import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import styled, { styled as styled$1, css } from 'styled-components';
import { makeAutoObservable, runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import gsap from 'gsap';
import { useMemo, useState, useRef, useCallback, useEffect } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { v4 } from 'uuid';
import { createPortal } from 'react-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneIcon from '@mui/icons-material/Done';
import { InfoOutlined } from '@mui/icons-material';
import { styled as styled$2, Tooltip as Tooltip$1, tooltipClasses } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';
import { createChart, CandlestickSeries, createTextWatermark } from 'lightweight-charts';
import zlib from 'browserify-zlib';
import { Buffer } from 'buffer';
import * as $protobuf from 'protobufjs/minimal';
import { useQuery } from '@tanstack/react-query';
import { toast, ToastContainer } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var ButtonStyled = styled.button(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n    padding: 20px;\n    border-radius: .5em;\n    min-width: 64px;\n\n    outline: none;\n    border: none;\n\n    &:hover {\n        cursor: pointer;\n        background-color: #4976c2!important;\n    }\n\n    user-select: none;\n\n    font-size: clamp(13px, 16px, 22px);\n    font-weight: 600;\n    font-style: normal;\n"], ["\n    padding: 20px;\n    border-radius: .5em;\n    min-width: 64px;\n\n    outline: none;\n    border: none;\n\n    &:hover {\n        cursor: pointer;\n        background-color: #4976c2!important;\n    }\n\n    user-select: none;\n\n    font-size: clamp(13px, 16px, 22px);\n    font-weight: 600;\n    font-style: normal;\n"])));
var templateObject_1$j;

var BASE_URL = "/";
var GREEN = "#0bba74";
var RED = "#ff4761";
var DARK_RED = "#d91f11";
var BLUE = "#3366cc";
var LIGHT_BLACK = "#252525";
var BLACK = "#131313";
var GREY = "#E4E4E4";
var DARK_GREY = "#303030";
var DARK_GREY2 = 'rgb(73, 72, 72)';
var GOLD = "#FFA800";
var WHITE = "#FFFFFF";
var HEADER_HEIGHT = '72px';
var MIN_INFO_WIDTH = '450px';
var SCROLL_WIDTH = '32px';
var AUTH_TOKEN = "authToken";
var REFRESH_TOKEN = "refreshToken";
var typeOptions = [
    { option: "futures", name: "Фьючерс-Фьючерс" },
    { option: "spot", name: "Спот-Фьючерс" },
    { option: "margin", name: "Фьючерс-Маржа" }
];
var shortExchanges = { "mexc": "mxc", "kucoin": "kuc", "gateio": "gat", "binance": "bin", "bybit": "byb", "coinex": "coi", "okx": "okx", "bitget": "btg", "bingx": "bgx", "bitmex": "btx", "huobi": "huo", "bitmart": "btm", 'xt': 'xt', 'lbank': 'lbk', 'hyper': 'hyp', 'ourbit': 'our', 'blofin': 'blf', 'phemex': 'phx', 'paradex': 'pdex', 'aster': 'astr', 'lighter': 'lgt', 'apex': 'apx', 'bitgetTf': 'btgTf', 'bybitTf': 'bybTf', 'gateioTf': "gatTf" };
var BAD_CONN_NOTIFICATIONS_KEY = "show-bad-conn-notifications";

var ThemeStore = /** @class */ (function () {
    function ThemeStore() {
        Object.defineProperty(this, "theme", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeAutoObservable(this);
        this.theme = localStorage.getItem('theme') || "light";
    }
    Object.defineProperty(ThemeStore.prototype, "textColor", {
        get: function () {
            if (this.theme === "dark") {
                return WHITE;
            }
            return BLACK;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "bgColor", {
        get: function () {
            if (this.theme === "dark") {
                return BLACK;
            }
            return WHITE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "greenColor", {
        get: function () {
            return GREEN;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "redColor", {
        get: function () {
            return RED;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "alternativeColor", {
        get: function () {
            if (this.theme === "dark") {
                return DARK_GREY;
            }
            return BLUE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "gridColor", {
        get: function () {
            if (this.theme === "dark") {
                return DARK_GREY;
            }
            return GREY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "btnModalColor", {
        get: function () {
            if (this.theme === "dark") {
                return DARK_GREY;
            }
            return DARK_GREY2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "dropdownColor", {
        get: function () {
            if (this.theme === "dark") {
                return LIGHT_BLACK;
            }
            return WHITE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "btnColor", {
        get: function () {
            if (this.theme === "dark") {
                return BLUE;
            }
            return BLACK;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeStore.prototype, "anotherTheme", {
        get: function () {
            if (this.theme === "dark") {
                return "light";
            }
            return "dark";
        },
        enumerable: false,
        configurable: true
    });
    return ThemeStore;
}());
var themeStore = new ThemeStore();

var Button = observer(function (_a) {
    var children = _a.children, onClick = _a.onClick, style = _a.style, className = _a.className, disabled = _a.disabled, args = __rest(_a, ["children", "onClick", "style", "className", "disabled"]);
    return (jsx(ButtonStyled, __assign({ onClick: onClick, style: __assign({ backgroundColor: disabled ? themeStore.bgColor : themeStore.btnColor, color: disabled ? themeStore.textColor : WHITE, pointerEvents: disabled ? "none" : "auto", border: disabled ? "1px solid ".concat(themeStore.textColor) : 'none' }, style), className: className, disabled: disabled }, args, { children: children })));
});

var DropdownStyled$1 = styled.div(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n    position: relative;\n    min-width: 64px;\n\n    button {\n        width: 100%;\n        position: relative;\n        padding: 12px 24px 12px 12px;\n        border-radius: 8px;\n\n        p {\n          font-size: 16px;\n        }\n\n        .arrow {\n            position: absolute;\n            right: 0;\n            top: 10px;\n        }\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n"], ["\n    position: relative;\n    min-width: 64px;\n\n    button {\n        width: 100%;\n        position: relative;\n        padding: 12px 24px 12px 12px;\n        border-radius: 8px;\n\n        p {\n          font-size: 16px;\n        }\n\n        .arrow {\n            position: absolute;\n            right: 0;\n            top: 10px;\n        }\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n"])));
var OptionsStyled = styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n    position: fixed;\n    overflow-y: auto;\n    flex-direction: column;\n    flex-wrap: wrap;\n\n\n    z-index: 1000;\n\n    p {\n        font-size: 16px;\n        padding: 8px 16px 8px 8px;\n        flex-grow: 1;\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n\n    box-shadow: 0 1px 1px ", ";\n\n"], ["\n    position: fixed;\n    overflow-y: auto;\n    flex-direction: column;\n    flex-wrap: wrap;\n\n\n    z-index: 1000;\n\n    p {\n        font-size: 16px;\n        padding: 8px 16px 8px 8px;\n        flex-grow: 1;\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n\n    box-shadow: 0 1px 1px ", ";\n\n"])), BLACK);
var templateObject_1$i, templateObject_2$6;

var Dropdown$1 = observer(function (_a) {
    var _b, _c, _d, _e;
    var value = _a.value, setValue = _a.setValue, options = _a.options, className = _a.className, disabled = _a.disabled, btnStyle = _a.btnStyle;
    var tl = useMemo(function () {
        return gsap.timeline();
    }, []);
    var _f = useState('none'), dropdownDisplay = _f[0], setDropdownDisplay = _f[1];
    var parentRef = useRef(null);
    var id = useMemo(function () {
        return "dropdown-".concat(v4());
    }, []);
    var onBtnClick = useCallback(function () {
        if (dropdownDisplay === "none") {
            setDropdownDisplay("flex");
            tl.to("#".concat(id), {
                duration: 0,
                rotate: 180
            });
        }
        else {
            setDropdownDisplay("none");
            tl.to("#".concat(id), {
                duration: 0,
                rotate: 0
            });
        }
    }, [id, dropdownDisplay]);
    var onOptionClick = useCallback(function (opt) {
        setValue(opt);
        setDropdownDisplay("none");
        tl.to("#".concat(id), {
            duration: 0,
            rotate: 0
        });
    }, [id]);
    var btnRef = useRef(null);
    var _g = useState(0), lastParentWidth = _g[0], setLastParentWidth = _g[1];
    useEffect(function () {
        var _a, _b, _c;
        if ((_a = parentRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) {
            setLastParentWidth(Math.max(parentRef.current.clientWidth, (_c = (_b = btnRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth) !== null && _c !== void 0 ? _c : 0));
        }
    }, [(_b = parentRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth, (_c = btnRef.current) === null || _c === void 0 ? void 0 : _c.clientWidth]);
    return (jsxs(DropdownStyled$1, __assign({ className: className }, { children: [jsxs("button", __assign({ style: __assign({ border: "1px solid ".concat(themeStore.textColor), pointerEvents: disabled ? "none" : "auto", userSelect: disabled ? "none" : "auto", backgroundColor: disabled ? themeStore.gridColor : themeStore.bgColor, color: disabled ? themeStore.gridColor : themeStore.textColor }, btnStyle), onClick: onBtnClick, ref: btnRef }, { children: [jsx("p", { children: value }), " ", jsx(ArrowDropDownIcon, { id: id, className: "arrow" })] })), jsx(OptionsStyled, __assign({ ref: parentRef, style: {
                    display: ((_d = btnRef.current) === null || _d === void 0 ? void 0 : _d.checkVisibility()) ? dropdownDisplay : "none",
                    top: (_e = btnRef.current) === null || _e === void 0 ? void 0 : _e.getBoundingClientRect().bottom
                } }, { children: options.map(function (opt) {
                    return jsx("p", __assign({ onClick: function () { onOptionClick(opt); }, style: {
                            backgroundColor: themeStore.dropdownColor,
                            color: themeStore.textColor,
                            width: 'fit-content',
                            minWidth: lastParentWidth,
                        }, onMouseOver: function (e) {
                            //@ts-ignore
                            e.target.style.backgroundColor = themeStore.gridColor;
                        }, onMouseLeave: function (e) {
                            //@ts-ignore
                            e.target.style.backgroundColor = themeStore.dropdownColor;
                        } }, { children: opt }), opt);
                }) }))] })));
});

var LoaderStyled = styled.div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n    img {\n        height: 100%;\n        width: 100%;\n    }\n\n    @keyframes rotate {\n        from {\n          rotate: 0;\n        }\n      \n        to {\n          rotate: 360deg;\n        }\n      }\n"], ["\n    img {\n        height: 100%;\n        width: 100%;\n    }\n\n    @keyframes rotate {\n        from {\n          rotate: 0;\n        }\n      \n        to {\n          rotate: 360deg;\n        }\n      }\n"])));
var templateObject_1$h;

var loader = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20200%20200%22%3E%3Ccircle%20fill%3D%22none%22%20stroke-opacity%3D%221%22%20stroke%3D%22%233366CC%22%20stroke-width%3D%22.5%22%20cx%3D%22100%22%20cy%3D%22100%22%20r%3D%220%22%3E%3Canimate%20attributeName%3D%22r%22%20calcMode%3D%22spline%22%20dur%3D%222%22%20values%3D%221%3B80%22%20keyTimes%3D%220%3B1%22%20keySplines%3D%220%20.2%20.5%201%22%20repeatCount%3D%22indefinite%22%3E%3C%2Fanimate%3E%3Canimate%20attributeName%3D%22stroke-width%22%20calcMode%3D%22spline%22%20dur%3D%222%22%20values%3D%220%3B25%22%20keyTimes%3D%220%3B1%22%20keySplines%3D%220%20.2%20.5%201%22%20repeatCount%3D%22indefinite%22%3E%3C%2Fanimate%3E%3Canimate%20attributeName%3D%22stroke-opacity%22%20calcMode%3D%22spline%22%20dur%3D%222%22%20values%3D%221%3B0%22%20keyTimes%3D%220%3B1%22%20keySplines%3D%220%20.2%20.5%201%22%20repeatCount%3D%22indefinite%22%3E%3C%2Fanimate%3E%3C%2Fcircle%3E%3C%2Fsvg%3E";

var Loader = observer(function (_a) {
    _a.size;
    return (jsx(LoaderStyled, { children: jsx("img", { src: loader }) }));
});

var ModalStyled = styled$1.div(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  width: 100vw;\n  z-index: 2000;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: rgba(0,0,0, .5);\n"], ["\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  width: 100vw;\n  z-index: 2000;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: rgba(0,0,0, .5);\n"])));
var templateObject_1$g;

var Modal = function (props) {
    var isOpen = props.isOpen, children = props.children, style = props.style;
    var display = useMemo(function () {
        return isOpen
            ? 'flex'
            : 'none';
    }, [isOpen]);
    return (createPortal(jsx(ModalStyled, __assign({ style: __assign({ display: display }, style) }, { children: children })), document.body));
};

var DropdownStyled = styled.div(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n    position: absolute;\n    width: 100%;\n    max-height: 200px;\n    top: 100%;\n\n    display: flex;\n    flex-direction: column;\n\n    border: none;\n    border-radius: 4px;\n    box-shadow: 0 1px 1px ", ";\n\n    overflow-y: auto;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n\n    z-index: 10;\n"], ["\n    position: absolute;\n    width: 100%;\n    max-height: 200px;\n    top: 100%;\n\n    display: flex;\n    flex-direction: column;\n\n    border: none;\n    border-radius: 4px;\n    box-shadow: 0 1px 1px ", ";\n\n    overflow-y: auto;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n\n    z-index: 10;\n"])), BLACK);
var templateObject_1$f;

var Dropdown = function (_a) {
    var children = _a.children, style = _a.style, onMouseOver = _a.onMouseOver, onMouseLeave = _a.onMouseLeave, onBlur = _a.onBlur;
    return (jsx(DropdownStyled, __assign({ style: style, onMouseOver: function () { return onMouseOver === null || onMouseOver === void 0 ? void 0 : onMouseOver(); }, onMouseLeave: onMouseLeave, onBlur: onBlur, onWheel: function (e) {
            e.stopPropagation();
        } }, { children: children })));
};

var SearchSelectStyled = styled.div(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n    position: relative;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin: 1em 0;\n\n    p.title {\n        position: absolute;\n        left: 0.35em;\n        top: -1.2em;\n        font-size: 12px;\n    }\n\n    input {\n        width: 100%;\n        padding: 12px;\n        outline: none;\n        border: 1px solid ", ";\n        border-radius: 8px;\n\n        &::-webkit-input-placeholder {\n            color: ", ";\n        }\n\n        ", "\n\n        font-size: clamp(12px,1.2vw,16px);\n\n        @media(max-width: 1100px) {\n            padding-left: 6px;\n        }\n    }\n\n    p.choice-funding {\n        position: absolute;\n        right: 25px;\n        pointer-events: none;\n    }\n\n    .dropdown-icon {\n        width: 25px;\n        position: absolute;\n        right: 0;\n        pointer-events: none;\n    }\n\n    div.option {\n        position: relative;\n        padding: 1em 5px 1em 1em;\n        width: 100%;\n        height: 2.5em;\n        // min-height: 25px;\n\n        @media(max-width: 1100px) {\n            padding-left: 6px;\n        }\n\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;;\n\n        &:hover {\n            cursor: pointer;\n        }\n\n        white-space: nowrap;\n        font-size: clamp(12px,1.4vw,16px);\n\n        span {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          gap: .5em;\n          width: 100%;\n          background-color: rgba(0,0,0,0) !important;\n        }\n\n        p {\n            background-color: inherit!important;\n            color: inherit!important;\n            pointer-events: none;\n            user-select: none;\n\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n\n        input {\n          justify-self: start;\n          width: fit-content;\n        }\n    }\n\n    p.funding {\n        width: fit-content;\n        font-family: monospace;\n        overflow: visible !important;\n    }\n"], ["\n    position: relative;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin: 1em 0;\n\n    p.title {\n        position: absolute;\n        left: 0.35em;\n        top: -1.2em;\n        font-size: 12px;\n    }\n\n    input {\n        width: 100%;\n        padding: 12px;\n        outline: none;\n        border: 1px solid ", ";\n        border-radius: 8px;\n\n        &::-webkit-input-placeholder {\n            color: ", ";\n        }\n\n        ", "\n\n        font-size: clamp(12px,1.2vw,16px);\n\n        @media(max-width: 1100px) {\n            padding-left: 6px;\n        }\n    }\n\n    p.choice-funding {\n        position: absolute;\n        right: 25px;\n        pointer-events: none;\n    }\n\n    .dropdown-icon {\n        width: 25px;\n        position: absolute;\n        right: 0;\n        pointer-events: none;\n    }\n\n    div.option {\n        position: relative;\n        padding: 1em 5px 1em 1em;\n        width: 100%;\n        height: 2.5em;\n        // min-height: 25px;\n\n        @media(max-width: 1100px) {\n            padding-left: 6px;\n        }\n\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;;\n\n        &:hover {\n            cursor: pointer;\n        }\n\n        white-space: nowrap;\n        font-size: clamp(12px,1.4vw,16px);\n\n        span {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          gap: .5em;\n          width: 100%;\n          background-color: rgba(0,0,0,0) !important;\n        }\n\n        p {\n            background-color: inherit!important;\n            color: inherit!important;\n            pointer-events: none;\n            user-select: none;\n\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n\n        input {\n          justify-self: start;\n          width: fit-content;\n        }\n    }\n\n    p.funding {\n        width: fit-content;\n        font-family: monospace;\n        overflow: visible !important;\n    }\n"])), BLACK, BLACK, function (props) { return props.$dark && css(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n            &::-webkit-input-placeholder {\n                color: ", ";\n            }\n        "], ["\n            &::-webkit-input-placeholder {\n                color: ", ";\n            }\n        "])), WHITE); });
var templateObject_1$e, templateObject_2$5;

var useDebounce = function (cb, deps, timeout) {
    var _a = useState(), timer = _a[0], setTimer = _a[1];
    useEffect(function () {
        clearTimeout(timer);
        setTimer(setTimeout(function () {
            cb();
        }, timeout || 500));
    }, deps);
};

var SearchSelect = observer(function (_a) {
    var title = _a.title, choice = _a.choice, setChoice = _a.setChoice, options = _a.options, className = _a.className, isDexFut = _a.isDexFut;
    var multiple = useMemo(function () {
        return Array.isArray(choice);
    }, [choice]);
    var placeHolder = useMemo(function () {
        if (!Array.isArray(choice)) {
            return (choice === null || choice === void 0 ? void 0 : choice.name) || "Не выбрано";
        }
        if (!choice.length) {
            return "Не выбрано";
        }
        if (choice.length <= 2) {
            return choice.map(function (ch) { return ch.name; }).join(', ');
        }
        return "\u0412\u044B\u0431\u0440\u0430\u043D\u043E: ".concat(choice.length);
    }, [choice]);
    var tl = useMemo(function () {
        return gsap.timeline();
    }, []);
    var _b = useState(""), search = _b[0], setSearch = _b[1];
    var _c = useState(options), filteredOptions = _c[0], setFilteredOptions = _c[1];
    var _d = useState("none"), display = _d[0], setDisplay = _d[1];
    var inputRef = useRef(null);
    useRef(null);
    var overDropdown = useRef(false);
    useDebounce(function () {
        setFilteredOptions(options === null || options === void 0 ? void 0 : options.filter(function (opt) { var _a, _b, _c, _d; return !isDexFut ? (_b = (_a = opt === null || opt === void 0 ? void 0 : opt.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.startsWith(search === null || search === void 0 ? void 0 : search.toLowerCase()) : (_d = (_c = opt === null || opt === void 0 ? void 0 : opt.name) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === null || _d === void 0 ? void 0 : _d.includes(search === null || search === void 0 ? void 0 : search.toLowerCase()); }));
    }, [search, options], 300);
    var onClickSingle = function (opt) {
        setChoice(opt);
        setSearch("");
        setDisplay("none");
        tl.to("#dropdown-icon-".concat(title), {
            duration: 0,
            rotate: 0
        });
    };
    var onClickMultiple = function (opt) {
        if (!Array.isArray(choice)) {
            return;
        }
        if (choice.find(function (val) { return val.option === opt.option; })) {
            setChoice(choice.filter(function (val) { return val.option !== opt.option; }));
        }
        else {
            setChoice(__spreadArray(__spreadArray([], choice, true), [opt], false));
        }
    };
    var onBlur = function () {
        var _a;
        if (!overDropdown.current) {
            setDisplay("none");
            setSearch("");
            tl.to("#dropdown-icon-".concat(title), {
                duration: 0,
                rotate: 0
            });
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
    };
    return (jsxs(SearchSelectStyled, __assign({ className: className, "$dark": themeStore.theme === "dark" }, { children: [jsx("p", __assign({ className: "title", style: { color: themeStore.textColor } }, { children: title })), jsx("input", { style: {
                    backgroundColor: themeStore.bgColor,
                    borderColor: themeStore.textColor,
                    color: themeStore.textColor,
                }, ref: inputRef, placeholder: placeHolder, type: "text", value: search, onChange: function (e) { return setSearch(e.target.value); }, onFocus: function () {
                    setDisplay("flex");
                    tl.to("#dropdown-icon-".concat(title), {
                        duration: 0,
                        rotate: 180
                    });
                }, onBlur: onBlur }), !Array.isArray(choice) && (choice === null || choice === void 0 ? void 0 : choice.funding) !== undefined && jsxs("p", __assign({ style: { color: themeStore.textColor }, className: "choice-funding funding" }, { children: [parseFloat(choice === null || choice === void 0 ? void 0 : choice.funding).toFixed(2), "%", (choice === null || choice === void 0 ? void 0 : choice.interval) !== undefined && " ".concat(choice.interval, "\u0447")] })), jsx(ArrowDropDownIcon, { style: { color: themeStore.textColor }, id: "dropdown-icon-".concat(title), className: "dropdown-icon" }), jsxs(Dropdown, __assign({ style: { display: display }, onMouseOver: function () {
                    overDropdown.current = true;
                }, onMouseLeave: function () {
                    overDropdown.current = false;
                }, onBlur: multiple ? onBlur : undefined }, { children: [filteredOptions.map(function (opt, i) {
                        return jsxs("div", __assign({ className: "option", style: { color: themeStore.textColor, backgroundColor: themeStore.dropdownColor }, onClick: function () {
                                var _a;
                                multiple ? onClickMultiple(opt) : onClickSingle(opt);
                                multiple && ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus());
                            }, onMouseOver: function (e) {
                                //@ts-ignore
                                e.target.style.backgroundColor = themeStore.gridColor;
                            }, onMouseLeave: function (e) {
                                //@ts-ignore
                                e.target.style.backgroundColor = themeStore.dropdownColor;
                            } }, { children: [jsxs("span", __assign({ style: { color: themeStore.textColor } }, { children: [multiple &&
                                            jsx("input", { name: "checked", type: "checkbox", readOnly: true, checked: !!choice.find(function (val) { return val.option === opt.option; }), style: {
                                                    accentColor: themeStore.textColor,
                                                    color: themeStore.dropdownColor
                                                } }), jsx("p", __assign({ className: "option" }, { children: opt.name }))] })), (opt === null || opt === void 0 ? void 0 : opt.funding) !== undefined &&
                                    jsxs("p", __assign({ className: "funding" }, { children: [parseFloat(opt === null || opt === void 0 ? void 0 : opt.funding).toFixed(2), "%", (opt === null || opt === void 0 ? void 0 : opt.interval) !== undefined && " ".concat(opt === null || opt === void 0 ? void 0 : opt.interval, "\u0447")] }))] }), JSON.stringify(opt.option));
                    }), filteredOptions.length === 0 &&
                        jsx("div", __assign({ className: "option", style: { color: themeStore.textColor, backgroundColor: themeStore.dropdownColor }, onClick: function () {
                                setDisplay("none");
                                tl.to("#dropdown-icon-".concat(title), {
                                    duration: 0,
                                    rotate: 0
                                });
                            } }, { children: jsx("p", __assign({ className: "option" }, { children: "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442" })) }))] }))] })));
});

var TextInputWrap = styled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n\n  p.label {\n    font-size: .75em;\n    margin-bottom: 4px;\n  }\n\n  p.tooltip {\n    font-size: .8em;\n    color: ", ";\n    margin-top: 2px;\n  }\n\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  /* for firefox */\n  input[type=number]{\n    -moz-appearance: textfield;\n  }\n"], ["\n  position: relative;\n  width: 100%;\n\n  p.label {\n    font-size: .75em;\n    margin-bottom: 4px;\n  }\n\n  p.tooltip {\n    font-size: .8em;\n    color: ", ";\n    margin-top: 2px;\n  }\n\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  /* for firefox */\n  input[type=number]{\n    -moz-appearance: textfield;\n  }\n"])), DARK_RED);
var TextInputStyled = styled.input(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  width: 100%;\n  padding: 6px;\n  border: 1px solid;\n  border-radius: 8px;\n\n  font-size: 1em;\n\n  &:focus {\n    outline: 1px solid ", ";\n    border-color: ", " !important;\n  }\n"], ["\n  width: 100%;\n  padding: 6px;\n  border: 1px solid;\n  border-radius: 8px;\n\n  font-size: 1em;\n\n  &:focus {\n    outline: 1px solid ", ";\n    border-color: ", " !important;\n  }\n"])), BLUE, BLUE);
var templateObject_1$d, templateObject_2$4;

function TextInput(props) {
    var _a;
    var hasError = props.hasError, label = props.label, tooltip = props.tooltip, value = props.value, setValue = props.setValue, wrapperClassName = props.wrapperClassName, type = props.type, disabled = props.disabled, originalOnClick = props.onClick, _b = props.size, size = _b === void 0 ? "lg" : _b, args = __rest(props, ["hasError", "label", "tooltip", "value", "setValue", "wrapperClassName", "type", "disabled", "onClick", "size"]);
    var inputRef = useRef(null);
    return (jsxs(TextInputWrap, __assign({ className: wrapperClassName }, { children: [label &&
                jsx("p", __assign({ className: "label", style: (_a = {},
                        _a[hasError ? "color" : ''] = DARK_RED,
                        _a) }, { children: label })), jsx(TextInputStyled, __assign({ type: type, ref: inputRef, style: {
                    borderColor: hasError ? DARK_RED : themeStore.gridColor,
                    backgroundColor: disabled ? themeStore.gridColor : themeStore.bgColor,
                    color: disabled ? themeStore.gridColor : themeStore.textColor,
                    pointerEvents: disabled ? "none" : "auto",
                    padding: size === "md" ? "6px" : "12px",
                    userSelect: disabled ? "none" : "auto",
                }, onClick: function (e) {
                    var _a;
                    if (disabled) {
                        return;
                    }
                    e.preventDefault();
                    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.select();
                    originalOnClick === null || originalOnClick === void 0 ? void 0 : originalOnClick(e);
                }, value: disabled ? '' : value, onChange: function (e) {
                    if (type === "number") {
                        var parsedValue = parseFloat(e.target.value);
                        if (Number.isNaN(parsedValue)) {
                            setValue(e.target.value);
                        }
                        else {
                            setValue(parsedValue);
                        }
                    }
                    else {
                        setValue(e.target.value);
                    }
                }, disabled: disabled }, args)), tooltip && jsx("p", __assign({ className: "tooltip" }, { children: tooltip }))] })));
}

var sunSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%3E%20%20%20%20%3Cpath%20d%3D%22M11.667%2017.625C14.6873%2017.625%2017.1357%2015.1066%2017.1357%2012C17.1357%208.8934%2014.6873%206.375%2011.667%206.375C8.64669%206.375%206.19824%208.8934%206.19824%2012C6.19824%2015.1066%208.64669%2017.625%2011.667%2017.625Z%22%20%20%20%20%20%20%20%20%20%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M11.667%203.375V1.5%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M5.73724%205.90102L4.44824%204.5752%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20%20%20%20%20%20%20%20%20%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M3.28092%2012H1.45801%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M5.73724%2018.0986L4.44824%2019.4245%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20%20%20%20%20%20%20%20%20%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M11.667%2020.625V22.5%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M17.5957%2018.0986L18.8847%2019.4245%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20%20%20%20%20%20%20%20%20%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M20.0518%2012H21.8747%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M17.5957%205.90102L18.8847%204.5752%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20%20%20%20%20%20%20%20%20%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var moonSvg = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M20.6949%2014.022C19.2491%2014.3631%2017.7427%2014.3209%2016.317%2013.8993C14.8914%2013.4777%2013.5932%2012.6905%2012.5443%2011.6116C11.4953%2010.5327%2010.73%209.19744%2010.3201%207.73105C9.91026%206.26467%209.86922%204.71522%2010.2009%203.22805L10.2008%203.22803C8.67855%203.5892%207.2781%204.3629%206.14479%205.4688C5.01148%206.5747%204.18664%207.97247%203.75591%209.517C3.32518%2011.0615%203.30426%2012.6965%203.69533%2014.2521C4.0864%2015.8078%204.87519%2017.2274%205.97982%2018.3636C7.08444%2019.4998%208.46462%2020.3111%209.97706%2020.7134C11.4895%2021.1156%2013.079%2021.0941%2014.5807%2020.6511C16.0823%2020.208%2017.4412%2019.3596%2018.5164%2018.1939C19.5916%2017.0283%2020.3438%2015.5878%2020.695%2014.0221L20.6949%2014.022Z%22%20stroke%3D%22white%22%20stroke-width%3D%221.2%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var ToggleStyled$1 = styled.img(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n    position: absolute;\n    left: auto;\n    right: 0;\n"], ["\n    position: absolute;\n    left: auto;\n    right: 0;\n"])));
var templateObject_1$c;

var Toggle$2 = observer(function () {
    var toggleImg = useMemo(function () {
        if (themeStore.theme === "dark") {
            return moonSvg;
        }
        return sunSvg;
    }, [themeStore.theme]);
    return (jsx(ToggleStyled$1, { id: "theme-toggle", src: toggleImg }));
});

var ThemePickerStyled$1 = styled.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n    position: relative;\n    height: 32px;\n    width: 56px;\n    border-radius: 16px;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    &:hover {\n        cursor: pointer;\n    }\n\n    user-select: none;\n    background-color: ", ";\n"], ["\n    position: relative;\n    height: 32px;\n    width: 56px;\n    border-radius: 16px;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    &:hover {\n        cursor: pointer;\n    }\n\n    user-select: none;\n    background-color: ", ";\n"])), GREY);
var templateObject_1$b;

var audioSrc = "data:audio/mpeg;base64,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";

var logoSvg = "data:image/svg+xml,%3Csvg%20width%3D%2268%22%20height%3D%2252%22%20viewBox%3D%220%200%2068%2052%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M42.8093%200.164978C41.9661%200.277575%2040.9313%200.450099%2040.5097%200.548486C38.4912%201.01895%2035.6323%202.17458%2035.7124%202.48765C35.737%202.58342%2036.4404%204.57572%2037.2754%206.91492L38.794%2011.1683L39.3082%2010.5948C40.0171%209.80444%2041.6659%208.96962%2043.2886%208.57993C44.9969%208.16955%2048.1944%208.13186%2049.9383%208.50163C52.979%209.14632%2054.8215%2011.0189%2055.6906%2014.3479C55.9382%2015.2962%2055.9989%2015.3906%2056.3617%2015.3929C56.5811%2015.3943%2058.8206%2015.3112%2061.3384%2015.2082L65.9163%2015.021L65.8111%2013.9314C65.4753%2010.4525%2064.2723%207.58371%2062.1896%205.29547C59.7808%202.64875%2056.783%201.13062%2052.3912%200.333023C50.4413%20-0.0209848%2044.9264%20-0.117827%2042.8093%200.164978ZM19.1797%202.37768C16.6017%209.07141%2014.2991%2015.0329%2012.0661%2020.7963C9.29536%2027.9475%207.60113%2032.3332%205.6222%2037.4773C5.0502%2038.9639%203.55128%2042.8397%202.29122%2046.0901L0%2052L5.15092%2051.9594L10.3017%2051.9188L13.7938%2042.7288C15.7145%2037.6743%2018.8771%2029.1252%2020.8219%2023.7309C22.7668%2018.3366%2024.4047%2013.8743%2024.4621%2013.8145C24.5192%2013.7549%2025.7318%2016.8826%2027.1563%2020.765C28.581%2024.6475%2031.818%2033.2626%2034.3498%2039.91L38.953%2051.996H43.1515C45.4607%2051.996%2047.3177%2051.9433%2047.2783%2051.8789C47.1974%2051.7472%2046.3965%2049.526%2040.275%2032.4576C33.4444%2013.4123%2029.3947%202.08144%2029.3947%202.01456C29.3947%201.98074%2027.1332%201.95294%2024.369%201.95294H19.3433L19.1797%202.37768ZM40.8929%2016.9944C40.8929%2017.1107%2045.1585%2028.852%2045.225%2028.919C45.2677%2028.962%2046.5007%2029.3078%2047.9653%2029.6874C54.1897%2031.301%2055.8648%2032.1431%2056.8464%2034.1521C57.2927%2035.0652%2057.3254%2035.2385%2057.2749%2036.4284C57.2297%2037.4986%2057.1376%2037.8854%2056.7301%2038.7167C55.8248%2040.5625%2053.8055%2042.1556%2051.7364%2042.6563C51.1269%2042.8038%2050.5481%2042.9674%2050.4505%2043.0197C50.3283%2043.0851%2050.72%2044.3711%2051.7029%2047.1307L53.1329%2051.1465L53.6436%2051.1051C54.5104%2051.0347%2056.6132%2050.4586%2057.9894%2049.9143C62.3261%2048.199%2065.577%2044.5504%2066.8412%2039.9792C67.1241%2038.9568%2067.1696%2038.3895%2067.1665%2035.9328C67.1633%2033.4788%2067.1153%2032.901%2066.8268%2031.8398C65.7184%2027.7623%2063.077%2024.6831%2059.0618%2022.7875C57.1173%2021.8695%2053.6941%2020.7702%2049.2484%2019.6364C45.2848%2018.6253%2043.2358%2017.994%2041.6978%2017.31C41.2552%2017.113%2040.8929%2016.9711%2040.8929%2016.9944ZM21.076%2042.0184C19.1586%2047.3069%2017.5898%2051.6806%2017.5898%2051.7377C17.5898%2051.7949%2020.7538%2051.8415%2024.6209%2051.8415H31.652L30.6878%2049.1772C27.3349%2039.9117%2024.6259%2032.467%2024.5965%2032.4373C24.5777%2032.4185%2022.9935%2036.7299%2021.076%2042.0184Z%22%20fill%3D%22%233366CC%22%2F%3E%3C%2Fsvg%3E";

dayjs.extend(utc);
function getFormatedLocalTime(date) {
    var transformedDate = dayjs.utc(date);
    return +transformedDate - new Date().getTimezoneOffset() * 60 * 1e3;
}
var audio = new Audio(audioSrc);
var getNotificationPermission = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (Notification.permission === 'granted') {
                    return [2 /*return*/, true];
                }
                if (Notification.permission === 'denied') {
                    return [2 /*return*/, false];
                }
                return [4 /*yield*/, Notification.requestPermission()];
            case 1: return [2 /*return*/, (_a.sent()) === 'granted'];
        }
    });
}); };
var showNotification = function (_a) {
    var title = _a.title, body = _a.body;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getNotificationPermission()];
                case 1:
                    if (!_b.sent()) return [3 /*break*/, 3];
                    new Notification(title, { body: body, icon: logoSvg });
                    return [4 /*yield*/, audio.play()];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
};
function wait(ms) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, new Promise(function (res) { return setTimeout(res, ms); })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}

var UserStore = /** @class */ (function () {
    function UserStore() {
        Object.defineProperty(this, "_isAuth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_baseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_outerBaseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_socketBaseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeAutoObservable(this);
        this._isAuth = true;
        this._baseUrl = '';
        this._outerBaseUrl = '';
        this._socketBaseUrl = '';
    }
    Object.defineProperty(UserStore.prototype, "getBaseUrl", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var count;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            count = 0;
                            _a.label = 1;
                        case 1:
                            if (!(!this._baseUrl && count < 50)) return [3 /*break*/, 3];
                            count++;
                            return [4 /*yield*/, wait(50)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 1];
                        case 3:
                            if (!this._baseUrl) {
                                throw new Error("UserStore.baseUrl in not defined. Define it in your root app.");
                            }
                            return [2 /*return*/, this._baseUrl];
                    }
                });
            });
        }
    });
    Object.defineProperty(UserStore.prototype, "getOuterBaseUrl", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var count;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            count = 0;
                            _a.label = 1;
                        case 1:
                            if (!(!this._outerBaseUrl && count < 50)) return [3 /*break*/, 3];
                            count++;
                            return [4 /*yield*/, wait(50)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 1];
                        case 3:
                            if (!this._outerBaseUrl) {
                                throw new Error("UserStore.baseUrl in not defined. Define it in your root app.");
                            }
                            return [2 /*return*/, this._outerBaseUrl];
                    }
                });
            });
        }
    });
    Object.defineProperty(UserStore.prototype, "getSocketBaseUrl", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var count;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            count = 0;
                            _a.label = 1;
                        case 1:
                            if (!(!this._socketBaseUrl && count < 50)) return [3 /*break*/, 3];
                            count++;
                            return [4 /*yield*/, wait(50)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 1];
                        case 3:
                            if (!this._socketBaseUrl) {
                                throw new Error("UserStore.socketBaseUrl in not defined. Define it in your root app.");
                            }
                            return [2 /*return*/, this._socketBaseUrl];
                    }
                });
            });
        }
    });
    Object.defineProperty(UserStore.prototype, "setBaseUrls", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            this._baseUrl = options.base;
            this._outerBaseUrl = options.outer;
            this._socketBaseUrl = options.socket;
        }
    });
    Object.defineProperty(UserStore.prototype, "isAuth", {
        get: function () {
            return this._isAuth;
        },
        set: function (val) {
            this._isAuth = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserStore.prototype, "authToken", {
        get: function () {
            return localStorage.getItem(AUTH_TOKEN);
        },
        set: function (val) {
            localStorage.setItem(AUTH_TOKEN, val || '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserStore.prototype, "refreshToken", {
        get: function () {
            return localStorage.getItem(REFRESH_TOKEN);
        },
        set: function (val) {
            localStorage.setItem(REFRESH_TOKEN, val || '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserStore.prototype, "loadDefaultOptions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (query) {
            query = query.slice(1);
            var pairs = query.split('&');
            for (var _i = 0, pairs_1 = pairs; _i < pairs_1.length; _i++) {
                var pair = pairs_1[_i];
                var _a = pair.split('='); _a[0]; _a[1];
            }
            this.authToken = localStorage.getItem(AUTH_TOKEN);
            this.refreshToken = localStorage.getItem(REFRESH_TOKEN);
        }
    });
    return UserStore;
}());
var userStore = new UserStore();

function getHeaders() {
    return __awaiter(this, void 0, void 0, function () {
        var authToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!localStorage) return [3 /*break*/, 2];
                    return [4 /*yield*/, new Promise(function (res) { return setTimeout(res, 50); })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 0];
                case 2:
                    authToken = localStorage.getItem(AUTH_TOKEN) || '';
                    return [2 /*return*/, {
                            "Authorization": authToken,
                            "Content-Type": "application/json",
                        }];
            }
        });
    });
}
var isRefreshRunning = false;
function withRetry(req) {
    return __awaiter(this, void 0, void 0, function () {
        var res, e_1;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 9]);
                    return [4 /*yield*/, req()];
                case 1:
                    res = _b.sent();
                    if (res.status === 401) {
                        throw 401;
                    }
                    return [3 /*break*/, 9];
                case 2:
                    e_1 = _b.sent();
                    if (e_1 !== 401) {
                        throw e_1;
                    }
                    if (!isRefreshRunning) {
                        isRefreshRunning = true;
                        setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, refreshToken()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, 0);
                    }
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 5, , 7]);
                    return [4 /*yield*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                            var times;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        times = 0;
                                        _a.label = 1;
                                    case 1:
                                        if (!(isRefreshRunning && times < 50)) return [3 /*break*/, 3];
                                        return [4 /*yield*/, new Promise(function (res) { return setTimeout(res, 100); })];
                                    case 2:
                                        _a.sent();
                                        times++;
                                        return [3 /*break*/, 1];
                                    case 3:
                                        if (times < 50) {
                                            resolve(true);
                                        }
                                        else {
                                            reject();
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 4:
                    _b.sent();
                    return [3 /*break*/, 7];
                case 5:
                    _b.sent();
                    return [4 /*yield*/, refreshToken()];
                case 6:
                    _b.sent();
                    return [3 /*break*/, 7];
                case 7: return [4 /*yield*/, req()];
                case 8:
                    res = _b.sent();
                    if (res.status === 401) {
                        userStore.isAuth = false;
                        throw new Error();
                    }
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/, res];
            }
        });
    });
}
function refreshToken() {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, refreshRes, _a, _b, _c, refresh_token, access_token;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    isRefreshRunning = true;
                    return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _e.sent();
                    _a = fetch;
                    _b = ["".concat(baseUrl, "/refresh")];
                    _d = {
                        method: "POST"
                    };
                    return [4 /*yield*/, getHeaders()];
                case 2: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_d.headers = _e.sent(),
                            _d.body = JSON.stringify({ refresh_token: localStorage.getItem(REFRESH_TOKEN) }),
                            _d)]))];
                case 3:
                    refreshRes = _e.sent();
                    return [4 /*yield*/, refreshRes.json()];
                case 4:
                    _c = _e.sent(), refresh_token = _c.refresh_token, access_token = _c.access_token;
                    localStorage.setItem(AUTH_TOKEN, access_token);
                    localStorage.setItem(REFRESH_TOKEN, refresh_token);
                    isRefreshRunning = false;
                    return [2 /*return*/];
            }
        });
    });
}

function getExchanges() {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, response, json, err_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, withRetry(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b;
                            var _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        _a = fetch;
                                        _b = ["".concat(baseUrl, "/exchanges")];
                                        _c = {};
                                        return [4 /*yield*/, getHeaders()];
                                    case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_c.headers = _d.sent(),
                                                _c)]))];
                                    case 2: return [2 /*return*/, _d.sent()];
                                }
                            });
                        }); })];
                case 3:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 4:
                    json = _a.sent();
                    return [2 /*return*/, json.markets];
                case 5:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [2 /*return*/, []];
                case 6: return [2 /*return*/];
            }
        });
    });
}

var ExchangesStore = /** @class */ (function () {
    function ExchangesStore() {
        Object.defineProperty(this, "_data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeAutoObservable(this);
        this._data = [];
    }
    Object.defineProperty(ExchangesStore.prototype, "load", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var exchanges;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getExchanges()];
                        case 1:
                            exchanges = _a.sent();
                            runInAction(function () {
                                _this._data = exchanges;
                            });
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ExchangesStore.prototype, "data", {
        get: function () {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExchangesStore.prototype, "getNameByMarket", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (market) {
            var _a, _b;
            if (!market) {
                return '';
            }
            return (_b = (_a = this._data) === null || _a === void 0 ? void 0 : _a.filter(function (ex) { return ex.market === market; })[0]) === null || _b === void 0 ? void 0 : _b.name;
        }
    });
    return ExchangesStore;
}());
var exchangesStore = new ExchangesStore();

var MobileStore = /** @class */ (function () {
    function MobileStore() {
        Object.defineProperty(this, "isMobile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "chartMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeAutoObservable(this);
        this.chartMode = "chart";
    }
    Object.defineProperty(MobileStore.prototype, "changeChartMode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this.chartMode === "chart") {
                this.chartMode = "info";
            }
            else {
                this.chartMode = "chart";
            }
        }
    });
    Object.defineProperty(MobileStore.prototype, "isChartVisible", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (window.innerWidth > 2 * parseInt(MIN_INFO_WIDTH) || !this.chartMode) {
                return true;
            }
            return this.chartMode === "chart";
        }
    });
    Object.defineProperty(MobileStore.prototype, "isInfoVisible", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (window.innerWidth > 2 * parseInt(MIN_INFO_WIDTH) || !this.chartMode) {
                return true;
            }
            return this.chartMode === "info";
        }
    });
    Object.defineProperty(MobileStore.prototype, "isOrdersVisible", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return window.innerWidth > 2 * parseInt(MIN_INFO_WIDTH);
        }
    });
    return MobileStore;
}());
var mobileStore = new MobileStore();

var ChartStore = /** @class */ (function () {
    function ChartStore() {
        Object.defineProperty(this, "_fetchSpreadInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getEnterSpread", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasConnectionError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "_timeFrames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                { value: 5, title: '5м' },
                { value: 15, title: '15м' },
                { value: 60, title: '1ч' },
                { value: 240, title: '4ч' },
            ]
        });
        makeAutoObservable(this);
        this._fetchSpreadInfo = function () { throw new Error("CharStore.fetchEnterSpread in not defined, define it in your root app."); };
        this.getEnterSpread = function () { throw new Error("CharStore.getEnterSpread in not defined, define it in your root app."); };
    }
    Object.defineProperty(ChartStore.prototype, "getSpreadInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this._fetchSpreadInfo(data)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        }
    });
    Object.defineProperty(ChartStore.prototype, "fetchSpreadInfo", {
        set: function (fn) {
            this._fetchSpreadInfo = fn;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChartStore.prototype, "timeFrames", {
        get: function () {
            return this._timeFrames;
        },
        set: function (value) {
            this._timeFrames = value;
        },
        enumerable: false,
        configurable: true
    });
    return ChartStore;
}());
var chartStore = new ChartStore();

var ThemePicker = observer(function () {
    var changePosition = useCallback(function () {
        var tl = gsap.timeline();
        if (themeStore.theme === "light") {
            tl.to("#theme-toggle", {
                duration: .1,
                right: 0,
                left: 'auto',
            });
        }
        if (themeStore.theme === "dark") {
            tl.to("#theme-toggle", {
                duration: .1,
                left: 0,
                right: 'auto,'
            });
        }
    }, [themeStore.theme]);
    return (jsx(ThemePickerStyled$1, __assign({ onClick: function () {
            themeStore.theme = themeStore.anotherTheme;
            localStorage.setItem('theme', themeStore.theme);
            changePosition();
        }, style: { backgroundColor: themeStore.alternativeColor } }, { children: jsx(Toggle$2, {}) })));
});

var LogoStyled = styled.div(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n    position: relative;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    gap: 11px;\n\n    img {\n        height: 100%;\n    }\n\n    h1 {\n        font-family: sans-serif;\n        font-size : 14px;\n        line-height: 110%;\n        font-weight: normal;\n\n        @media(max-width: 720px) {\n            font-size : 10px;\n        }\n\n    }\n"], ["\n    position: relative;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    gap: 11px;\n\n    img {\n        height: 100%;\n    }\n\n    h1 {\n        font-family: sans-serif;\n        font-size : 14px;\n        line-height: 110%;\n        font-weight: normal;\n\n        @media(max-width: 720px) {\n            font-size : 10px;\n        }\n\n    }\n"])));
var templateObject_1$a;

var Logo = observer(function () {
    return (jsxs(LogoStyled, { children: [jsx("img", { src: logoSvg }), jsx("h1", __assign({ style: { color: themeStore.textColor } }, { children: "Arbitrage Services" }))] }));
});

var StringContainerStyled = styled.div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n    position: relative;\n    width: fit-content !important;\n    padding: 6px 24px 6px 6px !important;\n    border-radius: 8px !important;\n    user-select: none;\n\n    display: flex !important;\n    flex-direction: row !important;\n    justify-content: start !important;\n    align-items: center !important;\n\n    overflow: hidden;\n    \n    &:hover {\n        cursor: pointer;\n    }\n\n    &:active {\n        outline: 1px solid #b7b7b7;\n    }\n\n    .title {\n        position: absolute;\n        top: -1.5em;\n        left: 0;\n        font-size: inherit;\n    }\n\n    p {\n        font-family: \"Proxima Nova\", sans-serif;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-wrap: nowrap;\n        height: auto !important;\n        font-size: .8em;\n    }\n\n    .copy {\n        height: .8em;\n        width: .8em;\n        position: absolute;\n        right: 2px;\n        z-index: 2;\n    }\n\n    .done {\n        height: .6em;\n        width: .6em;\n        position: absolute;\n        right: 2px;\n        z-index: 2;\n    }\n"], ["\n    position: relative;\n    width: fit-content !important;\n    padding: 6px 24px 6px 6px !important;\n    border-radius: 8px !important;\n    user-select: none;\n\n    display: flex !important;\n    flex-direction: row !important;\n    justify-content: start !important;\n    align-items: center !important;\n\n    overflow: hidden;\n    \n    &:hover {\n        cursor: pointer;\n    }\n\n    &:active {\n        outline: 1px solid #b7b7b7;\n    }\n\n    .title {\n        position: absolute;\n        top: -1.5em;\n        left: 0;\n        font-size: inherit;\n    }\n\n    p {\n        font-family: \"Proxima Nova\", sans-serif;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-wrap: nowrap;\n        height: auto !important;\n        font-size: .8em;\n    }\n\n    .copy {\n        height: .8em;\n        width: .8em;\n        position: absolute;\n        right: 2px;\n        z-index: 2;\n    }\n\n    .done {\n        height: .6em;\n        width: .6em;\n        position: absolute;\n        right: 2px;\n        z-index: 2;\n    }\n"])));
var templateObject_1$9;

var StringContainer = function (_a) {
    var content = _a.content, allowCopy = _a.allowCopy, className = _a.className, style = _a.style, short = _a.short;
    var _b = useState(false), isCopied = _b[0], setIsCopied = _b[1];
    if (!content) {
        return jsx(Fragment, {});
    }
    return (jsxs(StringContainerStyled, __assign({ className: className, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (allowCopy) {
                    navigator.clipboard.writeText(content).then(function () {
                        setIsCopied(true);
                    });
                }
                return [2 /*return*/];
            });
        }); }, style: __assign({ pointerEvents: allowCopy ? 'inherit' : 'none', border: "1px solid ".concat(themeStore.textColor) }, style) }, { children: [jsx("p", __assign({ className: "text2" }, { children: short ? "".concat(content.substring(0, 4), "...").concat(content.substring(content.length - 4)) : content })), allowCopy && jsx(ContentCopyIcon, { className: "copy" }), allowCopy && isCopied && jsx(DoneIcon, { className: "done" })] })));
};

var ToggleStyled = styled.div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n    position: absolute;\n    left: auto;\n    right: 0;\n"], ["\n    position: absolute;\n    left: auto;\n    right: 0;\n"])));
var templateObject_1$8;

var Toggle$1 = observer(function (props) {
    var comp = props.comp, id = props.id;
    return (jsx(ToggleStyled, __assign({ id: id }, { children: comp })));
});

var ThemePickerStyled = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n    position: relative;\n    height: 32px;\n    width: 56px;\n    border-radius: 16px;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    &:hover {\n        cursor: pointer;\n    }\n\n    user-select: none;\n    background-color: ", ";\n"], ["\n    position: relative;\n    height: 32px;\n    width: 56px;\n    border-radius: 16px;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    &:hover {\n        cursor: pointer;\n    }\n\n    user-select: none;\n    background-color: ", ";\n"])), GREY);
var templateObject_1$7;

var Toggle = observer(function (props) {
    var id = props.id, onComponent = props.onComponent, offComponent = props.offComponent, value = props.value, setValue = props.setValue, disabled = props.disabled;
    useEffect(function () {
        var tl = gsap.timeline();
        if (value) {
            tl.to("#".concat(id), {
                duration: 0,
                right: '8px',
                left: 'auto',
            });
        }
        if (!value) {
            tl.to("#".concat(id), {
                duration: 0,
                left: '8px',
                right: 'auto,'
            });
        }
    }, [value]);
    var component = value ? onComponent : offComponent;
    return (jsx(ThemePickerStyled, __assign({ onClick: function () {
            if (disabled) {
                return;
            }
            setValue(function (val) { return !val; });
        }, style: {
            backgroundColor: value ? BLUE : themeStore.gridColor,
            color: themeStore.theme === "dark" ? WHITE : (value ? WHITE : BLACK),
        } }, { children: jsx(Toggle$1, { comp: component, id: id }) })));
});

var CheckboxStyled = styled.input(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  width: 1.5em;\n  height: 1.5em;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &:checked::before {\n    content: \"\u2713\";\n    font-size: 1.5em;\n    display: block;\n    text-align: center;\n  }\n"], ["\n  width: 1.5em;\n  height: 1.5em;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &:checked::before {\n    content: \"\u2713\";\n    font-size: 1.5em;\n    display: block;\n    text-align: center;\n  }\n"])));
var templateObject_1$6;

var Checkbox = observer(function (props) {
    var value = props.value, setValue = props.setValue;
    return (jsx(CheckboxStyled, { type: "checkbox", checked: value, onChange: function (e) { return setValue(e.target.checked); }, style: {
            backgroundColor: value ? themeStore.btnColor : themeStore.bgColor,
            background: value ? themeStore.btnColor : themeStore.bgColor,
            color: value ? WHITE : themeStore.bgColor,
            fill: value ? WHITE : themeStore.bgColor,
            accentColor: value ? themeStore.btnColor : themeStore.bgColor,
            border: "1px solid ".concat(themeStore.gridColor)
        } }));
});

var LightTooltip = styled$2(function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (jsx(Tooltip$1, __assign({}, props, { classes: { popper: className } })));
})(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(tooltipClasses.tooltip)] = {
            backgroundColor: theme.palette.common.white,
            color: 'rgba(0, 0, 0, 0.87)',
            boxShadow: theme.shadows[1],
            fontSize: 11,
        },
        _b);
});
var BootstrapTooltip = styled$2(function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (jsx(Tooltip$1, __assign({}, props, { arrow: true, classes: { popper: className } })));
})(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(tooltipClasses.arrow)] = {
            color: theme.palette.common.black,
        },
        _b["& .".concat(tooltipClasses.tooltip)] = {
            backgroundColor: theme.palette.common.black,
        },
        _b);
});
var Tooltip = observer(function (props) {
    var title = props.title;
    var TooltipComponent = themeStore.theme === "dark" ? BootstrapTooltip : LightTooltip;
    return (jsx(TooltipComponent, __assign({ title: title }, { children: jsx(InfoOutlined, { style: {
                fill: BLUE,
                marginLeft: '4px',
            } }) })));
});

var AuthFormStyled = styled.form(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  position: relative;\n  padding: 64px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n\n  width: 750px;\n  height: 550px;\n  max-width: 100%;\n  max-height: 100%;\n  margin: 32px;\n  border-radius: 32px;\n\n  h1 {\n    position: absolute;\n    top: 16px;\n    text-align: center;\n  }\n\n  & > * {\n    width: 100%;\n    max-width: 350px;\n  }\n\n  button {\n    margin-top: 32px;\n  }\n"], ["\n  position: relative;\n  padding: 64px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n\n  width: 750px;\n  height: 550px;\n  max-width: 100%;\n  max-height: 100%;\n  margin: 32px;\n  border-radius: 32px;\n\n  h1 {\n    position: absolute;\n    top: 16px;\n    text-align: center;\n  }\n\n  & > * {\n    width: 100%;\n    max-width: 350px;\n  }\n\n  button {\n    margin-top: 32px;\n  }\n"])));
var NotFoundWrap = styled.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  width: 100%;\n  background-color: #ffe0de;\n  color: #d91f11;\n  padding: 19px 23px;\n  margin-bottom: 20px;\n  border-radius: 12px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: center;\n\n  p {\n    text-align: start;\n  }\n"], ["\n  width: 100%;\n  background-color: #ffe0de;\n  color: #d91f11;\n  padding: 19px 23px;\n  margin-bottom: 20px;\n  border-radius: 12px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: center;\n\n  p {\n    text-align: start;\n  }\n"])));
var templateObject_1$5, templateObject_2$3;

function signIn(options) {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, res, _a, access_token, refresh_token;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _b.sent();
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/login"), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(options)
                        })];
                case 2:
                    res = _b.sent();
                    if (res.status !== 200) {
                        userStore.isAuth = false;
                        throw new Error();
                    }
                    return [4 /*yield*/, res.json()];
                case 3:
                    _a = _b.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token;
                    localStorage.setItem(AUTH_TOKEN, access_token);
                    localStorage.setItem(REFRESH_TOKEN, refresh_token);
                    userStore.isAuth = true;
                    return [2 /*return*/];
            }
        });
    });
}

var AuthForm = function (props) {
    var isOpen = props.isOpen;
    var _a = useState(''), email = _a[0], setEmail = _a[1];
    var _b = useState(''), password = _b[0], setPassword = _b[1];
    var _c = useState(false), notFound = _c[0], setNotFound = _c[1];
    var _d = useState(''), emailTooltip = _d[0], setEmailTooltip = _d[1];
    var _e = useState(''), passwordTooltip = _e[0], setPasswordTooltip = _e[1];
    useEffect(function () {
        if (emailTooltip && email) {
            setEmailTooltip('');
        }
    }, [email]);
    useEffect(function () {
        if (passwordTooltip && password) {
            setPasswordTooltip('');
        }
    }, [password]);
    useEffect(function () {
        setNotFound(false);
    }, [email, password]);
    return (jsx(Modal, __assign({ isOpen: isOpen }, { children: jsxs(AuthFormStyled, __assign({ style: {
                backgroundColor: themeStore.bgColor,
                color: themeStore.textColor,
            } }, { children: [jsx("h1", __assign({ style: {
                        color: BLUE
                    } }, { children: "\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F" })), notFound &&
                    jsx(NotFoundWrap, { children: jsx("p", { children: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D" }) }), jsx(TextInput, { hasError: emailTooltip || notFound ? true : false, label: "E-mail", tooltip: emailTooltip, value: email, setValue: setEmail, placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 e-mail", autoComplete: "email", name: "email", type: "email", size: "lg" }), jsx(TextInput, { hasError: passwordTooltip || notFound ? true : false, label: "\u041F\u0430\u0440\u043E\u043B\u044C", tooltip: passwordTooltip, value: password, setValue: setPassword, placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C", autoComplete: "current-password", name: "password", type: "password", size: "lg" }), jsx(Button, __assign({ onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                        var hasError;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    e.preventDefault();
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 3, , 4]);
                                    hasError = false;
                                    if (!email) {
                                        setEmailTooltip("Данное поле является обязательным");
                                        hasError = true;
                                    }
                                    if (!password) {
                                        setPasswordTooltip("Данное поле является обязательным");
                                        hasError = true;
                                    }
                                    if (hasError) {
                                        return [2 /*return*/];
                                    }
                                    return [4 /*yield*/, signIn({ email: email, password: password })];
                                case 2:
                                    _b.sent();
                                    setEmail('');
                                    setPassword('');
                                    setNotFound(false);
                                    return [3 /*break*/, 4];
                                case 3:
                                    _b.sent();
                                    setNotFound(true);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); } }, { children: jsx("p", { children: "\u0412\u043E\u0439\u0442\u0438" }) }))] })) })));
};

var HeaderStyled = styled.header(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n    position: fixed;\n    z-index: 1002;\n    left: 0;\n    top: 0;\n\n    height: ", ";\n    width: 100%;\n    padding: 10px 2em 10px 2em;\n\n    background-color: ", ";\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n"], ["\n    position: fixed;\n    z-index: 1002;\n    left: 0;\n    top: 0;\n\n    height: ", ";\n    width: 100%;\n    padding: 10px 2em 10px 2em;\n\n    background-color: ", ";\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n"])), HEADER_HEIGHT, BLACK);
var TailStyled = styled.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 24px;\n"], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 24px;\n"])));
var templateObject_1$4, templateObject_2$2;

var NotificationsPicker = observer(function () {
    var _a;
    var _b = useState(((_a = localStorage.getItem(BAD_CONN_NOTIFICATIONS_KEY)) !== null && _a !== void 0 ? _a : "true") === "true"), val = _b[0], setVal = _b[1];
    var prevVal = useRef(val);
    var _c = useState(false), showModal = _c[0], setShowModal = _c[1];
    useEffect(function () {
        if (val === prevVal.current) {
            return;
        }
        setShowModal(true);
    }, [val]);
    var onCancel = function () {
        setVal(function (val) { return !val; });
        setShowModal(false);
    };
    var onSubmit = function () {
        localStorage.setItem(BAD_CONN_NOTIFICATIONS_KEY, "".concat(val));
        prevVal.current = val;
        setShowModal(false);
    };
    var modalTitle = useMemo(function () {
        var action = val ? "Включить" : "Выключить";
        return "".concat(action, " \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043E \u043F\u043B\u043E\u0445\u043E\u043C \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0438 \u0441 \u0431\u0438\u0440\u0436\u0435\u0439?");
    }, [val]);
    return (jsxs(Fragment, { children: [jsx(Toggle, { id: "notifications-toggle", onComponent: jsx(NotificationsIcon, {}), offComponent: jsx(NotificationsOffIcon, {}), value: val, setValue: setVal, disabled: showModal }), jsx(Modal, __assign({ isOpen: showModal }, { children: jsxs("div", __assign({ style: {
                        backgroundColor: themeStore.bgColor,
                        color: themeStore.textColor,
                        margin: '1em',
                        padding: '7em 2em 2em 2em',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '2em',
                        border: "1px solid ".concat(themeStore.textColor),
                        borderRadius: '12px',
                    } }, { children: [jsx("p", __assign({ style: { textAlign: 'center' } }, { children: modalTitle })), jsxs("div", __assign({ style: {
                                display: 'flex',
                                justifyContent: 'space-around',
                                width: '100%'
                            } }, { children: [jsx(Button, __assign({ style: {
                                        backgroundColor: themeStore.btnModalColor,
                                        width: '100px'
                                    }, onClick: onCancel }, { children: "\u041D\u0435\u0442" })), jsx(Button, __assign({ style: { width: '100px' }, onClick: onSubmit }, { children: "\u0414\u0430" }))] }))] })) }))] }));
});

var Header = observer(function (props) {
    var showNotificationsPicker = props.showNotificationsPicker;
    return (jsxs(HeaderStyled, __assign({ style: {
            backgroundColor: themeStore.bgColor,
            borderBottom: "1px solid ".concat(themeStore.textColor)
        } }, { children: [jsx(Logo, {}), jsxs(TailStyled, { children: [showNotificationsPicker && jsx(NotificationsPicker, {}), jsx(ThemePicker, {})] })] })));
});

var GraphStyled = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    width: 100%;\n    height: calc(100vh - ", " - 20px);\n    \n    display: flex;\n    flex-direction: row;\n"], ["\n    position: relative;\n    display: flex;\n    width: 100%;\n    height: calc(100vh - ", " - 20px);\n    \n    display: flex;\n    flex-direction: row;\n"])), HEADER_HEIGHT);
var GraphContainer = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n    position: relative;\n    width: calc(100% * 2 / 3);\n    max-width: calc(100% - ", ");\n    min-width: ", ";\n    height: 100%;\n\n    overflow-x: auto;\n\n    @media(max-width: calc(2*", ")) {\n        height: calc(100% - 10px);\n        margin-bottom: ", ";\n        width: 100%;\n        min-width: 100%;\n    }\n"], ["\n    position: relative;\n    width: calc(100% * 2 / 3);\n    max-width: calc(100% - ", ");\n    min-width: ", ";\n    height: 100%;\n\n    overflow-x: auto;\n\n    @media(max-width: calc(2*", ")) {\n        height: calc(100% - 10px);\n        margin-bottom: ", ";\n        width: 100%;\n        min-width: 100%;\n    }\n"])), MIN_INFO_WIDTH, MIN_INFO_WIDTH, MIN_INFO_WIDTH, SCROLL_WIDTH);
var InfoContainer = styled.div(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n    position: relative;\n    width: calc(100% / 3);\n    min-width: ", ";\n    height: 100%;\n    min-height: calc(750px - ", ");\n\n    display: flex;\n    flex-direction: column;\n\n    @media(max-width: calc(2*", ")) {\n      width: 100%;\n      min-width: 100%;\n    }\n"], ["\n    position: relative;\n    width: calc(100% / 3);\n    min-width: ", ";\n    height: 100%;\n    min-height: calc(750px - ", ");\n\n    display: flex;\n    flex-direction: column;\n\n    @media(max-width: calc(2*", ")) {\n      width: 100%;\n      min-width: 100%;\n    }\n"])), MIN_INFO_WIDTH, HEADER_HEIGHT, MIN_INFO_WIDTH);
var TimeFrameStyled = styled.div(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n    position: relative;\n\n    padding: 4px 1em;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n\n    h3 {\n        display: flex;\n        align-items: center;\n        font-weight: bold;\n    }\n"], ["\n    position: relative;\n\n    padding: 4px 1em;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n\n    h3 {\n        display: flex;\n        align-items: center;\n        font-weight: bold;\n    }\n"])));
var templateObject_1$3, templateObject_2$1, templateObject_3$1, templateObject_4$1;

var ChartStyled = styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n    height: 100%;\n\n    #tv-attr-logo {\n      display: none;\n    }\n\n    div.not-found {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        z-index: 100;\n\n        h1 {\n            position: absolute;\n            user-select: none;\n        }\n    }\n\n    .rate {\n      position: absolute;\n      font-size: 12px;\n      white-space: nowrap;\n    }\n\n"], ["\n    position: relative;\n    width: 100%;\n    height: 100%;\n\n    #tv-attr-logo {\n      display: none;\n    }\n\n    div.not-found {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        z-index: 100;\n\n        h1 {\n            position: absolute;\n            user-select: none;\n        }\n    }\n\n    .rate {\n      position: absolute;\n      font-size: 12px;\n      white-space: nowrap;\n    }\n\n"])));
var templateObject_1$2;

function getHistory(options) {
    return __awaiter(this, void 0, void 0, function () {
        var exchange, coin, baseUrl, searchParams, response, json;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    exchange = options.exchange, coin = options.coin;
                    if (!exchange) {
                        return [2 /*return*/, []];
                    }
                    return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    searchParams = new URLSearchParams("coin=".concat(coin));
                    return [4 /*yield*/, withRetry(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b;
                            var _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        _a = fetch;
                                        _b = ["".concat(baseUrl, "/history/").concat(exchange, "?").concat(searchParams)];
                                        _c = {};
                                        return [4 /*yield*/, getHeaders()];
                                    case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_c.headers = _d.sent(),
                                                _c)]))];
                                    case 2: return [2 /*return*/, _d.sent()];
                                }
                            });
                        }); })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    json = _a.sent();
                    return [2 /*return*/, json];
            }
        });
    });
}

var useResize = function (cb, deps) {
    if (deps === void 0) { deps = []; }
    useEffect(function () {
        window.addEventListener('resize', cb);
        return function () {
            window.removeEventListener('resize', cb);
        };
    }, deps);
};

function isNewTimeFrame(curTimeFrame, timeFrame) {
    // let time: TSeconds = Date.now() / 1000 - timeFrame*60
    // time -= new Date().getTimezoneOffset()*60
    var time = +dayjs() / 1000 - new Date().getTimezoneOffset() * 60 - timeFrame * 60;
    return time > curTimeFrame;
}
function wasDisconnected(curTimeFrame, timeFrame) {
    //   let time: TSeconds = Date.now() / 1000 - 2*timeFrame*60
    //   time -= new Date().getTimezoneOffset()*60
    var time = +dayjs() / 1000 - new Date().getTimezoneOffset() * 60 - 2 * timeFrame * 60;
    return time > curTimeFrame;
}
function getGeneralTitles(type, statistics, volume) {
    var _a, _b, _c, _d, _e, _f;
    var spread = statistics && 'short' in statistics ? (parseFloat((_a = statistics === null || statistics === void 0 ? void 0 : statistics.short) === null || _a === void 0 ? void 0 : _a.current_funding) - parseFloat((_b = statistics === null || statistics === void 0 ? void 0 : statistics.long) === null || _b === void 0 ? void 0 : _b.current_funding)).toFixed(2) : NaN;
    if (type === 'spot' && statistics && "short" in statistics) {
        spread = ((_c = statistics === null || statistics === void 0 ? void 0 : statistics.short) === null || _c === void 0 ? void 0 : _c.current_funding) || NaN;
    }
    if (type === 'margin' && statistics && 'short' in statistics) {
        spread = ((_d = statistics === null || statistics === void 0 ? void 0 : statistics.short) === null || _d === void 0 ? void 0 : _d.current_funding) ? (-((_e = statistics === null || statistics === void 0 ? void 0 : statistics.short) === null || _e === void 0 ? void 0 : _e.current_funding) || NaN) : (((_f = statistics === null || statistics === void 0 ? void 0 : statistics.short) === null || _f === void 0 ? void 0 : _f.current_funding) || NaN);
    }
    return {
        "Вход": statistics ? "".concat(getEnterSpread(statistics, volume), "%") : "-",
        "Выход": statistics ? "".concat(getCloseSpread(statistics, volume), "%") : "-",
        "Спред": !Number.isNaN(spread) ? "".concat(spread, "%") : '-',
        "Комиссия": statistics && 'fee' in statistics ? getValue((statistics === null || statistics === void 0 ? void 0 : statistics.fee) || '') : '',
    };
}
function getLongShortTitles(longShort) {
    if (!longShort) {
        return {};
    }
    return {
        "Ставка": getValue(longShort.current_funding) || '-',
        // "Прогноз": getValue(longShort.next_funding) || '-' ,
        "Отклонение": getValue(longShort.mark_index) || '-',
        "Стакан": getValue(longShort.orderbook_spread) || '-',
        "Период": getValue(longShort.interval, 'ч') || '-',
        "Лимит": longShort.limit ? longShort.limit.toFixed(0) + '$' : '-'
    };
}
function getValue(val, postfix) {
    if (postfix === void 0) { postfix = "%"; }
    var parsed = parseFloat(val);
    if (Number.isNaN(parsed)) {
        return null;
    }
    return "".concat(parsed).concat(postfix);
}
function getEnterSpread(message, volume) {
    var _a, _b;
    if (!("long" in message)) {
        return "- ";
    }
    var asks = (_a = message.long.orderbook) === null || _a === void 0 ? void 0 : _a.asks;
    var bids = (_b = message.short.orderbook) === null || _b === void 0 ? void 0 : _b.bids;
    if (!asks || !bids) {
        return "- ";
    }
    var askPrice = findAvgPrice(asks, volume);
    var bidPrice = findAvgPrice(bids, volume);
    var spread = getSpread(askPrice, bidPrice);
    return spread;
}
function getCloseSpread(message, volume) {
    var _a, _b, _c, _d;
    if (!('short' in message)) {
        return "- ";
    }
    var asks = (_b = (_a = message === null || message === void 0 ? void 0 : message.short) === null || _a === void 0 ? void 0 : _a.orderbook) === null || _b === void 0 ? void 0 : _b.asks;
    var bids = (_d = (_c = message === null || message === void 0 ? void 0 : message.long) === null || _c === void 0 ? void 0 : _c.orderbook) === null || _d === void 0 ? void 0 : _d.bids;
    if (!asks || !bids) {
        return "- ";
    }
    var askPrice = findAvgPrice(asks, volume);
    var bidPrice = findAvgPrice(bids, volume);
    return getSpread(askPrice, bidPrice);
}
function getSpread(askPrice, bidPrice) {
    return ((bidPrice - askPrice) / (askPrice + bidPrice) * 2 * 100).toFixed(2);
}
function findAvgPrice(orders, volume) {
    var _a;
    volume = volume || 1;
    var result = orders.reduce(function (acc, item) {
        if (acc.remain_volume <= 0)
            return acc;
        var addVolume = Math.min(parseInt(item.volume), acc.remain_volume);
        return __assign(__assign({}, acc), { price_volume: acc.price_volume + item.price * addVolume, remain_volume: Math.round(acc.remain_volume - addVolume) });
    }, { price_volume: 0, remain_volume: volume });
    if (!result.price_volume) {
        result = { price_volume: Number((_a = orders.at(0)) === null || _a === void 0 ? void 0 : _a.price), remain_volume: 0 };
        volume = 1;
    }
    return result.price_volume / (volume - result.remain_volume);
}

function useCheckMobile() {
    return useMemo(function () {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
            check = true; })(navigator.userAgent || navigator.vendor);
        return check;
    }, []);
}

var Chart = observer(function (_a) {
    var type = _a.type, coin = _a.coin, long = _a.long, short = _a.short, statistics = _a.statistics, chain = _a.chain, timeFrame = _a.timeFrame;
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var isMobile = useCheckMobile();
    useEffect(function () {
        if (isMobile) {
            var page = document.getElementById('statistics-page');
            page === null || page === void 0 ? void 0 : page.scrollTo(page.scrollWidth, 0);
        }
    }, [isMobile]);
    var _c = useState([]), longHistory = _c[0], setLongHistory = _c[1];
    var _d = useState([]), shortHistory = _d[0], setShortHistory = _d[1];
    var chartWidth = useRef(0);
    var fetchHistoryInterval = useRef();
    useEffect(function () {
        var fetchHistory = function (isNotFirstCall) {
            if (isNotFirstCall === void 0) { isNotFirstCall = true; }
            return __awaiter(void 0, void 0, void 0, function () {
                var promises, minute, results, hasErrors;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            promises = [];
                            console.log('fetching history...', new Date());
                            minute = dayjs().minute();
                            if (isNotFirstCall && minute === 0)
                                return [2 /*return*/];
                            if (short && type === "futures" || type === "spot") {
                                promises.push(getHistory({ exchange: short, coin: coin }).then(function (val) { return setShortHistory(val); }));
                            }
                            if (long && type === "futures" || type === "margin") {
                                promises.push(getHistory({ exchange: long, coin: coin }).then(function (val) { return setLongHistory(val); }));
                            }
                            return [4 /*yield*/, Promise.allSettled(promises)];
                        case 1:
                            results = _a.sent();
                            hasErrors = results.some(function (r) { return r.status === "rejected"; });
                            if (hasErrors) {
                                setTimeout(function () { return fetchHistory(); }, 5000);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        fetchHistory(false);
        fetchHistoryInterval.current = setInterval(fetchHistory, 1 * 60 * 1e3);
        return function () {
            clearInterval(fetchHistoryInterval.current);
        };
    }, [type, coin, long, short]);
    var chartProperties = useMemo(function () {
        return {
            timeScale: {
                timeVisible: true,
                secondsVisible: false,
                borderVisible: false,
            },
            layout: {
                background: { color: themeStore.bgColor },
                textColor: themeStore.textColor
            },
            grid: {
                vertLines: { color: themeStore.gridColor, },
                horzLines: { color: themeStore.gridColor, },
            },
            rightPriceScale: {
                borderVisible: false,
            },
            crosshair: {
                mode: 0,
                horzLine: {
                    labelBackgroundColor: themeStore.textColor,
                    color: themeStore.textColor,
                },
                vertLine: {
                    labelBackgroundColor: themeStore.textColor,
                    color: themeStore.textColor,
                }
            }
        };
    }, [themeStore.theme]);
    var priceLineOptions = useMemo(function () {
        return {
            price: 0,
            color: themeStore.theme === "light" ? BLUE : WHITE,
            lineWidth: 2,
            lineStyle: 3,
        };
    }, [themeStore.theme]);
    var chartRef = useRef(null);
    var _e = useState(), lastData = _e[0], setLastData = _e[1];
    var _f = useMemo(function () {
        if (chartRef.current) {
            var chart_1 = createChart(chartRef.current, chartProperties);
            var candleSeries_1 = chart_1.addSeries(CandlestickSeries);
            var timeScale_1 = chart_1.timeScale();
            var priceLine_1 = candleSeries_1.createPriceLine(priceLineOptions);
            var firstPane = chart_1.panes()[0];
            createTextWatermark(firstPane, {
                horzAlign: 'right',
                vertAlign: 'bottom',
                lines: [
                    {
                        text: 'Arbitrage Services',
                        color: 'rgba(41, 98, 255, 0.28)',
                        fontSize: 30,
                        fontStyle: 'bold',
                    },
                    {
                        text: '\n',
                        color: 'rgba(41, 98, 255, 0.28)',
                        fontSize: 15,
                        fontStyle: 'bold',
                    },
                ],
            });
            return [chart_1, candleSeries_1, priceLine_1, timeScale_1];
        }
        return [];
    }, [chartRef.current]), chart = _f[0], candleSeries = _f[1], priceLine = _f[2], timeScale = _f[3];
    var _g = useState([]), longRates = _g[0], setLongRates = _g[1];
    var _h = useState([]), shortRates = _h[0], setShortRates = _h[1];
    var getRates = function () {
        var longRates = longHistory === null || longHistory === void 0 ? void 0 : longHistory.map(function (item) {
            var date = Math.round((parseInt(item.timestamp) - new Date().getTimezoneOffset() * 60 * 1e3) / 1000 / 100) * 100;
            var coordinate = timeScale === null || timeScale === void 0 ? void 0 : timeScale.timeToCoordinate(date);
            return { coordinate: coordinate, rate: (item.rate * 100).toFixed(2) + '%' };
        }).filter(function (item) { return item.coordinate && item.coordinate > 0 && item.coordinate < chartWidth.current; });
        setLongRates(longRates || []);
        var shortRates = shortHistory === null || shortHistory === void 0 ? void 0 : shortHistory.map(function (item) {
            var date = Math.round((parseInt(item.timestamp) - new Date().getTimezoneOffset() * 60 * 1e3) / 1000 / 100) * 100;
            var coordinate = timeScale === null || timeScale === void 0 ? void 0 : timeScale.timeToCoordinate(date);
            return { coordinate: coordinate, rate: (item.rate * 100).toFixed(2) + '%' };
        }).filter(function (item) { return item.coordinate && item.coordinate > 0 && item.coordinate < chartWidth.current; });
        setShortRates(shortRates || []);
    };
    var cleanRates = function () {
        setLongRates([]);
        setShortRates([]);
    };
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (isLoading || !timeScale) {
            return;
        }
        getRates();
        (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('mousedown', cleanRates);
        (_b = chartRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('touchstart', cleanRates);
        (_c = chartRef.current) === null || _c === void 0 ? void 0 : _c.addEventListener('mouseup', getRates);
        (_d = chartRef.current) === null || _d === void 0 ? void 0 : _d.addEventListener('wheel', getRates);
        (_e = chartRef.current) === null || _e === void 0 ? void 0 : _e.addEventListener('touchend', getRates);
        return function () {
            var _a, _b, _c, _d, _e;
            (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('mousedown', cleanRates);
            (_b = chartRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('touchstart', cleanRates);
            (_c = chartRef.current) === null || _c === void 0 ? void 0 : _c.removeEventListener('mouseup', getRates);
            (_d = chartRef.current) === null || _d === void 0 ? void 0 : _d.removeEventListener('wheel', getRates);
            (_e = chartRef.current) === null || _e === void 0 ? void 0 : _e.removeEventListener('touchend', getRates);
        };
    }, [longHistory, shortHistory, timeScale, isLoading]);
    useEffect(function () {
        getRates();
    }, [chartWidth.current]);
    useEffect(function () {
        chart === null || chart === void 0 ? void 0 : chart.applyOptions(chartProperties);
    }, [chartProperties]);
    useEffect(function () {
        priceLine === null || priceLine === void 0 ? void 0 : priceLine.applyOptions(priceLineOptions);
    }, [priceLineOptions]);
    var chartResize = useCallback(function () {
        var height;
        var width;
        if (isMobile || window.innerWidth < 2 * parseInt(MIN_INFO_WIDTH)) {
            height = window.innerHeight - parseInt(HEADER_HEIGHT) - 30;
            width = window.innerWidth - parseInt(SCROLL_WIDTH);
        }
        else {
            height = window.innerHeight - parseInt(HEADER_HEIGHT) - (isMobile ? 70 : 30);
            width = Math.max(Math.min(Math.ceil(window.innerWidth * 2 / 3), window.innerWidth - parseInt(MIN_INFO_WIDTH)) - 20, parseInt(MIN_INFO_WIDTH)) - parseInt(SCROLL_WIDTH);
        }
        chartWidth.current = width;
        chart === null || chart === void 0 ? void 0 : chart.resize(width, height, true);
    }, [chart, isMobile]);
    useEffect(function () {
        chartResize === null || chartResize === void 0 ? void 0 : chartResize();
    }, [chartResize]);
    useResize(function () {
        chartResize === null || chartResize === void 0 ? void 0 : chartResize();
    }, [chartResize]);
    var setData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var vals, time;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!(type && coin && candleSeries && timeFrame)) return [3 /*break*/, 2];
                    return [4 /*yield*/, chartStore.getSpreadInfo({ type: type, coin: coin, long: long, short: short, network: chain, timeFrame: timeFrame })];
                case 1:
                    vals = _g.sent();
                    if (vals.length > 0) {
                        candleSeries.setData(vals.map(function (val) { return (__assign(__assign({}, val), { time: getFormatedLocalTime(val.time) / 1000 - timeFrame * 60 })); }));
                        time = timeFrame !== 240 ? Math.floor((getFormatedLocalTime((_a = vals.at(-1)) === null || _a === void 0 ? void 0 : _a.time) / 1000 - timeFrame * 60) / (timeFrame * 60)) * timeFrame * 60 : getFormatedLocalTime((_b = vals.at(-1)) === null || _b === void 0 ? void 0 : _b.time) / 1000 - timeFrame * 60;
                        setLastData({
                            time: time,
                            open: ((_c = vals.at(-1)) === null || _c === void 0 ? void 0 : _c.open) || 0,
                            close: ((_d = vals.at(-1)) === null || _d === void 0 ? void 0 : _d.close) || 0,
                            high: ((_e = vals.at(-1)) === null || _e === void 0 ? void 0 : _e.high) || 0,
                            low: ((_f = vals.at(-1)) === null || _f === void 0 ? void 0 : _f.low) || 0,
                        });
                    }
                    setIsLoading(false);
                    _g.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, [type, coin, long, short, chain, timeFrame, candleSeries, isLoading]);
    useEffect(function () {
        if (timeFrame && setData) {
            setIsLoading(true);
            setData();
        }
    }, [candleSeries, timeFrame]);
    var fetchingSpreadInfo = useRef(false);
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var close_1, time, open_1, high, low;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(statistics && lastData && !fetchingSpreadInfo.current)) return [3 /*break*/, 5];
                        close_1 = parseFloat(chartStore.getEnterSpread(statistics)) || lastData.close;
                        time = lastData.time;
                        open_1 = lastData.open;
                        high = Math.max(lastData.high, close_1);
                        low = Math.min(lastData.low, close_1);
                        if (!wasDisconnected(time, timeFrame)) return [3 /*break*/, 2];
                        if (fetchingSpreadInfo.current) {
                            return [2 /*return*/];
                        }
                        fetchingSpreadInfo.current = true;
                        return [4 /*yield*/, setData()];
                    case 1:
                        _a.sent();
                        fetchingSpreadInfo.current = false;
                        return [2 /*return*/];
                    case 2:
                        if (isNewTimeFrame(time, timeFrame)) {
                            time += timeFrame * 60;
                            open_1 = lastData.close;
                            high = open_1;
                            low = open_1;
                        }
                        if (!isNewTimeFrame(time, timeFrame)) return [3 /*break*/, 4];
                        fetchingSpreadInfo.current = true;
                        return [4 /*yield*/, setData()];
                    case 3:
                        _a.sent();
                        fetchingSpreadInfo.current = false;
                        return [3 /*break*/, 5];
                    case 4:
                        setLastData({
                            open: open_1,
                            time: time,
                            close: close_1,
                            high: high,
                            low: low,
                        });
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); })();
    }, [statistics, candleSeries, timeFrame]);
    useEffect(function () {
        candleSeries === null || candleSeries === void 0 ? void 0 : candleSeries.update(lastData);
    }, [lastData]);
    return (jsxs(ChartStyled, __assign({ ref: chartRef, onWheel: function (e) { return e.stopPropagation(); } }, { children: [lastData === undefined &&
                jsx("div", __assign({ className: 'not-found', style: { color: themeStore.textColor } }, { children: isLoading
                        ? jsx(Loader, { size: 'large' })
                        : jsx("h1", { children: "\u0414\u0430\u043D\u043D\u044B\u0435 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B" }) })), jsxs("span", __assign({ style: {
                    width: "calc(".concat(chartWidth.current, "px - 56px)"),
                    height: "calc(".concat(timeScale === null || timeScale === void 0 ? void 0 : timeScale.height(), "px + 3em)"),
                    position: 'absolute',
                    left: 0,
                    bottom: 0,
                    overflow: 'hidden',
                    zIndex: 1e3
                } }, { children: [longRates === null || longRates === void 0 ? void 0 : longRates.map(function (rate) {
                        var _a, _b;
                        return (jsxs("b", __assign({ id: "long-rate-".concat(long, "-").concat(rate.coordinate, "-").concat(rate.rate), className: 'rate', style: {
                                left: "calc(".concat(rate.coordinate, "px - ").concat((((_a = document.getElementById("long-rate-".concat(long, "-").concat(rate.coordinate, "-").concat(rate.rate))) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) / 2, "px)"),
                                bottom: "calc(".concat(timeScale === null || timeScale === void 0 ? void 0 : timeScale.height(), "px + 1.5em)"),
                                visibility: "".concat(((_b = document.getElementById("long-rate-".concat(long, "-").concat(rate.coordinate, "-").concat(rate.rate))) === null || _b === void 0 ? void 0 : _b.clientWidth) ? 'visible' : 'hidden'),
                                color: themeStore.textColor
                            } }, { children: [shortExchanges[long], " ", rate.rate] })));
                    }), shortRates === null || shortRates === void 0 ? void 0 : shortRates.map(function (rate) {
                        var _a, _b;
                        return (jsxs("b", __assign({ id: "short-rate-".concat(short, "-").concat(rate.coordinate, "-").concat(rate.rate), className: 'rate', style: {
                                left: "calc(".concat(rate.coordinate, "px - ").concat((((_a = document.getElementById("short-rate-".concat(short, "-").concat(rate.coordinate, "-").concat(rate.rate))) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) / 2, "px)"),
                                bottom: "calc(".concat(timeScale === null || timeScale === void 0 ? void 0 : timeScale.height(), "px + .5em)"),
                                visibility: "".concat(((_b = document.getElementById("short-rate-".concat(short, "-").concat(rate.coordinate, "-").concat(rate.rate))) === null || _b === void 0 ? void 0 : _b.clientWidth) ? 'visible' : 'hidden'),
                                color: themeStore.textColor
                            } }, { children: [shortExchanges[short], " ", rate.rate] })));
                    })] }))] })));
});

var DefaultSocket = /** @class */ (function () {
    function DefaultSocket(options) {
        var _this = this;
        Object.defineProperty(this, "futuresReqInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "spotReqInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasBadConnectionInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "futuresInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "spotInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onOrderbook", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "divide", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "coin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ws", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "futuresUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "spotUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "noFuturesSocket", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "noSpotSocket", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reInitTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lastMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "manuallyClosed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "_hasBadConnection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_tradfi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "convertSide", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (sideObj, sortDir) {
                return Object.entries(sideObj)
                    .map(function (_a) {
                    var price = _a[0], volume = _a[1];
                    return ({
                        price: +price / _this.divide,
                        volume: volume
                    });
                })
                    .sort(function (a, b) { return sortDir === 'asc'
                    ? a.price - b.price
                    : b.price - a.price; });
            }
        });
        var coin = options.coin, futuresUrl = options.futuresUrl, spotUrl = options.spotUrl, noFuturesSocket = options.noFuturesSocket, noSpotSocket = options.noSpotSocket, type = options.type, onOrderbook = options.onOrderbook, divide = options.divide, contractSize = options.contractSize;
        this.coin = coin;
        this.onOrderbook = onOrderbook;
        this.divide = divide;
        this.contractSize = contractSize;
        this.type = type;
        this.futuresUrl = futuresUrl;
        this.spotUrl = spotUrl;
        this.noFuturesSocket = noFuturesSocket;
        this.noSpotSocket = noSpotSocket;
        this._hasBadConnection = false;
        console.log('constructor call: ', new Date());
        this.init(true);
    }
    Object.defineProperty(DefaultSocket.prototype, "resetReinitTimeout", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            clearTimeout(this.reInitTimeout);
            this.reInitTimeout = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    console.warn("REINIT", this.futuresUrl, this.spotUrl);
                    this.close(false).catch(function (e) { return null; });
                    setTimeout(function () { return _this.init(); }, 200);
                    return [2 /*return*/];
                });
            }); }, 3e3);
        }
    });
    Object.defineProperty(DefaultSocket.prototype, "hasBadConnection", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._hasBadConnection;
        }
    });
    Object.defineProperty(DefaultSocket.prototype, "tradfi", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._tradfi;
        }
    });
    Object.defineProperty(DefaultSocket.prototype, "setLastMessage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (time) {
            if (this.lastMessage && this.lastMessage > time)
                return;
            this.lastMessage = time;
        }
    });
    Object.defineProperty(DefaultSocket.prototype, "init", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isFromConstructor) {
            var _this = this;
            if (isFromConstructor === void 0) { isFromConstructor = false; }
            if (this.manuallyClosed) {
                return;
            }
            if (isFromConstructor)
                this.setLastMessage(+new Date());
            this.resetReinitTimeout();
            this.hasBadConnectionInterval = setInterval(function () {
                //@ts-ignore
                if (+new Date() - _this.lastMessage > 5e3)
                    _this._hasBadConnection = true;
                else
                    _this._hasBadConnection = false;
            }, 1000);
            var ws;
            switch (this.type) {
                case "futures": {
                    if (this.noFuturesSocket) {
                        this.futuresReqInterval = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                            var response, json, e_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 3, , 4]);
                                        return [4 /*yield*/, fetch(this.futuresUrl)];
                                    case 1:
                                        response = _a.sent();
                                        return [4 /*yield*/, response.json()];
                                    case 2:
                                        json = _a.sent();
                                        if (response.ok) {
                                            this.resetReinitTimeout();
                                            this.setLastMessage(+new Date());
                                        }
                                        this.onFutures(json);
                                        return [3 /*break*/, 4];
                                    case 3:
                                        e_1 = _a.sent();
                                        console.error(e_1);
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); }, 500);
                        break;
                    }
                    ws = new WebSocket(this.futuresUrl);
                    this.ws = ws;
                    ws.onmessage = function (msg) {
                        _this.resetReinitTimeout();
                        _this.setLastMessage(+new Date());
                        _this.onFutures(msg);
                    };
                    ws.onopen = function () {
                        _this.resetReinitTimeout();
                        _this.setLastMessage(+new Date());
                        _this.onFuturesOpen();
                    };
                    ws.onclose = function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            this.onFuturesClose();
                            return [2 /*return*/];
                        });
                    }); };
                    ws.onerror = function (e) {
                        var _a;
                        try {
                            (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.close();
                        }
                        catch (e) { }
                    };
                    break;
                }
                case "spot": {
                    if (this.noSpotSocket) {
                        this.spotReqInterval = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                            var response, json, e_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 3, , 4]);
                                        return [4 /*yield*/, fetch(this.spotUrl)];
                                    case 1:
                                        response = _a.sent();
                                        return [4 /*yield*/, response.json()];
                                    case 2:
                                        json = _a.sent();
                                        if (response.ok) {
                                            this.resetReinitTimeout();
                                            this.setLastMessage(+new Date());
                                        }
                                        this.onSpot(json);
                                        return [3 /*break*/, 4];
                                    case 3:
                                        e_2 = _a.sent();
                                        console.error(e_2);
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); }, 500);
                        break;
                    }
                    ws = new WebSocket(this.spotUrl);
                    this.ws = ws;
                    ws.onmessage = function (msg) {
                        _this.resetReinitTimeout();
                        _this.setLastMessage(+new Date());
                        _this.onSpot(msg);
                    };
                    ws.onopen = function () {
                        _this.resetReinitTimeout();
                        _this.onSpotOpen();
                        _this.setLastMessage(+new Date());
                    };
                    ws.onclose = function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            this.onSpotClose();
                            return [2 /*return*/];
                        });
                    }); };
                    ws.onerror = function (e) {
                        var _a;
                        try {
                            (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.close();
                        }
                        catch (e) { }
                    };
                    break;
                }
            }
        }
    });
    Object.defineProperty(DefaultSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            throw new Error("Not implemented");
        }
    });
    Object.defineProperty(DefaultSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(DefaultSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(DefaultSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) { throw new Error("Not implemented"); }
    });
    Object.defineProperty(DefaultSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) { throw new Error("Not implemented"); }
    });
    Object.defineProperty(DefaultSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(DefaultSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(DefaultSocket.prototype, "close", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (manually) {
            var _a;
            if (manually === void 0) { manually = true; }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    if (this.type === 'futures' && this.futuresInterval) {
                        clearInterval(this.futuresInterval);
                        this.futuresInterval = undefined;
                    }
                    if (this.type === 'spot' && this.spotInterval) {
                        clearInterval(this.spotInterval);
                        this.spotInterval = undefined;
                    }
                    if (manually) {
                        this.manuallyClosed = true;
                        clearInterval(this.hasBadConnectionInterval);
                    }
                    try {
                        try {
                            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.close();
                        }
                        catch (_c) { }
                        clearTimeout(this.reInitTimeout);
                        clearInterval(this.futuresReqInterval);
                        clearInterval(this.spotReqInterval);
                        // clearInterval(this.hasBadConnectionInterval)
                    }
                    catch (e) {
                        console.error("Error when close socket connection: ", e);
                    }
                    return [2 /*return*/];
                });
            });
        }
    });
    return DefaultSocket;
}());

var ApexSocket = /** @class */ (function (_super) {
    __extends(ApexSocket, _super);
    function ApexSocket(options) {
        var coin = options.coin;
        var futuresUrl = "https://omni.apex.exchange/api/v3/depth?symbol=".concat(coin, "&limit=5");
        var spotUrl = "";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl, noFuturesSocket: true, noSpotSocket: true })) || this;
    }
    Object.defineProperty(ApexSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new ApexSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(ApexSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            var _this = this;
            var mainData = message.data;
            var asks = mainData.a.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            var bids = mainData.b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    Object.defineProperty(ApexSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
        }
    });
    return ApexSocket;
}(DefaultSocket));

var AsterSocket = /** @class */ (function (_super) {
    __extends(AsterSocket, _super);
    function AsterSocket(options) {
        var coin = options.coin;
        var futuresUrl = "wss://fstream.asterdex.com/ws/".concat(coin === null || coin === void 0 ? void 0 : coin.toLowerCase(), "@depth5@500ms");
        var spotUrl = "wss://sstream.asterdex.com/ws/".concat(coin === null || coin === void 0 ? void 0 : coin.toLowerCase(), "@depth5");
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(AsterSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new AsterSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(AsterSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            this.futuresInterval = setInterval(function () { var _a, _b; return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({ id: 1, "method": "LIST_SUBSCRIPTIONS" }))); }, 1500);
        }
    });
    Object.defineProperty(AsterSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            this.spotInterval = setInterval(function () { var _a, _b; return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({ id: 1, "method": "LIST_SUBSCRIPTIONS" }))); }, 1500);
        }
    });
    Object.defineProperty(AsterSocket.prototype, "onError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(AsterSocket.prototype, "onOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(AsterSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { clearInterval(this.futuresInterval); }
    });
    Object.defineProperty(AsterSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { clearInterval(this.spotInterval); }
    });
    Object.defineProperty(AsterSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var message = JSON.parse(event.data);
            if (!(message === null || message === void 0 ? void 0 : message.a))
                return;
            var asks = message.a.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            var bids = message.b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    Object.defineProperty(AsterSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var message = JSON.parse(event.data);
            if (!(message === null || message === void 0 ? void 0 : message.a))
                return;
            var asks = message.a.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
            var bids = message.b.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    return AsterSocket;
}(DefaultSocket));

var BinanceSocket = /** @class */ (function (_super) {
    __extends(BinanceSocket, _super);
    function BinanceSocket(options) {
        var _this = this;
        var coin = options.coin, orderbook = options.orderbook;
        var futuresUrl = "wss://fstream.binance.com/public/ws/".concat(coin === null || coin === void 0 ? void 0 : coin.toLowerCase(), "@rpiDepth@500ms");
        var spotUrl = "wss://stream.binance.com:9443/ws/".concat(coin === null || coin === void 0 ? void 0 : coin.toLowerCase(), "@depth5@1000ms");
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "orderbook", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { asks: [], bids: [] }
        });
        Object.defineProperty(_this, "lastUpdate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "setOrderbook", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (orderbook) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    if (!(orderbook === null || orderbook === void 0 ? void 0 : orderbook.asks))
                        orderbook = { asks: [], bids: [] };
                    this.orderbook.asks = orderbook.asks.reduce(function (acc, item) {
                        //@ts-ignore
                        acc[item.at(0)] = (item.at(1) * item.at(0)).toFixed(2);
                        return acc;
                    }, {});
                    this.orderbook.bids = orderbook.bids.reduce(function (acc, item) {
                        //@ts-ignore
                        acc[item.at(0)] = (item.at(1) * item.at(0)).toFixed(2);
                        return acc;
                    }, {});
                    return [2 /*return*/];
                });
            }); }
        });
        // this.futuresInterval = setInterval(async () =>  {
        //   const orderbook = await BinanceSocket.getOrderbook(coin || '').catch(e => ({asks: [], bids: []}))
        //   this.setOrderbook(orderbook)
        //   this.lastUpdate = +new Date()
        // }, 60_000)
        _this.lastUpdate = 0;
        _this.setOrderbook(orderbook);
        return _this;
    }
    Object.defineProperty(BinanceSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var coin, orderbook;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            coin = options.coin;
                            return [4 /*yield*/, BinanceSocket.getOrderbook(coin || '').catch(function (e) { return ({ asks: [], bids: [] }); })];
                        case 1:
                            orderbook = _b.sent();
                            return [2 /*return*/, new BinanceSocket(__assign(__assign({}, options), { orderbook: orderbook }))];
                    }
                });
            });
        }
    });
    Object.defineProperty(BinanceSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            this.futuresInterval = setInterval(function () { var _b, _c; return ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.readyState) === 1 && ((_c = _this.ws) === null || _c === void 0 ? void 0 : _c.send(JSON.stringify({ id: 1, "method": "LIST_SUBSCRIPTIONS" }))); }, 1500);
        }
    });
    Object.defineProperty(BinanceSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            this.spotInterval = setInterval(function () { var _b, _c; return ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.readyState) === 1 && ((_c = _this.ws) === null || _c === void 0 ? void 0 : _c.send(JSON.stringify({ id: 1, "method": "LIST_SUBSCRIPTIONS" }))); }, 1500);
        }
    });
    Object.defineProperty(BinanceSocket.prototype, "onError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(BinanceSocket.prototype, "onOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(BinanceSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { clearInterval(this.futuresInterval); }
    });
    Object.defineProperty(BinanceSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { clearInterval(this.spotInterval); }
    });
    Object.defineProperty(BinanceSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var message, orderbook, _i, _d, item, _e, _f, item, asks, bids, orderbook;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            message = JSON.parse(event.data);
                            if (!(this.lastUpdate && message.T > this.lastUpdate + 5000)) return [3 /*break*/, 2];
                            this.lastUpdate = +new Date();
                            return [4 /*yield*/, BinanceSocket.getOrderbook(this.coin || '').catch(function (e) { return ({ asks: [], bids: [] }); })];
                        case 1:
                            orderbook = _g.sent();
                            this.setOrderbook(orderbook);
                            return [2 /*return*/];
                        case 2:
                            this.lastUpdate = message.T;
                            if (!(message === null || message === void 0 ? void 0 : message.a))
                                return [2 /*return*/];
                            for (_i = 0, _d = message.a; _i < _d.length; _i++) {
                                item = _d[_i];
                                //@ts-ignore
                                if (!+(item === null || item === void 0 ? void 0 : item.at(1)))
                                    delete this.orderbook.asks[item.at(0)];
                                //@ts-ignore
                                else
                                    this.orderbook.asks[item.at(0)] = (item.at(1) * item.at(0)).toFixed(2);
                            }
                            for (_e = 0, _f = message.b; _e < _f.length; _e++) {
                                item = _f[_e];
                                //@ts-ignore
                                if (!+(item === null || item === void 0 ? void 0 : item.at(1)))
                                    delete this.orderbook.bids[item.at(0)];
                                //@ts-ignore
                                else
                                    this.orderbook.bids[item.at(0)] = (item.at(1) * item.at(0)).toFixed(2);
                            }
                            asks = this.convertSide(this.orderbook.asks, 'asc').slice(0, 5);
                            bids = this.convertSide(this.orderbook.bids, 'desc').slice(0, 5);
                            if (!(((_b = bids.at(0)) === null || _b === void 0 ? void 0 : _b.price) && ((_c = asks.at(0)) === null || _c === void 0 ? void 0 : _c.price) && asks.at(0).price < bids.at(0).price)) return [3 /*break*/, 4];
                            this.lastUpdate = +new Date();
                            return [4 /*yield*/, BinanceSocket.getOrderbook(this.coin || '').catch(function (e) { return ({ asks: [], bids: [] }); })];
                        case 3:
                            orderbook = _g.sent();
                            this.setOrderbook(orderbook);
                            return [2 /*return*/];
                        case 4:
                            //@ts-ignore
                            this.onOrderbook({ asks: asks, bids: bids });
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(BinanceSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var message = JSON.parse(event.data);
            if (!(message === null || message === void 0 ? void 0 : message.asks))
                return;
            var asks = message.asks.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
            var bids = message.bids.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    var _a;
    _a = BinanceSocket;
    Object.defineProperty(BinanceSocket, "getOrderbook", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: function (coin) { return __awaiter(void 0, void 0, void 0, function () {
            var response, orderbook;
            return __generator(_a, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetch("https://fapi.binance.com/fapi/v1/depth?symbol=".concat(coin, "&limit=5"))];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        orderbook = _b.sent();
                        return [2 /*return*/, orderbook || { asks: [], bids: [] }];
                }
            });
        }); }
    });
    return BinanceSocket;
}(DefaultSocket));

var BingxSocket = /** @class */ (function (_super) {
    __extends(BingxSocket, _super);
    function BingxSocket(options) {
        var futuresUrl = "wss://open-api-swap.bingx.com/swap-market";
        var spotUrl = "wss://open-api-ws.bingx.com/market";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(BingxSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new BingxSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(BingxSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                reqType: "sub",
                dataType: "".concat(this.coin, "@depth5")
            }));
        }
    });
    Object.defineProperty(BingxSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                id: v4(),
                reqType: "sub",
                dataType: "".concat(this.coin, "@depth5")
            }));
        }
    });
    Object.defineProperty(BingxSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var buffer, _b, _c, decodedMsg, _d, data, dataType, asks, bids;
                var _this = this;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            _c = (_b = Buffer).from;
                            return [4 /*yield*/, message.data.arrayBuffer()];
                        case 1:
                            buffer = _c.apply(_b, [_e.sent()]);
                            decodedMsg = zlib.gunzipSync(buffer).toString('utf-8');
                            if (decodedMsg === "Ping") {
                                (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send('Pong');
                                return [2 /*return*/];
                            }
                            _d = JSON.parse(decodedMsg), data = _d.data, dataType = _d.dataType;
                            if (dataType === null || dataType === void 0 ? void 0 : dataType.includes("@depth5")) {
                                asks = data.asks.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                                bids = data.bids.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                                this.onOrderbook({ asks: asks, bids: bids });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(BingxSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var buffer, _b, _c, decodedMsg, _d, ping, time, data, dataType, objString, asks, bids;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            _c = (_b = Buffer).from;
                            return [4 /*yield*/, message.data.arrayBuffer()];
                        case 1:
                            buffer = _c.apply(_b, [_e.sent()]);
                            decodedMsg = zlib.gunzipSync(buffer).toString('utf-8');
                            _d = JSON.parse(decodedMsg), ping = _d.ping, time = _d.time, data = _d.data, dataType = _d.dataType;
                            if (ping) {
                                objString = JSON.stringify({ pong: ping, time: time });
                                (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(objString);
                                return [2 /*return*/];
                            }
                            if (dataType === null || dataType === void 0 ? void 0 : dataType.includes("@depth5")) {
                                asks = data.asks.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); }).reverse();
                                bids = data.bids.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                                this.onOrderbook({ asks: asks, bids: bids });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    return BingxSocket;
}(DefaultSocket));

var BitgetSocket = /** @class */ (function (_super) {
    __extends(BitgetSocket, _super);
    function BitgetSocket(options) {
        var futuresUrl = "wss://ws.bitget.com/v2/ws/public";
        var spotUrl = "wss://ws.bitget.com/v2/ws/public";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(BitgetSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new BitgetSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(BitgetSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b;
            var val = {
                "instType": "USDT-FUTURES",
                "channel": "books5",
                "instId": (_a = this.coin) === null || _a === void 0 ? void 0 : _a.replace("_UMCBL", "")
            };
            (_b = this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({
                "op": "subscribe",
                "args": [val]
            }));
            this.futuresInterval = setInterval(function () { var _a, _b; return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send('ping')); }, 2000);
        }
    });
    Object.defineProperty(BitgetSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var val = {
                "instType": "SPOT",
                "channel": "books5",
                "instId": this.coin,
            };
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "op": "subscribe",
                "args": [val]
            }));
            this.spotInterval = setInterval(function () { var _a, _b; return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send('ping')); }, 2000);
        }
    });
    Object.defineProperty(BitgetSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            if (event.data === 'pong')
                return;
            var _a = JSON.parse(event.data), action = _a.action, data = _a.data;
            if (action === "snapshot") {
                var mainData = data[0];
                var asks = mainData.asks.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                var bids = mainData.bids.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(BitgetSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, action, data, mainData, asks, bids;
                var _this = this;
                return __generator(this, function (_b) {
                    if (event.data === 'pong')
                        return [2 /*return*/];
                    _a = JSON.parse(event.data), action = _a.action, data = _a.data;
                    if (action === "snapshot") {
                        mainData = data[0];
                        asks = mainData.asks.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                        bids = mainData.bids.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                        this.onOrderbook({ asks: asks, bids: bids });
                    }
                    return [2 /*return*/];
                });
            });
        }
    });
    Object.defineProperty(BitgetSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(BitgetSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return BitgetSocket;
}(DefaultSocket));

var BitmartSocket = /** @class */ (function (_super) {
    __extends(BitmartSocket, _super);
    function BitmartSocket(options) {
        var futuresUrl = "wss://contract-ws-v2.bitmart.com/v1/ifcontract/realTime";
        var spotUrl = "wss://ws-manager-compress.bitmart.com/api?protocol=1.1";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(BitmartSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new BitmartSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(BitmartSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            if (this.coin == '33544')
                this.divide = 10;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "action": "subscribe",
                "args": ["Depth:".concat(this.coin)]
            }));
            this.futuresInterval = setInterval(function () { var _a, _b; return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({ "action": "ping" }))); }, 10 * 1000);
        }
    });
    Object.defineProperty(BitmartSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var index = 0; // ???
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "op": "subscribe",
                "args": ["spot/depth5:".concat(this.coin)]
            }));
            this.spotInterval = setInterval(function () { var _a, _b; return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send('ping')); }, (5 + index) * 1000);
        }
    });
    Object.defineProperty(BitmartSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b, _c, _d;
            var eventData;
            try {
                eventData = JSON.parse(event.data);
            }
            catch (_e) {
                return;
            }
            var action = eventData.action, group = eventData.group, data = eventData.data;
            if (!action && (group === null || group === void 0 ? void 0 : group.includes("Depth:"))) {
                var mainData = data[0] || data;
                if ((mainData === null || mainData === void 0 ? void 0 : mainData.way) === 1) {
                    var bids = (_b = (_a = mainData === null || mainData === void 0 ? void 0 : mainData.depths) === null || _a === void 0 ? void 0 : _a.slice(0, 5)) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item.price / _this.divide, volume: (item.price * item.vol * _this.contractSize).toFixed(2) }); });
                    if (!(bids === null || bids === void 0 ? void 0 : bids.length))
                        return;
                    this.onOrderbook({ bids: bids });
                }
                if ((mainData === null || mainData === void 0 ? void 0 : mainData.way) === 2) {
                    var asks = (_d = (_c = mainData === null || mainData === void 0 ? void 0 : mainData.depths) === null || _c === void 0 ? void 0 : _c.slice(0, 5)) === null || _d === void 0 ? void 0 : _d.map(function (item) { return ({ price: item.price / _this.divide, volume: (item.price * item.vol * _this.contractSize).toFixed(2) }); });
                    if (!(asks === null || asks === void 0 ? void 0 : asks.length))
                        return;
                    this.onOrderbook({ asks: asks });
                }
            }
        }
    });
    Object.defineProperty(BitmartSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var eventData;
            try {
                eventData = JSON.parse(event.data);
            }
            catch (_a) {
                return;
            }
            var table = eventData.table, data = eventData.data;
            if (table) {
                var mainData = data[0] || data;
                var asks = mainData.asks.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                var bids = mainData.bids.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(BitmartSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(BitmartSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return BitmartSocket;
}(DefaultSocket));

var BitmexSocket = /** @class */ (function (_super) {
    __extends(BitmexSocket, _super);
    function BitmexSocket(options) {
        var futuresUrl = "wss://ws.bitmex.com/realtime";
        var spotUrl = "wss://ws.bitmex.com/realtime";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(BitmexSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new BitmexSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(BitmexSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "op": "subscribe",
                "args": ["orderBook10:".concat(this.coin)]
            }));
        }
    });
    Object.defineProperty(BitmexSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            var arr = ["orderBook10:".concat(this.coin)];
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "op": "subscribe",
                "args": arr
            }));
        }
    });
    Object.defineProperty(BitmexSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a = JSON.parse(event.data), action = _a.action, table = _a.table, data = _a.data;
            if (action && table) {
                var mainData = data[0] || data;
                var asks = mainData.asks.slice(0, 5).map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] / _this.contractSize).toFixed(2) }); });
                var bids = mainData.bids.slice(0, 5).map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] / _this.contractSize).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(BitmexSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a = JSON.parse(event.data), action = _a.action, table = _a.table, data = _a.data;
            if (action && table) {
                var mainData = data[0] || data;
                var asks = mainData.asks.slice(0, 5).map(function (item) { return ({ price: item[0], volume: (item[1] * item[0] / _this.contractSize).toFixed(2) }); });
                var bids = mainData.bids.slice(0, 5).map(function (item) { return ({ price: item[0], volume: (item[1] * item[0] / _this.contractSize).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    return BitmexSocket;
}(DefaultSocket));

var BlofinSocket = /** @class */ (function (_super) {
    __extends(BlofinSocket, _super);
    function BlofinSocket(options) {
        var futuresUrl = "wss://openapi.blofin.com/ws/public";
        var spotUrl = "";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(BlofinSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new BlofinSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(BlofinSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var val = {
                "channel": "books5",
                "instId": this.coin
            };
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "op": "subscribe",
                "args": [val]
            }));
            this.futuresInterval = setInterval(function () { var _a, _b; return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send('ping')); }, 5000);
        }
    });
    Object.defineProperty(BlofinSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(BlofinSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            if (event.data === 'pong')
                return;
            var _a = JSON.parse(event.data), action = _a.action, data = _a.data;
            if (action === "snapshot") {
                var mainData = data;
                var asks = mainData.asks.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                var bids = mainData.bids.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(BlofinSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/];
            }); });
        }
    });
    Object.defineProperty(BlofinSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(BlofinSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return BlofinSocket;
}(DefaultSocket));

var BybitSocket = /** @class */ (function (_super) {
    __extends(BybitSocket, _super);
    function BybitSocket(options) {
        var coin = options.coin;
        var futuresUrl = "https://api.bybit.com/v5/market/orderbook?category=linear&symbol=".concat(coin, "&limit=5");
        var spotUrl = "https://api.bybit.com/v5/market/orderbook?category=spot&symbol=".concat(coin, "&limit=5");
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl, noFuturesSocket: true, noSpotSocket: true })) || this;
    }
    Object.defineProperty(BybitSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new BybitSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(BybitSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            var _this = this;
            var mainData = message.result;
            var asks = mainData.a.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            var bids = mainData.b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    Object.defineProperty(BybitSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            var _this = this;
            var mainData = message.result;
            var asks = mainData.a.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            var bids = mainData.b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    return BybitSocket;
}(DefaultSocket));

var CoinexSocket = /** @class */ (function (_super) {
    __extends(CoinexSocket, _super);
    function CoinexSocket(options) {
        var futuresUrl = "wss://socket.coinex.com/v2/futures/";
        var spotUrl = "wss://socket.coinex.com/v2/spot";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(CoinexSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new CoinexSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(CoinexSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var params = [this.coin, 5, '0', true];
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "depth.subscribe",
                "params": { market_list: [params] },
                "id": 42
            }));
            this.futuresInterval = setInterval(function () {
                var _a, _b;
                return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({
                    "method": "server.ping",
                    "params": {},
                    "id": 42
                })));
            }, 2000);
        }
    });
    Object.defineProperty(CoinexSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var params = [this.coin, 5, '0', true];
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "depth.subscribe",
                "params": { market_list: [params] },
                "id": 42
            }));
            if (!this.spotInterval)
                this.spotInterval = setInterval(function () {
                    var _a, _b;
                    return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({
                        "method": "server.ping",
                        "params": {},
                        "id": 42
                    })));
                }, 2000);
        }
    });
    Object.defineProperty(CoinexSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                var buf, _c, _d, decodedMsg, _e, data, method, asks, bids;
                var _this = this;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            _d = (_c = Buffer).from;
                            return [4 /*yield*/, event.data.arrayBuffer()];
                        case 1:
                            buf = _d.apply(_c, [_f.sent()]);
                            decodedMsg = zlib.gunzipSync(buf).toString('utf-8');
                            _e = JSON.parse(decodedMsg), data = _e.data, method = _e.method;
                            if (method === "depth.update") {
                                asks = (_a = data === null || data === void 0 ? void 0 : data.depth) === null || _a === void 0 ? void 0 : _a.asks.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                                bids = (_b = data === null || data === void 0 ? void 0 : data.depth) === null || _b === void 0 ? void 0 : _b.bids.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                                this.onOrderbook({ asks: asks, bids: bids });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(CoinexSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b, _c, _d;
            return __awaiter(this, void 0, void 0, function () {
                var buf, _e, _f, decodedMsg, _g, data, method, asks, bids;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            _f = (_e = Buffer).from;
                            return [4 /*yield*/, event.data.arrayBuffer()];
                        case 1:
                            buf = _f.apply(_e, [_h.sent()]);
                            decodedMsg = zlib.gunzipSync(buf).toString('utf-8');
                            _g = JSON.parse(decodedMsg), data = _g.data, method = _g.method;
                            if (method === "depth.update") {
                                asks = (_b = (_a = data === null || data === void 0 ? void 0 : data.depth) === null || _a === void 0 ? void 0 : _a.asks) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                                bids = (_d = (_c = data === null || data === void 0 ? void 0 : data.depth) === null || _c === void 0 ? void 0 : _c.bids) === null || _d === void 0 ? void 0 : _d.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                                this.onOrderbook({ asks: asks, bids: bids });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(CoinexSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(CoinexSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return CoinexSocket;
}(DefaultSocket));

var GateioSocket = /** @class */ (function (_super) {
    __extends(GateioSocket, _super);
    function GateioSocket(options) {
        var _this = this;
        var futuresUrl = "wss://webws.wsbridge.com/v4/ws/usdt?device_type=0'";
        var spotUrl = "wss://ws.gate.io/v3/";
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "futuresPrecision", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.futuresPrecision = options.futuresPrecision;
        return _this;
    }
    Object.defineProperty(GateioSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var futuresPrecision, baseUrl_1, futuresResposne, tick;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 4, , 5]);
                            return [4 /*yield*/, userStore.getBaseUrl()];
                        case 1:
                            baseUrl_1 = _a.sent();
                            return [4 /*yield*/, withRetry(function () { return __awaiter(_this, void 0, void 0, function () {
                                    var _a, _b;
                                    var _c;
                                    return __generator(this, function (_d) {
                                        switch (_d.label) {
                                            case 0:
                                                _a = fetch;
                                                _b = ["".concat(baseUrl_1, "/gateio/price-round/").concat(options.backendCoin)];
                                                _c = {};
                                                return [4 /*yield*/, getHeaders()];
                                            case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_c.headers = _d.sent(),
                                                        _c)]))];
                                            case 2: return [2 /*return*/, _d.sent()];
                                        }
                                    });
                                }); })];
                        case 2:
                            futuresResposne = _a.sent();
                            return [4 /*yield*/, futuresResposne.json()];
                        case 3:
                            tick = (_a.sent()).tick;
                            futuresPrecision = tick || '1';
                            return [3 /*break*/, 5];
                        case 4:
                            _a.sent();
                            futuresPrecision = '1';
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/, new GateioSocket(__assign(__assign({}, options), { futuresPrecision: futuresPrecision }))];
                    }
                });
            });
        }
    });
    Object.defineProperty(GateioSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var params;
                var _this = this;
                return __generator(this, function (_b) {
                    params = [this.coin, '30', this.futuresPrecision];
                    (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                        "channel": "futures.order_book",
                        "event": "subscribe",
                        "payload": [params]
                    }));
                    this.futuresInterval = setInterval(function () {
                        var _a, _b;
                        try {
                            ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({ "time": Math.floor(+new Date() / 1000), "channel": "futures.ping" })));
                        }
                        catch (e) {
                            // this.onFuturesClose()
                        }
                    }, 5000);
                    return [2 /*return*/];
                });
            });
        }
    });
    Object.defineProperty(GateioSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var params = [this.coin, 5, "0"];
            var payload = JSON.stringify({
                "id": 42,
                "method": "depth.subscribe",
                "params": [params]
            });
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(payload);
            if (!this.spotInterval)
                this.spotInterval = setInterval(function () {
                    var _a, _b;
                    try {
                        ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({ "id": 42, "method": "server.ping", "params": [] })));
                    }
                    catch (e) {
                        // this.onSpotClose()
                    }
                }, 5000);
        }
    });
    Object.defineProperty(GateioSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b, _c, _d;
            var _e = JSON.parse(event.data), error = _e.error, result = _e.result, channel = _e.channel;
            if (error === null || error === void 0 ? void 0 : error.code) {
                return;
            }
            if (channel === "futures.order_book" && result.asks && result.bids) {
                var asks = ((_b = (_a = result.asks) === null || _a === void 0 ? void 0 : _a.slice(0, 5)) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item.p, volume: (item.s * item.p * _this.contractSize).toFixed(2) }); })) || [];
                var bids = ((_d = (_c = result.bids) === null || _c === void 0 ? void 0 : _c.slice(0, 5)) === null || _d === void 0 ? void 0 : _d.map(function (item) { return ({ price: item.p, volume: (item.s * item.p * _this.contractSize).toFixed(2) }); })) || [];
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(GateioSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b, _c, _d, _e, _f;
            var _g = JSON.parse(event.data), error = _g.error, method = _g.method, params = _g.params;
            if (error === null || error === void 0 ? void 0 : error.code) {
                return;
            }
            if (method === "depth.update" && ((_a = params === null || params === void 0 ? void 0 : params.at(1)) === null || _a === void 0 ? void 0 : _a.asks) && ((_b = params === null || params === void 0 ? void 0 : params.at(1)) === null || _b === void 0 ? void 0 : _b.bids)) {
                var asks = ((_d = (_c = params === null || params === void 0 ? void 0 : params.at(1)) === null || _c === void 0 ? void 0 : _c.asks) === null || _d === void 0 ? void 0 : _d.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); })) || [];
                var bids = ((_f = (_e = params === null || params === void 0 ? void 0 : params.at(1)) === null || _e === void 0 ? void 0 : _e.bids) === null || _f === void 0 ? void 0 : _f.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); })) || [];
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(GateioSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(GateioSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return GateioSocket;
}(DefaultSocket));

var HuobiSocket = /** @class */ (function (_super) {
    __extends(HuobiSocket, _super);
    function HuobiSocket(options) {
        var futuresUrl = "wss://www.htx.com/futures/api/linear-swap-ws";
        var spotUrl = "wss://www.htx.com/-/s/pro/ws";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(HuobiSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new HuobiSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(HuobiSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "sub": "market.".concat(this.coin, ".depth.step0"),
                "id": "331"
            }));
        }
    });
    Object.defineProperty(HuobiSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "sub": "market.".concat(this.coin, ".depth.step0"),
                "id": "631"
            }));
        }
    });
    Object.defineProperty(HuobiSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var buffer, _b, _c, decodedMsg, _d, ch, ping, tick, iterArr, asks, bids;
                var _this = this;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            _c = (_b = Buffer).from;
                            return [4 /*yield*/, event.data.arrayBuffer()];
                        case 1:
                            buffer = _c.apply(_b, [_e.sent()]);
                            decodedMsg = zlib.gunzipSync(buffer).toString('utf-8');
                            _d = JSON.parse(decodedMsg), ch = _d.ch, ping = _d.ping, tick = _d.tick;
                            if (ch === null || ch === void 0 ? void 0 : ch.includes("market")) {
                                iterArr = Array(5).fill(Number);
                                asks = iterArr.map(function (_, index) {
                                    var item = tick.asks[index];
                                    return { price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) };
                                });
                                bids = iterArr.map(function (_, index) {
                                    var item = tick.bids[index];
                                    return { price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) };
                                });
                                this.onOrderbook({ asks: asks, bids: bids });
                            }
                            if (ping) {
                                (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({ pong: ping }));
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(HuobiSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var buffer, _b, _c, decodedMsg, _d, ch, ping, tick, iterArr, asks, bids;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            _c = (_b = Buffer).from;
                            return [4 /*yield*/, event.data.arrayBuffer()];
                        case 1:
                            buffer = _c.apply(_b, [_e.sent()]);
                            decodedMsg = zlib.gunzipSync(buffer).toString('utf-8');
                            _d = JSON.parse(decodedMsg), ch = _d.ch, ping = _d.ping, tick = _d.tick;
                            if (ch === null || ch === void 0 ? void 0 : ch.includes("market")) {
                                iterArr = Array(5).fill(Number);
                                asks = iterArr.map(function (_, index) {
                                    var _a;
                                    var item = (_a = tick.asks) === null || _a === void 0 ? void 0 : _a[index];
                                    return { price: item[0], volume: (item[1] * item[0]).toFixed(2) };
                                });
                                bids = iterArr.map(function (_, index) {
                                    var _a;
                                    var item = (_a = tick.bids) === null || _a === void 0 ? void 0 : _a[index];
                                    return { price: item[0], volume: (item[1] * item[0]).toFixed(2) };
                                });
                                this.onOrderbook({ asks: asks, bids: bids });
                            }
                            if (ping) {
                                (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({ pong: ping }));
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    return HuobiSocket;
}(DefaultSocket));

var HyperLiquidSocket = /** @class */ (function (_super) {
    __extends(HyperLiquidSocket, _super);
    function HyperLiquidSocket(options) {
        var _this = this;
        var futuresUrl = "wss://api.hyperliquid.xyz/ws";
        var spotUrl = "wss://api.hyperliquid.xyz/ws";
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "coin1", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "coin2", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(HyperLiquidSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new HyperLiquidSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(HyperLiquidSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            var _b, _c;
            if (!this.coin) {
                return;
            }
            _a = this.coin.split(' '), this.coin1 = _a[0], this.coin2 = _a[1];
            //@ts-ignore
            this.divide = +((_b = this.coin1.match(/^10+/g)) === null || _b === void 0 ? void 0 : _b.at(0)) || 1;
            (_c = this.ws) === null || _c === void 0 ? void 0 : _c.send(JSON.stringify({
                "method": "subscribe",
                "subscription": { "type": "l2Book", "coin": this.coin2 }
            }));
        }
    });
    Object.defineProperty(HyperLiquidSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "subscribe",
                "subscription": { "type": "l2Book", "coin": this.coin }
            }));
        }
    });
    Object.defineProperty(HyperLiquidSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b;
            var _c = JSON.parse(event.data), channel = _c.channel, data = _c.data;
            if (channel === "l2Book") {
                var asks = (_a = data.levels.at(1)) === null || _a === void 0 ? void 0 : _a.slice(0, 5).map(function (item) { return ({ price: item.px / _this.divide, volume: (item.px * item.sz).toFixed(2) }); });
                var bids = (_b = data.levels.at(0)) === null || _b === void 0 ? void 0 : _b.slice(0, 5).map(function (item) { return ({ price: item.px / _this.divide, volume: (item.px * item.sz).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(HyperLiquidSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b;
            var _c = JSON.parse(event.data), channel = _c.channel, data = _c.data;
            if (channel === "l2Book") {
                var asks = (_a = data.levels.at(1)) === null || _a === void 0 ? void 0 : _a.slice(0, 5).map(function (item) { return ({ price: item.px, volume: (item.px * item.sz).toFixed(2) }); });
                var bids = (_b = data.levels.at(0)) === null || _b === void 0 ? void 0 : _b.slice(0, 5).map(function (item) { return ({ price: item.px, volume: (item.px * item.sz).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    return HyperLiquidSocket;
}(DefaultSocket));

var KucoinSocket = /** @class */ (function (_super) {
    __extends(KucoinSocket, _super);
    function KucoinSocket(options) {
        var _this = this;
        var futuresToken = options.futuresToken, spotToken = options.spotToken;
        var futuresUrl = "wss://ws-api-futures.kucoin.com/endpoint?token=".concat(futuresToken);
        var spotUrl = "wss://ws-api-spot.kucoin.com/endpoint?token=".concat(spotToken);
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "spotToken", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "futuresToken", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.spotToken = spotToken;
        _this.futuresToken = futuresToken;
        return _this;
    }
    Object.defineProperty(KucoinSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var futuresToken, spotToken, baseUrl_1, futuresResposne, token, baseUrl_2, spotResponse, token;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 4, , 5]);
                            return [4 /*yield*/, userStore.getBaseUrl()];
                        case 1:
                            baseUrl_1 = _a.sent();
                            return [4 /*yield*/, withRetry(function () { return __awaiter(_this, void 0, void 0, function () {
                                    var _a, _b;
                                    var _c;
                                    return __generator(this, function (_d) {
                                        switch (_d.label) {
                                            case 0:
                                                _a = fetch;
                                                _b = ["".concat(baseUrl_1, "/kucoin/futures")];
                                                _c = {};
                                                return [4 /*yield*/, getHeaders()];
                                            case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_c.headers = _d.sent(),
                                                        _c)]))];
                                            case 2: return [2 /*return*/, _d.sent()];
                                        }
                                    });
                                }); })];
                        case 2:
                            futuresResposne = _a.sent();
                            return [4 /*yield*/, futuresResposne.json()];
                        case 3:
                            token = (_a.sent()).token;
                            if (token) {
                                localStorage.setItem('kucoin:futures:token', token);
                                futuresToken = token;
                            }
                            else {
                                futuresToken = localStorage.getItem('kucoin:futures:token');
                            }
                            return [3 /*break*/, 5];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 5];
                        case 5:
                            _a.trys.push([5, 9, , 10]);
                            return [4 /*yield*/, userStore.getBaseUrl()];
                        case 6:
                            baseUrl_2 = _a.sent();
                            return [4 /*yield*/, withRetry(function () { return __awaiter(_this, void 0, void 0, function () {
                                    var _a, _b;
                                    var _c;
                                    return __generator(this, function (_d) {
                                        switch (_d.label) {
                                            case 0:
                                                _a = fetch;
                                                _b = ["".concat(baseUrl_2, "/kucoin/spot")];
                                                _c = {};
                                                return [4 /*yield*/, getHeaders()];
                                            case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_c.headers = _d.sent(),
                                                        _c)]))];
                                            case 2: return [2 /*return*/, _d.sent()];
                                        }
                                    });
                                }); })];
                        case 7:
                            spotResponse = _a.sent();
                            return [4 /*yield*/, spotResponse.json()];
                        case 8:
                            token = (_a.sent()).token;
                            if (token) {
                                localStorage.setItem('kucoin:spot:token', token);
                                spotToken = token;
                            }
                            else {
                                spotToken = localStorage.getItem('kucoin:spot:token');
                            }
                            return [3 /*break*/, 10];
                        case 9:
                            _a.sent();
                            return [3 /*break*/, 10];
                        case 10: return [2 /*return*/, new KucoinSocket(__assign(__assign({}, options), { futuresToken: futuresToken, spotToken: spotToken }))];
                    }
                });
            });
        }
    });
    Object.defineProperty(KucoinSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "type": "subscribe",
                "topic": "/contractMarket/level2Depth5:".concat(this.coin)
            }));
            this.futuresInterval = setInterval(function () {
                var _a, _b;
                return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({
                    id: _this.futuresToken,
                    type: "ping"
                })));
            }, 5000);
        }
    });
    Object.defineProperty(KucoinSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                id: this.spotToken,
                "type": "subscribe",
                "topic": "/spotMarket/level2Depth5:".concat(this.coin)
            }));
            if (!this.spotInterval)
                this.spotInterval = setInterval(function () {
                    var _a, _b;
                    return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({
                        id: _this.spotToken,
                        type: "ping"
                    })));
                }, 5000);
        }
    });
    Object.defineProperty(KucoinSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b;
            var _c = JSON.parse(event.data), subject = _c.subject, data = _c.data;
            if (subject === null || subject === void 0 ? void 0 : subject.includes("level2")) {
                var asks = (_a = data === null || data === void 0 ? void 0 : data.asks) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                var bids = (_b = data === null || data === void 0 ? void 0 : data.bids) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(KucoinSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b;
            var _c = JSON.parse(event.data), subject = _c.subject, id = _c.id, type = _c.type, data = _c.data;
            if (subject === null || subject === void 0 ? void 0 : subject.includes("level2")) {
                var asks = (_a = data === null || data === void 0 ? void 0 : data.asks) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                var bids = (_b = data === null || data === void 0 ? void 0 : data.bids) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
            else if (id && type == 'welcome') {
                clearInterval(this.spotInterval);
                this.spotInterval = setInterval(function () {
                    var _a;
                    (_a = _this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                        id: id,
                        type: "ping"
                    }));
                }, 2000);
            }
        }
    });
    Object.defineProperty(KucoinSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    Object.defineProperty(KucoinSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    return KucoinSocket;
}(DefaultSocket));

var LighterSocket = /** @class */ (function (_super) {
    __extends(LighterSocket, _super);
    function LighterSocket(options) {
        var coin = options.coin;
        var futuresUrl = "https://mainnet.zklighter.elliot.ai/api/v1/orderBookOrders?market_id=".concat(coin, "&limit=100");
        var spotUrl = "";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl, noFuturesSocket: true, noSpotSocket: true })) || this;
    }
    Object.defineProperty(LighterSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new LighterSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(LighterSocket.prototype, "onError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(LighterSocket.prototype, "onOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(LighterSocket.prototype, "onClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { }
    });
    Object.defineProperty(LighterSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            var asksObj = {};
            var bidsObj = {};
            var asksResLength = 0;
            var bidsResLength = 0;
            var asksIndex = 0;
            var bidsIndex = 0;
            var asksLength = message.asks.length;
            var bidsLength = message.bids.length;
            while (asksIndex < asksLength) {
                var item = message.asks[asksIndex];
                if (!asksObj[item.price]) {
                    asksResLength += 1;
                    if (asksResLength > 5)
                        break;
                    asksObj[item.price] = +item.remaining_base_amount;
                }
                else
                    asksObj[item.price] += +item.remaining_base_amount;
                asksIndex += 1;
            }
            while (bidsIndex < bidsLength) {
                var item = message.bids[bidsIndex];
                if (!bidsObj[item.price]) {
                    bidsResLength += 1;
                    if (bidsResLength > 5)
                        break;
                    bidsObj[item.price] = +item.remaining_base_amount;
                }
                else
                    bidsObj[item.price] += +item.remaining_base_amount;
                bidsIndex += 1;
            }
            var asks = Object.keys(asksObj).map(function (key) { return ({ price: +key, volume: (+key * asksObj[key]).toFixed(2) }); });
            var bids = Object.keys(bidsObj).map(function (key) { return ({ price: +key, volume: (+key * bidsObj[key]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    Object.defineProperty(LighterSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
        }
    });
    return LighterSocket;
}(DefaultSocket));

/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
// @ts-nocheck
// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;
// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});
$root.PrivateAccountV3Api = (function () {
    /**
     * Properties of a PrivateAccountV3Api.
     * @exports IPrivateAccountV3Api
     * @interface IPrivateAccountV3Api
     * @property {string|null} [vcoinName] PrivateAccountV3Api vcoinName
     * @property {string|null} [coinId] PrivateAccountV3Api coinId
     * @property {string|null} [balanceAmount] PrivateAccountV3Api balanceAmount
     * @property {string|null} [balanceAmountChange] PrivateAccountV3Api balanceAmountChange
     * @property {string|null} [frozenAmount] PrivateAccountV3Api frozenAmount
     * @property {string|null} [frozenAmountChange] PrivateAccountV3Api frozenAmountChange
     * @property {string|null} [type] PrivateAccountV3Api type
     * @property {number|Long|null} [time] PrivateAccountV3Api time
     */
    /**
     * Constructs a new PrivateAccountV3Api.
     * @exports PrivateAccountV3Api
     * @classdesc Represents a PrivateAccountV3Api.
     * @implements IPrivateAccountV3Api
     * @constructor
     * @param {IPrivateAccountV3Api=} [properties] Properties to set
     */
    function PrivateAccountV3Api(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PrivateAccountV3Api vcoinName.
     * @member {string} vcoinName
     * @memberof PrivateAccountV3Api
     * @instance
     */
    PrivateAccountV3Api.prototype.vcoinName = "";
    /**
     * PrivateAccountV3Api coinId.
     * @member {string} coinId
     * @memberof PrivateAccountV3Api
     * @instance
     */
    PrivateAccountV3Api.prototype.coinId = "";
    /**
     * PrivateAccountV3Api balanceAmount.
     * @member {string} balanceAmount
     * @memberof PrivateAccountV3Api
     * @instance
     */
    PrivateAccountV3Api.prototype.balanceAmount = "";
    /**
     * PrivateAccountV3Api balanceAmountChange.
     * @member {string} balanceAmountChange
     * @memberof PrivateAccountV3Api
     * @instance
     */
    PrivateAccountV3Api.prototype.balanceAmountChange = "";
    /**
     * PrivateAccountV3Api frozenAmount.
     * @member {string} frozenAmount
     * @memberof PrivateAccountV3Api
     * @instance
     */
    PrivateAccountV3Api.prototype.frozenAmount = "";
    /**
     * PrivateAccountV3Api frozenAmountChange.
     * @member {string} frozenAmountChange
     * @memberof PrivateAccountV3Api
     * @instance
     */
    PrivateAccountV3Api.prototype.frozenAmountChange = "";
    /**
     * PrivateAccountV3Api type.
     * @member {string} type
     * @memberof PrivateAccountV3Api
     * @instance
     */
    PrivateAccountV3Api.prototype.type = "";
    /**
     * PrivateAccountV3Api time.
     * @member {number|Long} time
     * @memberof PrivateAccountV3Api
     * @instance
     */
    PrivateAccountV3Api.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    /**
     * Creates a new PrivateAccountV3Api instance using the specified properties.
     * @function create
     * @memberof PrivateAccountV3Api
     * @static
     * @param {IPrivateAccountV3Api=} [properties] Properties to set
     * @returns {PrivateAccountV3Api} PrivateAccountV3Api instance
     */
    PrivateAccountV3Api.create = function create(properties) {
        return new PrivateAccountV3Api(properties);
    };
    /**
     * Encodes the specified PrivateAccountV3Api message. Does not implicitly {@link PrivateAccountV3Api.verify|verify} messages.
     * @function encode
     * @memberof PrivateAccountV3Api
     * @static
     * @param {IPrivateAccountV3Api} message PrivateAccountV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PrivateAccountV3Api.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.vcoinName != null && Object.hasOwnProperty.call(message, "vcoinName"))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.vcoinName);
        if (message.coinId != null && Object.hasOwnProperty.call(message, "coinId"))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.coinId);
        if (message.balanceAmount != null && Object.hasOwnProperty.call(message, "balanceAmount"))
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.balanceAmount);
        if (message.balanceAmountChange != null && Object.hasOwnProperty.call(message, "balanceAmountChange"))
            writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.balanceAmountChange);
        if (message.frozenAmount != null && Object.hasOwnProperty.call(message, "frozenAmount"))
            writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.frozenAmount);
        if (message.frozenAmountChange != null && Object.hasOwnProperty.call(message, "frozenAmountChange"))
            writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.frozenAmountChange);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.type);
        if (message.time != null && Object.hasOwnProperty.call(message, "time"))
            writer.uint32(/* id 8, wireType 0 =*/ 64).int64(message.time);
        return writer;
    };
    /**
     * Encodes the specified PrivateAccountV3Api message, length delimited. Does not implicitly {@link PrivateAccountV3Api.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PrivateAccountV3Api
     * @static
     * @param {IPrivateAccountV3Api} message PrivateAccountV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PrivateAccountV3Api.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PrivateAccountV3Api message from the specified reader or buffer.
     * @function decode
     * @memberof PrivateAccountV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PrivateAccountV3Api} PrivateAccountV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PrivateAccountV3Api.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PrivateAccountV3Api();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    message.vcoinName = reader.string();
                    break;
                }
                case 2: {
                    message.coinId = reader.string();
                    break;
                }
                case 3: {
                    message.balanceAmount = reader.string();
                    break;
                }
                case 4: {
                    message.balanceAmountChange = reader.string();
                    break;
                }
                case 5: {
                    message.frozenAmount = reader.string();
                    break;
                }
                case 6: {
                    message.frozenAmountChange = reader.string();
                    break;
                }
                case 7: {
                    message.type = reader.string();
                    break;
                }
                case 8: {
                    message.time = reader.int64();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PrivateAccountV3Api message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PrivateAccountV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PrivateAccountV3Api} PrivateAccountV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PrivateAccountV3Api.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PrivateAccountV3Api message.
     * @function verify
     * @memberof PrivateAccountV3Api
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PrivateAccountV3Api.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.vcoinName != null && message.hasOwnProperty("vcoinName"))
            if (!$util.isString(message.vcoinName))
                return "vcoinName: string expected";
        if (message.coinId != null && message.hasOwnProperty("coinId"))
            if (!$util.isString(message.coinId))
                return "coinId: string expected";
        if (message.balanceAmount != null && message.hasOwnProperty("balanceAmount"))
            if (!$util.isString(message.balanceAmount))
                return "balanceAmount: string expected";
        if (message.balanceAmountChange != null && message.hasOwnProperty("balanceAmountChange"))
            if (!$util.isString(message.balanceAmountChange))
                return "balanceAmountChange: string expected";
        if (message.frozenAmount != null && message.hasOwnProperty("frozenAmount"))
            if (!$util.isString(message.frozenAmount))
                return "frozenAmount: string expected";
        if (message.frozenAmountChange != null && message.hasOwnProperty("frozenAmountChange"))
            if (!$util.isString(message.frozenAmountChange))
                return "frozenAmountChange: string expected";
        if (message.type != null && message.hasOwnProperty("type"))
            if (!$util.isString(message.type))
                return "type: string expected";
        if (message.time != null && message.hasOwnProperty("time"))
            if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
                return "time: integer|Long expected";
        return null;
    };
    /**
     * Creates a PrivateAccountV3Api message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PrivateAccountV3Api
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PrivateAccountV3Api} PrivateAccountV3Api
     */
    PrivateAccountV3Api.fromObject = function fromObject(object) {
        if (object instanceof $root.PrivateAccountV3Api)
            return object;
        var message = new $root.PrivateAccountV3Api();
        if (object.vcoinName != null)
            message.vcoinName = String(object.vcoinName);
        if (object.coinId != null)
            message.coinId = String(object.coinId);
        if (object.balanceAmount != null)
            message.balanceAmount = String(object.balanceAmount);
        if (object.balanceAmountChange != null)
            message.balanceAmountChange = String(object.balanceAmountChange);
        if (object.frozenAmount != null)
            message.frozenAmount = String(object.frozenAmount);
        if (object.frozenAmountChange != null)
            message.frozenAmountChange = String(object.frozenAmountChange);
        if (object.type != null)
            message.type = String(object.type);
        if (object.time != null)
            if ($util.Long)
                (message.time = $util.Long.fromValue(object.time)).unsigned = false;
            else if (typeof object.time === "string")
                message.time = parseInt(object.time, 10);
            else if (typeof object.time === "number")
                message.time = object.time;
            else if (typeof object.time === "object")
                message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
        return message;
    };
    /**
     * Creates a plain object from a PrivateAccountV3Api message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PrivateAccountV3Api
     * @static
     * @param {PrivateAccountV3Api} message PrivateAccountV3Api
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PrivateAccountV3Api.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.vcoinName = "";
            object.coinId = "";
            object.balanceAmount = "";
            object.balanceAmountChange = "";
            object.frozenAmount = "";
            object.frozenAmountChange = "";
            object.type = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            }
            else
                object.time = options.longs === String ? "0" : 0;
        }
        if (message.vcoinName != null && message.hasOwnProperty("vcoinName"))
            object.vcoinName = message.vcoinName;
        if (message.coinId != null && message.hasOwnProperty("coinId"))
            object.coinId = message.coinId;
        if (message.balanceAmount != null && message.hasOwnProperty("balanceAmount"))
            object.balanceAmount = message.balanceAmount;
        if (message.balanceAmountChange != null && message.hasOwnProperty("balanceAmountChange"))
            object.balanceAmountChange = message.balanceAmountChange;
        if (message.frozenAmount != null && message.hasOwnProperty("frozenAmount"))
            object.frozenAmount = message.frozenAmount;
        if (message.frozenAmountChange != null && message.hasOwnProperty("frozenAmountChange"))
            object.frozenAmountChange = message.frozenAmountChange;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        if (message.time != null && message.hasOwnProperty("time"))
            if (typeof message.time === "number")
                object.time = options.longs === String ? String(message.time) : message.time;
            else
                object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
        return object;
    };
    /**
     * Converts this PrivateAccountV3Api to JSON.
     * @function toJSON
     * @memberof PrivateAccountV3Api
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PrivateAccountV3Api.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PrivateAccountV3Api
     * @function getTypeUrl
     * @memberof PrivateAccountV3Api
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PrivateAccountV3Api.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PrivateAccountV3Api";
    };
    return PrivateAccountV3Api;
})();
$root.PrivateDealsV3Api = (function () {
    /**
     * Properties of a PrivateDealsV3Api.
     * @exports IPrivateDealsV3Api
     * @interface IPrivateDealsV3Api
     * @property {string|null} [price] PrivateDealsV3Api price
     * @property {string|null} [quantity] PrivateDealsV3Api quantity
     * @property {string|null} [amount] PrivateDealsV3Api amount
     * @property {number|null} [tradeType] PrivateDealsV3Api tradeType
     * @property {boolean|null} [isMaker] PrivateDealsV3Api isMaker
     * @property {boolean|null} [isSelfTrade] PrivateDealsV3Api isSelfTrade
     * @property {string|null} [tradeId] PrivateDealsV3Api tradeId
     * @property {string|null} [clientOrderId] PrivateDealsV3Api clientOrderId
     * @property {string|null} [orderId] PrivateDealsV3Api orderId
     * @property {string|null} [feeAmount] PrivateDealsV3Api feeAmount
     * @property {string|null} [feeCurrency] PrivateDealsV3Api feeCurrency
     * @property {number|Long|null} [time] PrivateDealsV3Api time
     */
    /**
     * Constructs a new PrivateDealsV3Api.
     * @exports PrivateDealsV3Api
     * @classdesc Represents a PrivateDealsV3Api.
     * @implements IPrivateDealsV3Api
     * @constructor
     * @param {IPrivateDealsV3Api=} [properties] Properties to set
     */
    function PrivateDealsV3Api(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PrivateDealsV3Api price.
     * @member {string} price
     * @memberof PrivateDealsV3Api
     * @instance
     */
    PrivateDealsV3Api.prototype.price = "";
    /**
     * PrivateDealsV3Api quantity.
     * @member {string} quantity
     * @memberof PrivateDealsV3Api
     * @instance
     */
    PrivateDealsV3Api.prototype.quantity = "";
    /**
     * PrivateDealsV3Api amount.
     * @member {string} amount
     * @memberof PrivateDealsV3Api
     * @instance
     */
    PrivateDealsV3Api.prototype.amount = "";
    /**
     * PrivateDealsV3Api tradeType.
     * @member {number} tradeType
     * @memberof PrivateDealsV3Api
     * @instance
     */
    PrivateDealsV3Api.prototype.tradeType = 0;
    /**
     * PrivateDealsV3Api isMaker.
     * @member {boolean} isMaker
     * @memberof PrivateDealsV3Api
     * @instance
     */
    PrivateDealsV3Api.prototype.isMaker = false;
    /**
     * PrivateDealsV3Api isSelfTrade.
     * @member {boolean} isSelfTrade
     * @memberof PrivateDealsV3Api
     * @instance
     */
    PrivateDealsV3Api.prototype.isSelfTrade = false;
    /**
     * PrivateDealsV3Api tradeId.
     * @member {string} tradeId
     * @memberof PrivateDealsV3Api
     * @instance
     */
    PrivateDealsV3Api.prototype.tradeId = "";
    /**
     * PrivateDealsV3Api clientOrderId.
     * @member {string} clientOrderId
     * @memberof PrivateDealsV3Api
     * @instance
     */
    PrivateDealsV3Api.prototype.clientOrderId = "";
    /**
     * PrivateDealsV3Api orderId.
     * @member {string} orderId
     * @memberof PrivateDealsV3Api
     * @instance
     */
    PrivateDealsV3Api.prototype.orderId = "";
    /**
     * PrivateDealsV3Api feeAmount.
     * @member {string} feeAmount
     * @memberof PrivateDealsV3Api
     * @instance
     */
    PrivateDealsV3Api.prototype.feeAmount = "";
    /**
     * PrivateDealsV3Api feeCurrency.
     * @member {string} feeCurrency
     * @memberof PrivateDealsV3Api
     * @instance
     */
    PrivateDealsV3Api.prototype.feeCurrency = "";
    /**
     * PrivateDealsV3Api time.
     * @member {number|Long} time
     * @memberof PrivateDealsV3Api
     * @instance
     */
    PrivateDealsV3Api.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    /**
     * Creates a new PrivateDealsV3Api instance using the specified properties.
     * @function create
     * @memberof PrivateDealsV3Api
     * @static
     * @param {IPrivateDealsV3Api=} [properties] Properties to set
     * @returns {PrivateDealsV3Api} PrivateDealsV3Api instance
     */
    PrivateDealsV3Api.create = function create(properties) {
        return new PrivateDealsV3Api(properties);
    };
    /**
     * Encodes the specified PrivateDealsV3Api message. Does not implicitly {@link PrivateDealsV3Api.verify|verify} messages.
     * @function encode
     * @memberof PrivateDealsV3Api
     * @static
     * @param {IPrivateDealsV3Api} message PrivateDealsV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PrivateDealsV3Api.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.price);
        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.quantity);
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.amount);
        if (message.tradeType != null && Object.hasOwnProperty.call(message, "tradeType"))
            writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.tradeType);
        if (message.isMaker != null && Object.hasOwnProperty.call(message, "isMaker"))
            writer.uint32(/* id 5, wireType 0 =*/ 40).bool(message.isMaker);
        if (message.isSelfTrade != null && Object.hasOwnProperty.call(message, "isSelfTrade"))
            writer.uint32(/* id 6, wireType 0 =*/ 48).bool(message.isSelfTrade);
        if (message.tradeId != null && Object.hasOwnProperty.call(message, "tradeId"))
            writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.tradeId);
        if (message.clientOrderId != null && Object.hasOwnProperty.call(message, "clientOrderId"))
            writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.clientOrderId);
        if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
            writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.orderId);
        if (message.feeAmount != null && Object.hasOwnProperty.call(message, "feeAmount"))
            writer.uint32(/* id 10, wireType 2 =*/ 82).string(message.feeAmount);
        if (message.feeCurrency != null && Object.hasOwnProperty.call(message, "feeCurrency"))
            writer.uint32(/* id 11, wireType 2 =*/ 90).string(message.feeCurrency);
        if (message.time != null && Object.hasOwnProperty.call(message, "time"))
            writer.uint32(/* id 12, wireType 0 =*/ 96).int64(message.time);
        return writer;
    };
    /**
     * Encodes the specified PrivateDealsV3Api message, length delimited. Does not implicitly {@link PrivateDealsV3Api.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PrivateDealsV3Api
     * @static
     * @param {IPrivateDealsV3Api} message PrivateDealsV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PrivateDealsV3Api.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PrivateDealsV3Api message from the specified reader or buffer.
     * @function decode
     * @memberof PrivateDealsV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PrivateDealsV3Api} PrivateDealsV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PrivateDealsV3Api.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PrivateDealsV3Api();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    message.price = reader.string();
                    break;
                }
                case 2: {
                    message.quantity = reader.string();
                    break;
                }
                case 3: {
                    message.amount = reader.string();
                    break;
                }
                case 4: {
                    message.tradeType = reader.int32();
                    break;
                }
                case 5: {
                    message.isMaker = reader.bool();
                    break;
                }
                case 6: {
                    message.isSelfTrade = reader.bool();
                    break;
                }
                case 7: {
                    message.tradeId = reader.string();
                    break;
                }
                case 8: {
                    message.clientOrderId = reader.string();
                    break;
                }
                case 9: {
                    message.orderId = reader.string();
                    break;
                }
                case 10: {
                    message.feeAmount = reader.string();
                    break;
                }
                case 11: {
                    message.feeCurrency = reader.string();
                    break;
                }
                case 12: {
                    message.time = reader.int64();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PrivateDealsV3Api message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PrivateDealsV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PrivateDealsV3Api} PrivateDealsV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PrivateDealsV3Api.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PrivateDealsV3Api message.
     * @function verify
     * @memberof PrivateDealsV3Api
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PrivateDealsV3Api.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.price != null && message.hasOwnProperty("price"))
            if (!$util.isString(message.price))
                return "price: string expected";
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (!$util.isString(message.quantity))
                return "quantity: string expected";
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (!$util.isString(message.amount))
                return "amount: string expected";
        if (message.tradeType != null && message.hasOwnProperty("tradeType"))
            if (!$util.isInteger(message.tradeType))
                return "tradeType: integer expected";
        if (message.isMaker != null && message.hasOwnProperty("isMaker"))
            if (typeof message.isMaker !== "boolean")
                return "isMaker: boolean expected";
        if (message.isSelfTrade != null && message.hasOwnProperty("isSelfTrade"))
            if (typeof message.isSelfTrade !== "boolean")
                return "isSelfTrade: boolean expected";
        if (message.tradeId != null && message.hasOwnProperty("tradeId"))
            if (!$util.isString(message.tradeId))
                return "tradeId: string expected";
        if (message.clientOrderId != null && message.hasOwnProperty("clientOrderId"))
            if (!$util.isString(message.clientOrderId))
                return "clientOrderId: string expected";
        if (message.orderId != null && message.hasOwnProperty("orderId"))
            if (!$util.isString(message.orderId))
                return "orderId: string expected";
        if (message.feeAmount != null && message.hasOwnProperty("feeAmount"))
            if (!$util.isString(message.feeAmount))
                return "feeAmount: string expected";
        if (message.feeCurrency != null && message.hasOwnProperty("feeCurrency"))
            if (!$util.isString(message.feeCurrency))
                return "feeCurrency: string expected";
        if (message.time != null && message.hasOwnProperty("time"))
            if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
                return "time: integer|Long expected";
        return null;
    };
    /**
     * Creates a PrivateDealsV3Api message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PrivateDealsV3Api
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PrivateDealsV3Api} PrivateDealsV3Api
     */
    PrivateDealsV3Api.fromObject = function fromObject(object) {
        if (object instanceof $root.PrivateDealsV3Api)
            return object;
        var message = new $root.PrivateDealsV3Api();
        if (object.price != null)
            message.price = String(object.price);
        if (object.quantity != null)
            message.quantity = String(object.quantity);
        if (object.amount != null)
            message.amount = String(object.amount);
        if (object.tradeType != null)
            message.tradeType = object.tradeType | 0;
        if (object.isMaker != null)
            message.isMaker = Boolean(object.isMaker);
        if (object.isSelfTrade != null)
            message.isSelfTrade = Boolean(object.isSelfTrade);
        if (object.tradeId != null)
            message.tradeId = String(object.tradeId);
        if (object.clientOrderId != null)
            message.clientOrderId = String(object.clientOrderId);
        if (object.orderId != null)
            message.orderId = String(object.orderId);
        if (object.feeAmount != null)
            message.feeAmount = String(object.feeAmount);
        if (object.feeCurrency != null)
            message.feeCurrency = String(object.feeCurrency);
        if (object.time != null)
            if ($util.Long)
                (message.time = $util.Long.fromValue(object.time)).unsigned = false;
            else if (typeof object.time === "string")
                message.time = parseInt(object.time, 10);
            else if (typeof object.time === "number")
                message.time = object.time;
            else if (typeof object.time === "object")
                message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
        return message;
    };
    /**
     * Creates a plain object from a PrivateDealsV3Api message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PrivateDealsV3Api
     * @static
     * @param {PrivateDealsV3Api} message PrivateDealsV3Api
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PrivateDealsV3Api.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.price = "";
            object.quantity = "";
            object.amount = "";
            object.tradeType = 0;
            object.isMaker = false;
            object.isSelfTrade = false;
            object.tradeId = "";
            object.clientOrderId = "";
            object.orderId = "";
            object.feeAmount = "";
            object.feeCurrency = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            }
            else
                object.time = options.longs === String ? "0" : 0;
        }
        if (message.price != null && message.hasOwnProperty("price"))
            object.price = message.price;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            object.quantity = message.quantity;
        if (message.amount != null && message.hasOwnProperty("amount"))
            object.amount = message.amount;
        if (message.tradeType != null && message.hasOwnProperty("tradeType"))
            object.tradeType = message.tradeType;
        if (message.isMaker != null && message.hasOwnProperty("isMaker"))
            object.isMaker = message.isMaker;
        if (message.isSelfTrade != null && message.hasOwnProperty("isSelfTrade"))
            object.isSelfTrade = message.isSelfTrade;
        if (message.tradeId != null && message.hasOwnProperty("tradeId"))
            object.tradeId = message.tradeId;
        if (message.clientOrderId != null && message.hasOwnProperty("clientOrderId"))
            object.clientOrderId = message.clientOrderId;
        if (message.orderId != null && message.hasOwnProperty("orderId"))
            object.orderId = message.orderId;
        if (message.feeAmount != null && message.hasOwnProperty("feeAmount"))
            object.feeAmount = message.feeAmount;
        if (message.feeCurrency != null && message.hasOwnProperty("feeCurrency"))
            object.feeCurrency = message.feeCurrency;
        if (message.time != null && message.hasOwnProperty("time"))
            if (typeof message.time === "number")
                object.time = options.longs === String ? String(message.time) : message.time;
            else
                object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
        return object;
    };
    /**
     * Converts this PrivateDealsV3Api to JSON.
     * @function toJSON
     * @memberof PrivateDealsV3Api
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PrivateDealsV3Api.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PrivateDealsV3Api
     * @function getTypeUrl
     * @memberof PrivateDealsV3Api
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PrivateDealsV3Api.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PrivateDealsV3Api";
    };
    return PrivateDealsV3Api;
})();
$root.PrivateOrdersV3Api = (function () {
    /**
     * Properties of a PrivateOrdersV3Api.
     * @exports IPrivateOrdersV3Api
     * @interface IPrivateOrdersV3Api
     * @property {string|null} [id] PrivateOrdersV3Api id
     * @property {string|null} [clientId] PrivateOrdersV3Api clientId
     * @property {string|null} [price] PrivateOrdersV3Api price
     * @property {string|null} [quantity] PrivateOrdersV3Api quantity
     * @property {string|null} [amount] PrivateOrdersV3Api amount
     * @property {string|null} [avgPrice] PrivateOrdersV3Api avgPrice
     * @property {number|null} [orderType] PrivateOrdersV3Api orderType
     * @property {number|null} [tradeType] PrivateOrdersV3Api tradeType
     * @property {boolean|null} [isMaker] PrivateOrdersV3Api isMaker
     * @property {string|null} [remainAmount] PrivateOrdersV3Api remainAmount
     * @property {string|null} [remainQuantity] PrivateOrdersV3Api remainQuantity
     * @property {string|null} [lastDealQuantity] PrivateOrdersV3Api lastDealQuantity
     * @property {string|null} [cumulativeQuantity] PrivateOrdersV3Api cumulativeQuantity
     * @property {string|null} [cumulativeAmount] PrivateOrdersV3Api cumulativeAmount
     * @property {number|null} [status] PrivateOrdersV3Api status
     * @property {number|Long|null} [createTime] PrivateOrdersV3Api createTime
     * @property {string|null} [market] PrivateOrdersV3Api market
     * @property {number|null} [triggerType] PrivateOrdersV3Api triggerType
     * @property {string|null} [triggerPrice] PrivateOrdersV3Api triggerPrice
     * @property {number|null} [state] PrivateOrdersV3Api state
     * @property {string|null} [ocoId] PrivateOrdersV3Api ocoId
     * @property {string|null} [routeFactor] PrivateOrdersV3Api routeFactor
     * @property {string|null} [symbolId] PrivateOrdersV3Api symbolId
     * @property {string|null} [marketId] PrivateOrdersV3Api marketId
     * @property {string|null} [marketCurrencyId] PrivateOrdersV3Api marketCurrencyId
     * @property {string|null} [currencyId] PrivateOrdersV3Api currencyId
     */
    /**
     * Constructs a new PrivateOrdersV3Api.
     * @exports PrivateOrdersV3Api
     * @classdesc Represents a PrivateOrdersV3Api.
     * @implements IPrivateOrdersV3Api
     * @constructor
     * @param {IPrivateOrdersV3Api=} [properties] Properties to set
     */
    function PrivateOrdersV3Api(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PrivateOrdersV3Api id.
     * @member {string} id
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.id = "";
    /**
     * PrivateOrdersV3Api clientId.
     * @member {string} clientId
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.clientId = "";
    /**
     * PrivateOrdersV3Api price.
     * @member {string} price
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.price = "";
    /**
     * PrivateOrdersV3Api quantity.
     * @member {string} quantity
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.quantity = "";
    /**
     * PrivateOrdersV3Api amount.
     * @member {string} amount
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.amount = "";
    /**
     * PrivateOrdersV3Api avgPrice.
     * @member {string} avgPrice
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.avgPrice = "";
    /**
     * PrivateOrdersV3Api orderType.
     * @member {number} orderType
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.orderType = 0;
    /**
     * PrivateOrdersV3Api tradeType.
     * @member {number} tradeType
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.tradeType = 0;
    /**
     * PrivateOrdersV3Api isMaker.
     * @member {boolean} isMaker
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.isMaker = false;
    /**
     * PrivateOrdersV3Api remainAmount.
     * @member {string} remainAmount
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.remainAmount = "";
    /**
     * PrivateOrdersV3Api remainQuantity.
     * @member {string} remainQuantity
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.remainQuantity = "";
    /**
     * PrivateOrdersV3Api lastDealQuantity.
     * @member {string|null|undefined} lastDealQuantity
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.lastDealQuantity = null;
    /**
     * PrivateOrdersV3Api cumulativeQuantity.
     * @member {string} cumulativeQuantity
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.cumulativeQuantity = "";
    /**
     * PrivateOrdersV3Api cumulativeAmount.
     * @member {string} cumulativeAmount
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.cumulativeAmount = "";
    /**
     * PrivateOrdersV3Api status.
     * @member {number} status
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.status = 0;
    /**
     * PrivateOrdersV3Api createTime.
     * @member {number|Long} createTime
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.createTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    /**
     * PrivateOrdersV3Api market.
     * @member {string|null|undefined} market
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.market = null;
    /**
     * PrivateOrdersV3Api triggerType.
     * @member {number|null|undefined} triggerType
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.triggerType = null;
    /**
     * PrivateOrdersV3Api triggerPrice.
     * @member {string|null|undefined} triggerPrice
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.triggerPrice = null;
    /**
     * PrivateOrdersV3Api state.
     * @member {number|null|undefined} state
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.state = null;
    /**
     * PrivateOrdersV3Api ocoId.
     * @member {string|null|undefined} ocoId
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.ocoId = null;
    /**
     * PrivateOrdersV3Api routeFactor.
     * @member {string|null|undefined} routeFactor
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.routeFactor = null;
    /**
     * PrivateOrdersV3Api symbolId.
     * @member {string|null|undefined} symbolId
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.symbolId = null;
    /**
     * PrivateOrdersV3Api marketId.
     * @member {string|null|undefined} marketId
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.marketId = null;
    /**
     * PrivateOrdersV3Api marketCurrencyId.
     * @member {string|null|undefined} marketCurrencyId
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.marketCurrencyId = null;
    /**
     * PrivateOrdersV3Api currencyId.
     * @member {string|null|undefined} currencyId
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    PrivateOrdersV3Api.prototype.currencyId = null;
    // OneOf field names bound to virtual getters and setters
    var $oneOfFields;
    /**
     * PrivateOrdersV3Api _lastDealQuantity.
     * @member {"lastDealQuantity"|undefined} _lastDealQuantity
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    Object.defineProperty(PrivateOrdersV3Api.prototype, "_lastDealQuantity", {
        get: $util.oneOfGetter($oneOfFields = ["lastDealQuantity"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * PrivateOrdersV3Api _market.
     * @member {"market"|undefined} _market
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    Object.defineProperty(PrivateOrdersV3Api.prototype, "_market", {
        get: $util.oneOfGetter($oneOfFields = ["market"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * PrivateOrdersV3Api _triggerType.
     * @member {"triggerType"|undefined} _triggerType
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    Object.defineProperty(PrivateOrdersV3Api.prototype, "_triggerType", {
        get: $util.oneOfGetter($oneOfFields = ["triggerType"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * PrivateOrdersV3Api _triggerPrice.
     * @member {"triggerPrice"|undefined} _triggerPrice
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    Object.defineProperty(PrivateOrdersV3Api.prototype, "_triggerPrice", {
        get: $util.oneOfGetter($oneOfFields = ["triggerPrice"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * PrivateOrdersV3Api _state.
     * @member {"state"|undefined} _state
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    Object.defineProperty(PrivateOrdersV3Api.prototype, "_state", {
        get: $util.oneOfGetter($oneOfFields = ["state"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * PrivateOrdersV3Api _ocoId.
     * @member {"ocoId"|undefined} _ocoId
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    Object.defineProperty(PrivateOrdersV3Api.prototype, "_ocoId", {
        get: $util.oneOfGetter($oneOfFields = ["ocoId"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * PrivateOrdersV3Api _routeFactor.
     * @member {"routeFactor"|undefined} _routeFactor
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    Object.defineProperty(PrivateOrdersV3Api.prototype, "_routeFactor", {
        get: $util.oneOfGetter($oneOfFields = ["routeFactor"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * PrivateOrdersV3Api _symbolId.
     * @member {"symbolId"|undefined} _symbolId
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    Object.defineProperty(PrivateOrdersV3Api.prototype, "_symbolId", {
        get: $util.oneOfGetter($oneOfFields = ["symbolId"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * PrivateOrdersV3Api _marketId.
     * @member {"marketId"|undefined} _marketId
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    Object.defineProperty(PrivateOrdersV3Api.prototype, "_marketId", {
        get: $util.oneOfGetter($oneOfFields = ["marketId"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * PrivateOrdersV3Api _marketCurrencyId.
     * @member {"marketCurrencyId"|undefined} _marketCurrencyId
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    Object.defineProperty(PrivateOrdersV3Api.prototype, "_marketCurrencyId", {
        get: $util.oneOfGetter($oneOfFields = ["marketCurrencyId"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * PrivateOrdersV3Api _currencyId.
     * @member {"currencyId"|undefined} _currencyId
     * @memberof PrivateOrdersV3Api
     * @instance
     */
    Object.defineProperty(PrivateOrdersV3Api.prototype, "_currencyId", {
        get: $util.oneOfGetter($oneOfFields = ["currencyId"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * Creates a new PrivateOrdersV3Api instance using the specified properties.
     * @function create
     * @memberof PrivateOrdersV3Api
     * @static
     * @param {IPrivateOrdersV3Api=} [properties] Properties to set
     * @returns {PrivateOrdersV3Api} PrivateOrdersV3Api instance
     */
    PrivateOrdersV3Api.create = function create(properties) {
        return new PrivateOrdersV3Api(properties);
    };
    /**
     * Encodes the specified PrivateOrdersV3Api message. Does not implicitly {@link PrivateOrdersV3Api.verify|verify} messages.
     * @function encode
     * @memberof PrivateOrdersV3Api
     * @static
     * @param {IPrivateOrdersV3Api} message PrivateOrdersV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PrivateOrdersV3Api.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
        if (message.clientId != null && Object.hasOwnProperty.call(message, "clientId"))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.clientId);
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.price);
        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.quantity);
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.amount);
        if (message.avgPrice != null && Object.hasOwnProperty.call(message, "avgPrice"))
            writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.avgPrice);
        if (message.orderType != null && Object.hasOwnProperty.call(message, "orderType"))
            writer.uint32(/* id 7, wireType 0 =*/ 56).int32(message.orderType);
        if (message.tradeType != null && Object.hasOwnProperty.call(message, "tradeType"))
            writer.uint32(/* id 8, wireType 0 =*/ 64).int32(message.tradeType);
        if (message.isMaker != null && Object.hasOwnProperty.call(message, "isMaker"))
            writer.uint32(/* id 9, wireType 0 =*/ 72).bool(message.isMaker);
        if (message.remainAmount != null && Object.hasOwnProperty.call(message, "remainAmount"))
            writer.uint32(/* id 10, wireType 2 =*/ 82).string(message.remainAmount);
        if (message.remainQuantity != null && Object.hasOwnProperty.call(message, "remainQuantity"))
            writer.uint32(/* id 11, wireType 2 =*/ 90).string(message.remainQuantity);
        if (message.lastDealQuantity != null && Object.hasOwnProperty.call(message, "lastDealQuantity"))
            writer.uint32(/* id 12, wireType 2 =*/ 98).string(message.lastDealQuantity);
        if (message.cumulativeQuantity != null && Object.hasOwnProperty.call(message, "cumulativeQuantity"))
            writer.uint32(/* id 13, wireType 2 =*/ 106).string(message.cumulativeQuantity);
        if (message.cumulativeAmount != null && Object.hasOwnProperty.call(message, "cumulativeAmount"))
            writer.uint32(/* id 14, wireType 2 =*/ 114).string(message.cumulativeAmount);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(/* id 15, wireType 0 =*/ 120).int32(message.status);
        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
            writer.uint32(/* id 16, wireType 0 =*/ 128).int64(message.createTime);
        if (message.market != null && Object.hasOwnProperty.call(message, "market"))
            writer.uint32(/* id 17, wireType 2 =*/ 138).string(message.market);
        if (message.triggerType != null && Object.hasOwnProperty.call(message, "triggerType"))
            writer.uint32(/* id 18, wireType 0 =*/ 144).int32(message.triggerType);
        if (message.triggerPrice != null && Object.hasOwnProperty.call(message, "triggerPrice"))
            writer.uint32(/* id 19, wireType 2 =*/ 154).string(message.triggerPrice);
        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
            writer.uint32(/* id 20, wireType 0 =*/ 160).int32(message.state);
        if (message.ocoId != null && Object.hasOwnProperty.call(message, "ocoId"))
            writer.uint32(/* id 21, wireType 2 =*/ 170).string(message.ocoId);
        if (message.routeFactor != null && Object.hasOwnProperty.call(message, "routeFactor"))
            writer.uint32(/* id 22, wireType 2 =*/ 178).string(message.routeFactor);
        if (message.symbolId != null && Object.hasOwnProperty.call(message, "symbolId"))
            writer.uint32(/* id 23, wireType 2 =*/ 186).string(message.symbolId);
        if (message.marketId != null && Object.hasOwnProperty.call(message, "marketId"))
            writer.uint32(/* id 24, wireType 2 =*/ 194).string(message.marketId);
        if (message.marketCurrencyId != null && Object.hasOwnProperty.call(message, "marketCurrencyId"))
            writer.uint32(/* id 25, wireType 2 =*/ 202).string(message.marketCurrencyId);
        if (message.currencyId != null && Object.hasOwnProperty.call(message, "currencyId"))
            writer.uint32(/* id 26, wireType 2 =*/ 210).string(message.currencyId);
        return writer;
    };
    /**
     * Encodes the specified PrivateOrdersV3Api message, length delimited. Does not implicitly {@link PrivateOrdersV3Api.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PrivateOrdersV3Api
     * @static
     * @param {IPrivateOrdersV3Api} message PrivateOrdersV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PrivateOrdersV3Api.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PrivateOrdersV3Api message from the specified reader or buffer.
     * @function decode
     * @memberof PrivateOrdersV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PrivateOrdersV3Api} PrivateOrdersV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PrivateOrdersV3Api.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PrivateOrdersV3Api();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    message.id = reader.string();
                    break;
                }
                case 2: {
                    message.clientId = reader.string();
                    break;
                }
                case 3: {
                    message.price = reader.string();
                    break;
                }
                case 4: {
                    message.quantity = reader.string();
                    break;
                }
                case 5: {
                    message.amount = reader.string();
                    break;
                }
                case 6: {
                    message.avgPrice = reader.string();
                    break;
                }
                case 7: {
                    message.orderType = reader.int32();
                    break;
                }
                case 8: {
                    message.tradeType = reader.int32();
                    break;
                }
                case 9: {
                    message.isMaker = reader.bool();
                    break;
                }
                case 10: {
                    message.remainAmount = reader.string();
                    break;
                }
                case 11: {
                    message.remainQuantity = reader.string();
                    break;
                }
                case 12: {
                    message.lastDealQuantity = reader.string();
                    break;
                }
                case 13: {
                    message.cumulativeQuantity = reader.string();
                    break;
                }
                case 14: {
                    message.cumulativeAmount = reader.string();
                    break;
                }
                case 15: {
                    message.status = reader.int32();
                    break;
                }
                case 16: {
                    message.createTime = reader.int64();
                    break;
                }
                case 17: {
                    message.market = reader.string();
                    break;
                }
                case 18: {
                    message.triggerType = reader.int32();
                    break;
                }
                case 19: {
                    message.triggerPrice = reader.string();
                    break;
                }
                case 20: {
                    message.state = reader.int32();
                    break;
                }
                case 21: {
                    message.ocoId = reader.string();
                    break;
                }
                case 22: {
                    message.routeFactor = reader.string();
                    break;
                }
                case 23: {
                    message.symbolId = reader.string();
                    break;
                }
                case 24: {
                    message.marketId = reader.string();
                    break;
                }
                case 25: {
                    message.marketCurrencyId = reader.string();
                    break;
                }
                case 26: {
                    message.currencyId = reader.string();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PrivateOrdersV3Api message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PrivateOrdersV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PrivateOrdersV3Api} PrivateOrdersV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PrivateOrdersV3Api.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PrivateOrdersV3Api message.
     * @function verify
     * @memberof PrivateOrdersV3Api
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PrivateOrdersV3Api.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.clientId != null && message.hasOwnProperty("clientId"))
            if (!$util.isString(message.clientId))
                return "clientId: string expected";
        if (message.price != null && message.hasOwnProperty("price"))
            if (!$util.isString(message.price))
                return "price: string expected";
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (!$util.isString(message.quantity))
                return "quantity: string expected";
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (!$util.isString(message.amount))
                return "amount: string expected";
        if (message.avgPrice != null && message.hasOwnProperty("avgPrice"))
            if (!$util.isString(message.avgPrice))
                return "avgPrice: string expected";
        if (message.orderType != null && message.hasOwnProperty("orderType"))
            if (!$util.isInteger(message.orderType))
                return "orderType: integer expected";
        if (message.tradeType != null && message.hasOwnProperty("tradeType"))
            if (!$util.isInteger(message.tradeType))
                return "tradeType: integer expected";
        if (message.isMaker != null && message.hasOwnProperty("isMaker"))
            if (typeof message.isMaker !== "boolean")
                return "isMaker: boolean expected";
        if (message.remainAmount != null && message.hasOwnProperty("remainAmount"))
            if (!$util.isString(message.remainAmount))
                return "remainAmount: string expected";
        if (message.remainQuantity != null && message.hasOwnProperty("remainQuantity"))
            if (!$util.isString(message.remainQuantity))
                return "remainQuantity: string expected";
        if (message.lastDealQuantity != null && message.hasOwnProperty("lastDealQuantity")) {
            if (!$util.isString(message.lastDealQuantity))
                return "lastDealQuantity: string expected";
        }
        if (message.cumulativeQuantity != null && message.hasOwnProperty("cumulativeQuantity"))
            if (!$util.isString(message.cumulativeQuantity))
                return "cumulativeQuantity: string expected";
        if (message.cumulativeAmount != null && message.hasOwnProperty("cumulativeAmount"))
            if (!$util.isString(message.cumulativeAmount))
                return "cumulativeAmount: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            if (!$util.isInteger(message.status))
                return "status: integer expected";
        if (message.createTime != null && message.hasOwnProperty("createTime"))
            if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                return "createTime: integer|Long expected";
        if (message.market != null && message.hasOwnProperty("market")) {
            if (!$util.isString(message.market))
                return "market: string expected";
        }
        if (message.triggerType != null && message.hasOwnProperty("triggerType")) {
            if (!$util.isInteger(message.triggerType))
                return "triggerType: integer expected";
        }
        if (message.triggerPrice != null && message.hasOwnProperty("triggerPrice")) {
            if (!$util.isString(message.triggerPrice))
                return "triggerPrice: string expected";
        }
        if (message.state != null && message.hasOwnProperty("state")) {
            if (!$util.isInteger(message.state))
                return "state: integer expected";
        }
        if (message.ocoId != null && message.hasOwnProperty("ocoId")) {
            if (!$util.isString(message.ocoId))
                return "ocoId: string expected";
        }
        if (message.routeFactor != null && message.hasOwnProperty("routeFactor")) {
            if (!$util.isString(message.routeFactor))
                return "routeFactor: string expected";
        }
        if (message.symbolId != null && message.hasOwnProperty("symbolId")) {
            if (!$util.isString(message.symbolId))
                return "symbolId: string expected";
        }
        if (message.marketId != null && message.hasOwnProperty("marketId")) {
            if (!$util.isString(message.marketId))
                return "marketId: string expected";
        }
        if (message.marketCurrencyId != null && message.hasOwnProperty("marketCurrencyId")) {
            if (!$util.isString(message.marketCurrencyId))
                return "marketCurrencyId: string expected";
        }
        if (message.currencyId != null && message.hasOwnProperty("currencyId")) {
            if (!$util.isString(message.currencyId))
                return "currencyId: string expected";
        }
        return null;
    };
    /**
     * Creates a PrivateOrdersV3Api message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PrivateOrdersV3Api
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PrivateOrdersV3Api} PrivateOrdersV3Api
     */
    PrivateOrdersV3Api.fromObject = function fromObject(object) {
        if (object instanceof $root.PrivateOrdersV3Api)
            return object;
        var message = new $root.PrivateOrdersV3Api();
        if (object.id != null)
            message.id = String(object.id);
        if (object.clientId != null)
            message.clientId = String(object.clientId);
        if (object.price != null)
            message.price = String(object.price);
        if (object.quantity != null)
            message.quantity = String(object.quantity);
        if (object.amount != null)
            message.amount = String(object.amount);
        if (object.avgPrice != null)
            message.avgPrice = String(object.avgPrice);
        if (object.orderType != null)
            message.orderType = object.orderType | 0;
        if (object.tradeType != null)
            message.tradeType = object.tradeType | 0;
        if (object.isMaker != null)
            message.isMaker = Boolean(object.isMaker);
        if (object.remainAmount != null)
            message.remainAmount = String(object.remainAmount);
        if (object.remainQuantity != null)
            message.remainQuantity = String(object.remainQuantity);
        if (object.lastDealQuantity != null)
            message.lastDealQuantity = String(object.lastDealQuantity);
        if (object.cumulativeQuantity != null)
            message.cumulativeQuantity = String(object.cumulativeQuantity);
        if (object.cumulativeAmount != null)
            message.cumulativeAmount = String(object.cumulativeAmount);
        if (object.status != null)
            message.status = object.status | 0;
        if (object.createTime != null)
            if ($util.Long)
                (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
            else if (typeof object.createTime === "string")
                message.createTime = parseInt(object.createTime, 10);
            else if (typeof object.createTime === "number")
                message.createTime = object.createTime;
            else if (typeof object.createTime === "object")
                message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
        if (object.market != null)
            message.market = String(object.market);
        if (object.triggerType != null)
            message.triggerType = object.triggerType | 0;
        if (object.triggerPrice != null)
            message.triggerPrice = String(object.triggerPrice);
        if (object.state != null)
            message.state = object.state | 0;
        if (object.ocoId != null)
            message.ocoId = String(object.ocoId);
        if (object.routeFactor != null)
            message.routeFactor = String(object.routeFactor);
        if (object.symbolId != null)
            message.symbolId = String(object.symbolId);
        if (object.marketId != null)
            message.marketId = String(object.marketId);
        if (object.marketCurrencyId != null)
            message.marketCurrencyId = String(object.marketCurrencyId);
        if (object.currencyId != null)
            message.currencyId = String(object.currencyId);
        return message;
    };
    /**
     * Creates a plain object from a PrivateOrdersV3Api message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PrivateOrdersV3Api
     * @static
     * @param {PrivateOrdersV3Api} message PrivateOrdersV3Api
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PrivateOrdersV3Api.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.id = "";
            object.clientId = "";
            object.price = "";
            object.quantity = "";
            object.amount = "";
            object.avgPrice = "";
            object.orderType = 0;
            object.tradeType = 0;
            object.isMaker = false;
            object.remainAmount = "";
            object.remainQuantity = "";
            object.cumulativeQuantity = "";
            object.cumulativeAmount = "";
            object.status = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            }
            else
                object.createTime = options.longs === String ? "0" : 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.clientId != null && message.hasOwnProperty("clientId"))
            object.clientId = message.clientId;
        if (message.price != null && message.hasOwnProperty("price"))
            object.price = message.price;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            object.quantity = message.quantity;
        if (message.amount != null && message.hasOwnProperty("amount"))
            object.amount = message.amount;
        if (message.avgPrice != null && message.hasOwnProperty("avgPrice"))
            object.avgPrice = message.avgPrice;
        if (message.orderType != null && message.hasOwnProperty("orderType"))
            object.orderType = message.orderType;
        if (message.tradeType != null && message.hasOwnProperty("tradeType"))
            object.tradeType = message.tradeType;
        if (message.isMaker != null && message.hasOwnProperty("isMaker"))
            object.isMaker = message.isMaker;
        if (message.remainAmount != null && message.hasOwnProperty("remainAmount"))
            object.remainAmount = message.remainAmount;
        if (message.remainQuantity != null && message.hasOwnProperty("remainQuantity"))
            object.remainQuantity = message.remainQuantity;
        if (message.lastDealQuantity != null && message.hasOwnProperty("lastDealQuantity")) {
            object.lastDealQuantity = message.lastDealQuantity;
            if (options.oneofs)
                object._lastDealQuantity = "lastDealQuantity";
        }
        if (message.cumulativeQuantity != null && message.hasOwnProperty("cumulativeQuantity"))
            object.cumulativeQuantity = message.cumulativeQuantity;
        if (message.cumulativeAmount != null && message.hasOwnProperty("cumulativeAmount"))
            object.cumulativeAmount = message.cumulativeAmount;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = message.status;
        if (message.createTime != null && message.hasOwnProperty("createTime"))
            if (typeof message.createTime === "number")
                object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
            else
                object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
        if (message.market != null && message.hasOwnProperty("market")) {
            object.market = message.market;
            if (options.oneofs)
                object._market = "market";
        }
        if (message.triggerType != null && message.hasOwnProperty("triggerType")) {
            object.triggerType = message.triggerType;
            if (options.oneofs)
                object._triggerType = "triggerType";
        }
        if (message.triggerPrice != null && message.hasOwnProperty("triggerPrice")) {
            object.triggerPrice = message.triggerPrice;
            if (options.oneofs)
                object._triggerPrice = "triggerPrice";
        }
        if (message.state != null && message.hasOwnProperty("state")) {
            object.state = message.state;
            if (options.oneofs)
                object._state = "state";
        }
        if (message.ocoId != null && message.hasOwnProperty("ocoId")) {
            object.ocoId = message.ocoId;
            if (options.oneofs)
                object._ocoId = "ocoId";
        }
        if (message.routeFactor != null && message.hasOwnProperty("routeFactor")) {
            object.routeFactor = message.routeFactor;
            if (options.oneofs)
                object._routeFactor = "routeFactor";
        }
        if (message.symbolId != null && message.hasOwnProperty("symbolId")) {
            object.symbolId = message.symbolId;
            if (options.oneofs)
                object._symbolId = "symbolId";
        }
        if (message.marketId != null && message.hasOwnProperty("marketId")) {
            object.marketId = message.marketId;
            if (options.oneofs)
                object._marketId = "marketId";
        }
        if (message.marketCurrencyId != null && message.hasOwnProperty("marketCurrencyId")) {
            object.marketCurrencyId = message.marketCurrencyId;
            if (options.oneofs)
                object._marketCurrencyId = "marketCurrencyId";
        }
        if (message.currencyId != null && message.hasOwnProperty("currencyId")) {
            object.currencyId = message.currencyId;
            if (options.oneofs)
                object._currencyId = "currencyId";
        }
        return object;
    };
    /**
     * Converts this PrivateOrdersV3Api to JSON.
     * @function toJSON
     * @memberof PrivateOrdersV3Api
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PrivateOrdersV3Api.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PrivateOrdersV3Api
     * @function getTypeUrl
     * @memberof PrivateOrdersV3Api
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PrivateOrdersV3Api.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PrivateOrdersV3Api";
    };
    return PrivateOrdersV3Api;
})();
$root.PublicAggreBookTickerV3Api = (function () {
    /**
     * Properties of a PublicAggreBookTickerV3Api.
     * @exports IPublicAggreBookTickerV3Api
     * @interface IPublicAggreBookTickerV3Api
     * @property {string|null} [bidPrice] PublicAggreBookTickerV3Api bidPrice
     * @property {string|null} [bidQuantity] PublicAggreBookTickerV3Api bidQuantity
     * @property {string|null} [askPrice] PublicAggreBookTickerV3Api askPrice
     * @property {string|null} [askQuantity] PublicAggreBookTickerV3Api askQuantity
     */
    /**
     * Constructs a new PublicAggreBookTickerV3Api.
     * @exports PublicAggreBookTickerV3Api
     * @classdesc Represents a PublicAggreBookTickerV3Api.
     * @implements IPublicAggreBookTickerV3Api
     * @constructor
     * @param {IPublicAggreBookTickerV3Api=} [properties] Properties to set
     */
    function PublicAggreBookTickerV3Api(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicAggreBookTickerV3Api bidPrice.
     * @member {string} bidPrice
     * @memberof PublicAggreBookTickerV3Api
     * @instance
     */
    PublicAggreBookTickerV3Api.prototype.bidPrice = "";
    /**
     * PublicAggreBookTickerV3Api bidQuantity.
     * @member {string} bidQuantity
     * @memberof PublicAggreBookTickerV3Api
     * @instance
     */
    PublicAggreBookTickerV3Api.prototype.bidQuantity = "";
    /**
     * PublicAggreBookTickerV3Api askPrice.
     * @member {string} askPrice
     * @memberof PublicAggreBookTickerV3Api
     * @instance
     */
    PublicAggreBookTickerV3Api.prototype.askPrice = "";
    /**
     * PublicAggreBookTickerV3Api askQuantity.
     * @member {string} askQuantity
     * @memberof PublicAggreBookTickerV3Api
     * @instance
     */
    PublicAggreBookTickerV3Api.prototype.askQuantity = "";
    /**
     * Creates a new PublicAggreBookTickerV3Api instance using the specified properties.
     * @function create
     * @memberof PublicAggreBookTickerV3Api
     * @static
     * @param {IPublicAggreBookTickerV3Api=} [properties] Properties to set
     * @returns {PublicAggreBookTickerV3Api} PublicAggreBookTickerV3Api instance
     */
    PublicAggreBookTickerV3Api.create = function create(properties) {
        return new PublicAggreBookTickerV3Api(properties);
    };
    /**
     * Encodes the specified PublicAggreBookTickerV3Api message. Does not implicitly {@link PublicAggreBookTickerV3Api.verify|verify} messages.
     * @function encode
     * @memberof PublicAggreBookTickerV3Api
     * @static
     * @param {IPublicAggreBookTickerV3Api} message PublicAggreBookTickerV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicAggreBookTickerV3Api.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.bidPrice != null && Object.hasOwnProperty.call(message, "bidPrice"))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.bidPrice);
        if (message.bidQuantity != null && Object.hasOwnProperty.call(message, "bidQuantity"))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.bidQuantity);
        if (message.askPrice != null && Object.hasOwnProperty.call(message, "askPrice"))
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.askPrice);
        if (message.askQuantity != null && Object.hasOwnProperty.call(message, "askQuantity"))
            writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.askQuantity);
        return writer;
    };
    /**
     * Encodes the specified PublicAggreBookTickerV3Api message, length delimited. Does not implicitly {@link PublicAggreBookTickerV3Api.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicAggreBookTickerV3Api
     * @static
     * @param {IPublicAggreBookTickerV3Api} message PublicAggreBookTickerV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicAggreBookTickerV3Api.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicAggreBookTickerV3Api message from the specified reader or buffer.
     * @function decode
     * @memberof PublicAggreBookTickerV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicAggreBookTickerV3Api} PublicAggreBookTickerV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicAggreBookTickerV3Api.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicAggreBookTickerV3Api();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    message.bidPrice = reader.string();
                    break;
                }
                case 2: {
                    message.bidQuantity = reader.string();
                    break;
                }
                case 3: {
                    message.askPrice = reader.string();
                    break;
                }
                case 4: {
                    message.askQuantity = reader.string();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicAggreBookTickerV3Api message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicAggreBookTickerV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicAggreBookTickerV3Api} PublicAggreBookTickerV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicAggreBookTickerV3Api.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicAggreBookTickerV3Api message.
     * @function verify
     * @memberof PublicAggreBookTickerV3Api
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicAggreBookTickerV3Api.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.bidPrice != null && message.hasOwnProperty("bidPrice"))
            if (!$util.isString(message.bidPrice))
                return "bidPrice: string expected";
        if (message.bidQuantity != null && message.hasOwnProperty("bidQuantity"))
            if (!$util.isString(message.bidQuantity))
                return "bidQuantity: string expected";
        if (message.askPrice != null && message.hasOwnProperty("askPrice"))
            if (!$util.isString(message.askPrice))
                return "askPrice: string expected";
        if (message.askQuantity != null && message.hasOwnProperty("askQuantity"))
            if (!$util.isString(message.askQuantity))
                return "askQuantity: string expected";
        return null;
    };
    /**
     * Creates a PublicAggreBookTickerV3Api message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicAggreBookTickerV3Api
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicAggreBookTickerV3Api} PublicAggreBookTickerV3Api
     */
    PublicAggreBookTickerV3Api.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicAggreBookTickerV3Api)
            return object;
        var message = new $root.PublicAggreBookTickerV3Api();
        if (object.bidPrice != null)
            message.bidPrice = String(object.bidPrice);
        if (object.bidQuantity != null)
            message.bidQuantity = String(object.bidQuantity);
        if (object.askPrice != null)
            message.askPrice = String(object.askPrice);
        if (object.askQuantity != null)
            message.askQuantity = String(object.askQuantity);
        return message;
    };
    /**
     * Creates a plain object from a PublicAggreBookTickerV3Api message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicAggreBookTickerV3Api
     * @static
     * @param {PublicAggreBookTickerV3Api} message PublicAggreBookTickerV3Api
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicAggreBookTickerV3Api.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.bidPrice = "";
            object.bidQuantity = "";
            object.askPrice = "";
            object.askQuantity = "";
        }
        if (message.bidPrice != null && message.hasOwnProperty("bidPrice"))
            object.bidPrice = message.bidPrice;
        if (message.bidQuantity != null && message.hasOwnProperty("bidQuantity"))
            object.bidQuantity = message.bidQuantity;
        if (message.askPrice != null && message.hasOwnProperty("askPrice"))
            object.askPrice = message.askPrice;
        if (message.askQuantity != null && message.hasOwnProperty("askQuantity"))
            object.askQuantity = message.askQuantity;
        return object;
    };
    /**
     * Converts this PublicAggreBookTickerV3Api to JSON.
     * @function toJSON
     * @memberof PublicAggreBookTickerV3Api
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicAggreBookTickerV3Api.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicAggreBookTickerV3Api
     * @function getTypeUrl
     * @memberof PublicAggreBookTickerV3Api
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicAggreBookTickerV3Api.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicAggreBookTickerV3Api";
    };
    return PublicAggreBookTickerV3Api;
})();
$root.PublicAggreDealsV3Api = (function () {
    /**
     * Properties of a PublicAggreDealsV3Api.
     * @exports IPublicAggreDealsV3Api
     * @interface IPublicAggreDealsV3Api
     * @property {Array.<IPublicAggreDealsV3ApiItem>|null} [deals] PublicAggreDealsV3Api deals
     * @property {string|null} [eventType] PublicAggreDealsV3Api eventType
     */
    /**
     * Constructs a new PublicAggreDealsV3Api.
     * @exports PublicAggreDealsV3Api
     * @classdesc Represents a PublicAggreDealsV3Api.
     * @implements IPublicAggreDealsV3Api
     * @constructor
     * @param {IPublicAggreDealsV3Api=} [properties] Properties to set
     */
    function PublicAggreDealsV3Api(properties) {
        this.deals = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicAggreDealsV3Api deals.
     * @member {Array.<IPublicAggreDealsV3ApiItem>} deals
     * @memberof PublicAggreDealsV3Api
     * @instance
     */
    PublicAggreDealsV3Api.prototype.deals = $util.emptyArray;
    /**
     * PublicAggreDealsV3Api eventType.
     * @member {string} eventType
     * @memberof PublicAggreDealsV3Api
     * @instance
     */
    PublicAggreDealsV3Api.prototype.eventType = "";
    /**
     * Creates a new PublicAggreDealsV3Api instance using the specified properties.
     * @function create
     * @memberof PublicAggreDealsV3Api
     * @static
     * @param {IPublicAggreDealsV3Api=} [properties] Properties to set
     * @returns {PublicAggreDealsV3Api} PublicAggreDealsV3Api instance
     */
    PublicAggreDealsV3Api.create = function create(properties) {
        return new PublicAggreDealsV3Api(properties);
    };
    /**
     * Encodes the specified PublicAggreDealsV3Api message. Does not implicitly {@link PublicAggreDealsV3Api.verify|verify} messages.
     * @function encode
     * @memberof PublicAggreDealsV3Api
     * @static
     * @param {IPublicAggreDealsV3Api} message PublicAggreDealsV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicAggreDealsV3Api.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.deals != null && message.deals.length)
            for (var i = 0; i < message.deals.length; ++i)
                $root.PublicAggreDealsV3ApiItem.encode(message.deals[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        if (message.eventType != null && Object.hasOwnProperty.call(message, "eventType"))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.eventType);
        return writer;
    };
    /**
     * Encodes the specified PublicAggreDealsV3Api message, length delimited. Does not implicitly {@link PublicAggreDealsV3Api.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicAggreDealsV3Api
     * @static
     * @param {IPublicAggreDealsV3Api} message PublicAggreDealsV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicAggreDealsV3Api.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicAggreDealsV3Api message from the specified reader or buffer.
     * @function decode
     * @memberof PublicAggreDealsV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicAggreDealsV3Api} PublicAggreDealsV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicAggreDealsV3Api.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicAggreDealsV3Api();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    if (!(message.deals && message.deals.length))
                        message.deals = [];
                    message.deals.push($root.PublicAggreDealsV3ApiItem.decode(reader, reader.uint32()));
                    break;
                }
                case 2: {
                    message.eventType = reader.string();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicAggreDealsV3Api message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicAggreDealsV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicAggreDealsV3Api} PublicAggreDealsV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicAggreDealsV3Api.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicAggreDealsV3Api message.
     * @function verify
     * @memberof PublicAggreDealsV3Api
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicAggreDealsV3Api.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.deals != null && message.hasOwnProperty("deals")) {
            if (!Array.isArray(message.deals))
                return "deals: array expected";
            for (var i = 0; i < message.deals.length; ++i) {
                var error = $root.PublicAggreDealsV3ApiItem.verify(message.deals[i]);
                if (error)
                    return "deals." + error;
            }
        }
        if (message.eventType != null && message.hasOwnProperty("eventType"))
            if (!$util.isString(message.eventType))
                return "eventType: string expected";
        return null;
    };
    /**
     * Creates a PublicAggreDealsV3Api message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicAggreDealsV3Api
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicAggreDealsV3Api} PublicAggreDealsV3Api
     */
    PublicAggreDealsV3Api.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicAggreDealsV3Api)
            return object;
        var message = new $root.PublicAggreDealsV3Api();
        if (object.deals) {
            if (!Array.isArray(object.deals))
                throw TypeError(".PublicAggreDealsV3Api.deals: array expected");
            message.deals = [];
            for (var i = 0; i < object.deals.length; ++i) {
                if (typeof object.deals[i] !== "object")
                    throw TypeError(".PublicAggreDealsV3Api.deals: object expected");
                message.deals[i] = $root.PublicAggreDealsV3ApiItem.fromObject(object.deals[i]);
            }
        }
        if (object.eventType != null)
            message.eventType = String(object.eventType);
        return message;
    };
    /**
     * Creates a plain object from a PublicAggreDealsV3Api message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicAggreDealsV3Api
     * @static
     * @param {PublicAggreDealsV3Api} message PublicAggreDealsV3Api
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicAggreDealsV3Api.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.deals = [];
        if (options.defaults)
            object.eventType = "";
        if (message.deals && message.deals.length) {
            object.deals = [];
            for (var j = 0; j < message.deals.length; ++j)
                object.deals[j] = $root.PublicAggreDealsV3ApiItem.toObject(message.deals[j], options);
        }
        if (message.eventType != null && message.hasOwnProperty("eventType"))
            object.eventType = message.eventType;
        return object;
    };
    /**
     * Converts this PublicAggreDealsV3Api to JSON.
     * @function toJSON
     * @memberof PublicAggreDealsV3Api
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicAggreDealsV3Api.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicAggreDealsV3Api
     * @function getTypeUrl
     * @memberof PublicAggreDealsV3Api
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicAggreDealsV3Api.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicAggreDealsV3Api";
    };
    return PublicAggreDealsV3Api;
})();
$root.PublicAggreDealsV3ApiItem = (function () {
    /**
     * Properties of a PublicAggreDealsV3ApiItem.
     * @exports IPublicAggreDealsV3ApiItem
     * @interface IPublicAggreDealsV3ApiItem
     * @property {string|null} [price] PublicAggreDealsV3ApiItem price
     * @property {string|null} [quantity] PublicAggreDealsV3ApiItem quantity
     * @property {number|null} [tradeType] PublicAggreDealsV3ApiItem tradeType
     * @property {number|Long|null} [time] PublicAggreDealsV3ApiItem time
     */
    /**
     * Constructs a new PublicAggreDealsV3ApiItem.
     * @exports PublicAggreDealsV3ApiItem
     * @classdesc Represents a PublicAggreDealsV3ApiItem.
     * @implements IPublicAggreDealsV3ApiItem
     * @constructor
     * @param {IPublicAggreDealsV3ApiItem=} [properties] Properties to set
     */
    function PublicAggreDealsV3ApiItem(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicAggreDealsV3ApiItem price.
     * @member {string} price
     * @memberof PublicAggreDealsV3ApiItem
     * @instance
     */
    PublicAggreDealsV3ApiItem.prototype.price = "";
    /**
     * PublicAggreDealsV3ApiItem quantity.
     * @member {string} quantity
     * @memberof PublicAggreDealsV3ApiItem
     * @instance
     */
    PublicAggreDealsV3ApiItem.prototype.quantity = "";
    /**
     * PublicAggreDealsV3ApiItem tradeType.
     * @member {number} tradeType
     * @memberof PublicAggreDealsV3ApiItem
     * @instance
     */
    PublicAggreDealsV3ApiItem.prototype.tradeType = 0;
    /**
     * PublicAggreDealsV3ApiItem time.
     * @member {number|Long} time
     * @memberof PublicAggreDealsV3ApiItem
     * @instance
     */
    PublicAggreDealsV3ApiItem.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    /**
     * Creates a new PublicAggreDealsV3ApiItem instance using the specified properties.
     * @function create
     * @memberof PublicAggreDealsV3ApiItem
     * @static
     * @param {IPublicAggreDealsV3ApiItem=} [properties] Properties to set
     * @returns {PublicAggreDealsV3ApiItem} PublicAggreDealsV3ApiItem instance
     */
    PublicAggreDealsV3ApiItem.create = function create(properties) {
        return new PublicAggreDealsV3ApiItem(properties);
    };
    /**
     * Encodes the specified PublicAggreDealsV3ApiItem message. Does not implicitly {@link PublicAggreDealsV3ApiItem.verify|verify} messages.
     * @function encode
     * @memberof PublicAggreDealsV3ApiItem
     * @static
     * @param {IPublicAggreDealsV3ApiItem} message PublicAggreDealsV3ApiItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicAggreDealsV3ApiItem.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.price);
        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.quantity);
        if (message.tradeType != null && Object.hasOwnProperty.call(message, "tradeType"))
            writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.tradeType);
        if (message.time != null && Object.hasOwnProperty.call(message, "time"))
            writer.uint32(/* id 4, wireType 0 =*/ 32).int64(message.time);
        return writer;
    };
    /**
     * Encodes the specified PublicAggreDealsV3ApiItem message, length delimited. Does not implicitly {@link PublicAggreDealsV3ApiItem.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicAggreDealsV3ApiItem
     * @static
     * @param {IPublicAggreDealsV3ApiItem} message PublicAggreDealsV3ApiItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicAggreDealsV3ApiItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicAggreDealsV3ApiItem message from the specified reader or buffer.
     * @function decode
     * @memberof PublicAggreDealsV3ApiItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicAggreDealsV3ApiItem} PublicAggreDealsV3ApiItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicAggreDealsV3ApiItem.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicAggreDealsV3ApiItem();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    message.price = reader.string();
                    break;
                }
                case 2: {
                    message.quantity = reader.string();
                    break;
                }
                case 3: {
                    message.tradeType = reader.int32();
                    break;
                }
                case 4: {
                    message.time = reader.int64();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicAggreDealsV3ApiItem message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicAggreDealsV3ApiItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicAggreDealsV3ApiItem} PublicAggreDealsV3ApiItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicAggreDealsV3ApiItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicAggreDealsV3ApiItem message.
     * @function verify
     * @memberof PublicAggreDealsV3ApiItem
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicAggreDealsV3ApiItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.price != null && message.hasOwnProperty("price"))
            if (!$util.isString(message.price))
                return "price: string expected";
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (!$util.isString(message.quantity))
                return "quantity: string expected";
        if (message.tradeType != null && message.hasOwnProperty("tradeType"))
            if (!$util.isInteger(message.tradeType))
                return "tradeType: integer expected";
        if (message.time != null && message.hasOwnProperty("time"))
            if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
                return "time: integer|Long expected";
        return null;
    };
    /**
     * Creates a PublicAggreDealsV3ApiItem message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicAggreDealsV3ApiItem
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicAggreDealsV3ApiItem} PublicAggreDealsV3ApiItem
     */
    PublicAggreDealsV3ApiItem.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicAggreDealsV3ApiItem)
            return object;
        var message = new $root.PublicAggreDealsV3ApiItem();
        if (object.price != null)
            message.price = String(object.price);
        if (object.quantity != null)
            message.quantity = String(object.quantity);
        if (object.tradeType != null)
            message.tradeType = object.tradeType | 0;
        if (object.time != null)
            if ($util.Long)
                (message.time = $util.Long.fromValue(object.time)).unsigned = false;
            else if (typeof object.time === "string")
                message.time = parseInt(object.time, 10);
            else if (typeof object.time === "number")
                message.time = object.time;
            else if (typeof object.time === "object")
                message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
        return message;
    };
    /**
     * Creates a plain object from a PublicAggreDealsV3ApiItem message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicAggreDealsV3ApiItem
     * @static
     * @param {PublicAggreDealsV3ApiItem} message PublicAggreDealsV3ApiItem
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicAggreDealsV3ApiItem.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.price = "";
            object.quantity = "";
            object.tradeType = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            }
            else
                object.time = options.longs === String ? "0" : 0;
        }
        if (message.price != null && message.hasOwnProperty("price"))
            object.price = message.price;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            object.quantity = message.quantity;
        if (message.tradeType != null && message.hasOwnProperty("tradeType"))
            object.tradeType = message.tradeType;
        if (message.time != null && message.hasOwnProperty("time"))
            if (typeof message.time === "number")
                object.time = options.longs === String ? String(message.time) : message.time;
            else
                object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
        return object;
    };
    /**
     * Converts this PublicAggreDealsV3ApiItem to JSON.
     * @function toJSON
     * @memberof PublicAggreDealsV3ApiItem
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicAggreDealsV3ApiItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicAggreDealsV3ApiItem
     * @function getTypeUrl
     * @memberof PublicAggreDealsV3ApiItem
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicAggreDealsV3ApiItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicAggreDealsV3ApiItem";
    };
    return PublicAggreDealsV3ApiItem;
})();
$root.PublicAggreDepthsV3Api = (function () {
    /**
     * Properties of a PublicAggreDepthsV3Api.
     * @exports IPublicAggreDepthsV3Api
     * @interface IPublicAggreDepthsV3Api
     * @property {Array.<IPublicAggreDepthV3ApiItem>|null} [asks] PublicAggreDepthsV3Api asks
     * @property {Array.<IPublicAggreDepthV3ApiItem>|null} [bids] PublicAggreDepthsV3Api bids
     * @property {string|null} [eventType] PublicAggreDepthsV3Api eventType
     * @property {string|null} [fromVersion] PublicAggreDepthsV3Api fromVersion
     * @property {string|null} [toVersion] PublicAggreDepthsV3Api toVersion
     */
    /**
     * Constructs a new PublicAggreDepthsV3Api.
     * @exports PublicAggreDepthsV3Api
     * @classdesc Represents a PublicAggreDepthsV3Api.
     * @implements IPublicAggreDepthsV3Api
     * @constructor
     * @param {IPublicAggreDepthsV3Api=} [properties] Properties to set
     */
    function PublicAggreDepthsV3Api(properties) {
        this.asks = [];
        this.bids = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicAggreDepthsV3Api asks.
     * @member {Array.<IPublicAggreDepthV3ApiItem>} asks
     * @memberof PublicAggreDepthsV3Api
     * @instance
     */
    PublicAggreDepthsV3Api.prototype.asks = $util.emptyArray;
    /**
     * PublicAggreDepthsV3Api bids.
     * @member {Array.<IPublicAggreDepthV3ApiItem>} bids
     * @memberof PublicAggreDepthsV3Api
     * @instance
     */
    PublicAggreDepthsV3Api.prototype.bids = $util.emptyArray;
    /**
     * PublicAggreDepthsV3Api eventType.
     * @member {string} eventType
     * @memberof PublicAggreDepthsV3Api
     * @instance
     */
    PublicAggreDepthsV3Api.prototype.eventType = "";
    /**
     * PublicAggreDepthsV3Api fromVersion.
     * @member {string} fromVersion
     * @memberof PublicAggreDepthsV3Api
     * @instance
     */
    PublicAggreDepthsV3Api.prototype.fromVersion = "";
    /**
     * PublicAggreDepthsV3Api toVersion.
     * @member {string} toVersion
     * @memberof PublicAggreDepthsV3Api
     * @instance
     */
    PublicAggreDepthsV3Api.prototype.toVersion = "";
    /**
     * Creates a new PublicAggreDepthsV3Api instance using the specified properties.
     * @function create
     * @memberof PublicAggreDepthsV3Api
     * @static
     * @param {IPublicAggreDepthsV3Api=} [properties] Properties to set
     * @returns {PublicAggreDepthsV3Api} PublicAggreDepthsV3Api instance
     */
    PublicAggreDepthsV3Api.create = function create(properties) {
        return new PublicAggreDepthsV3Api(properties);
    };
    /**
     * Encodes the specified PublicAggreDepthsV3Api message. Does not implicitly {@link PublicAggreDepthsV3Api.verify|verify} messages.
     * @function encode
     * @memberof PublicAggreDepthsV3Api
     * @static
     * @param {IPublicAggreDepthsV3Api} message PublicAggreDepthsV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicAggreDepthsV3Api.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.asks != null && message.asks.length)
            for (var i = 0; i < message.asks.length; ++i)
                $root.PublicAggreDepthV3ApiItem.encode(message.asks[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        if (message.bids != null && message.bids.length)
            for (var i = 0; i < message.bids.length; ++i)
                $root.PublicAggreDepthV3ApiItem.encode(message.bids[i], writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
        if (message.eventType != null && Object.hasOwnProperty.call(message, "eventType"))
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.eventType);
        if (message.fromVersion != null && Object.hasOwnProperty.call(message, "fromVersion"))
            writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.fromVersion);
        if (message.toVersion != null && Object.hasOwnProperty.call(message, "toVersion"))
            writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.toVersion);
        return writer;
    };
    /**
     * Encodes the specified PublicAggreDepthsV3Api message, length delimited. Does not implicitly {@link PublicAggreDepthsV3Api.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicAggreDepthsV3Api
     * @static
     * @param {IPublicAggreDepthsV3Api} message PublicAggreDepthsV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicAggreDepthsV3Api.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicAggreDepthsV3Api message from the specified reader or buffer.
     * @function decode
     * @memberof PublicAggreDepthsV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicAggreDepthsV3Api} PublicAggreDepthsV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicAggreDepthsV3Api.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicAggreDepthsV3Api();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    if (!(message.asks && message.asks.length))
                        message.asks = [];
                    message.asks.push($root.PublicAggreDepthV3ApiItem.decode(reader, reader.uint32()));
                    break;
                }
                case 2: {
                    if (!(message.bids && message.bids.length))
                        message.bids = [];
                    message.bids.push($root.PublicAggreDepthV3ApiItem.decode(reader, reader.uint32()));
                    break;
                }
                case 3: {
                    message.eventType = reader.string();
                    break;
                }
                case 4: {
                    message.fromVersion = reader.string();
                    break;
                }
                case 5: {
                    message.toVersion = reader.string();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicAggreDepthsV3Api message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicAggreDepthsV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicAggreDepthsV3Api} PublicAggreDepthsV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicAggreDepthsV3Api.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicAggreDepthsV3Api message.
     * @function verify
     * @memberof PublicAggreDepthsV3Api
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicAggreDepthsV3Api.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.asks != null && message.hasOwnProperty("asks")) {
            if (!Array.isArray(message.asks))
                return "asks: array expected";
            for (var i = 0; i < message.asks.length; ++i) {
                var error = $root.PublicAggreDepthV3ApiItem.verify(message.asks[i]);
                if (error)
                    return "asks." + error;
            }
        }
        if (message.bids != null && message.hasOwnProperty("bids")) {
            if (!Array.isArray(message.bids))
                return "bids: array expected";
            for (var i = 0; i < message.bids.length; ++i) {
                var error = $root.PublicAggreDepthV3ApiItem.verify(message.bids[i]);
                if (error)
                    return "bids." + error;
            }
        }
        if (message.eventType != null && message.hasOwnProperty("eventType"))
            if (!$util.isString(message.eventType))
                return "eventType: string expected";
        if (message.fromVersion != null && message.hasOwnProperty("fromVersion"))
            if (!$util.isString(message.fromVersion))
                return "fromVersion: string expected";
        if (message.toVersion != null && message.hasOwnProperty("toVersion"))
            if (!$util.isString(message.toVersion))
                return "toVersion: string expected";
        return null;
    };
    /**
     * Creates a PublicAggreDepthsV3Api message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicAggreDepthsV3Api
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicAggreDepthsV3Api} PublicAggreDepthsV3Api
     */
    PublicAggreDepthsV3Api.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicAggreDepthsV3Api)
            return object;
        var message = new $root.PublicAggreDepthsV3Api();
        if (object.asks) {
            if (!Array.isArray(object.asks))
                throw TypeError(".PublicAggreDepthsV3Api.asks: array expected");
            message.asks = [];
            for (var i = 0; i < object.asks.length; ++i) {
                if (typeof object.asks[i] !== "object")
                    throw TypeError(".PublicAggreDepthsV3Api.asks: object expected");
                message.asks[i] = $root.PublicAggreDepthV3ApiItem.fromObject(object.asks[i]);
            }
        }
        if (object.bids) {
            if (!Array.isArray(object.bids))
                throw TypeError(".PublicAggreDepthsV3Api.bids: array expected");
            message.bids = [];
            for (var i = 0; i < object.bids.length; ++i) {
                if (typeof object.bids[i] !== "object")
                    throw TypeError(".PublicAggreDepthsV3Api.bids: object expected");
                message.bids[i] = $root.PublicAggreDepthV3ApiItem.fromObject(object.bids[i]);
            }
        }
        if (object.eventType != null)
            message.eventType = String(object.eventType);
        if (object.fromVersion != null)
            message.fromVersion = String(object.fromVersion);
        if (object.toVersion != null)
            message.toVersion = String(object.toVersion);
        return message;
    };
    /**
     * Creates a plain object from a PublicAggreDepthsV3Api message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicAggreDepthsV3Api
     * @static
     * @param {PublicAggreDepthsV3Api} message PublicAggreDepthsV3Api
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicAggreDepthsV3Api.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.asks = [];
            object.bids = [];
        }
        if (options.defaults) {
            object.eventType = "";
            object.fromVersion = "";
            object.toVersion = "";
        }
        if (message.asks && message.asks.length) {
            object.asks = [];
            for (var j = 0; j < message.asks.length; ++j)
                object.asks[j] = $root.PublicAggreDepthV3ApiItem.toObject(message.asks[j], options);
        }
        if (message.bids && message.bids.length) {
            object.bids = [];
            for (var j = 0; j < message.bids.length; ++j)
                object.bids[j] = $root.PublicAggreDepthV3ApiItem.toObject(message.bids[j], options);
        }
        if (message.eventType != null && message.hasOwnProperty("eventType"))
            object.eventType = message.eventType;
        if (message.fromVersion != null && message.hasOwnProperty("fromVersion"))
            object.fromVersion = message.fromVersion;
        if (message.toVersion != null && message.hasOwnProperty("toVersion"))
            object.toVersion = message.toVersion;
        return object;
    };
    /**
     * Converts this PublicAggreDepthsV3Api to JSON.
     * @function toJSON
     * @memberof PublicAggreDepthsV3Api
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicAggreDepthsV3Api.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicAggreDepthsV3Api
     * @function getTypeUrl
     * @memberof PublicAggreDepthsV3Api
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicAggreDepthsV3Api.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicAggreDepthsV3Api";
    };
    return PublicAggreDepthsV3Api;
})();
$root.PublicAggreDepthV3ApiItem = (function () {
    /**
     * Properties of a PublicAggreDepthV3ApiItem.
     * @exports IPublicAggreDepthV3ApiItem
     * @interface IPublicAggreDepthV3ApiItem
     * @property {string|null} [price] PublicAggreDepthV3ApiItem price
     * @property {string|null} [quantity] PublicAggreDepthV3ApiItem quantity
     */
    /**
     * Constructs a new PublicAggreDepthV3ApiItem.
     * @exports PublicAggreDepthV3ApiItem
     * @classdesc Represents a PublicAggreDepthV3ApiItem.
     * @implements IPublicAggreDepthV3ApiItem
     * @constructor
     * @param {IPublicAggreDepthV3ApiItem=} [properties] Properties to set
     */
    function PublicAggreDepthV3ApiItem(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicAggreDepthV3ApiItem price.
     * @member {string} price
     * @memberof PublicAggreDepthV3ApiItem
     * @instance
     */
    PublicAggreDepthV3ApiItem.prototype.price = "";
    /**
     * PublicAggreDepthV3ApiItem quantity.
     * @member {string} quantity
     * @memberof PublicAggreDepthV3ApiItem
     * @instance
     */
    PublicAggreDepthV3ApiItem.prototype.quantity = "";
    /**
     * Creates a new PublicAggreDepthV3ApiItem instance using the specified properties.
     * @function create
     * @memberof PublicAggreDepthV3ApiItem
     * @static
     * @param {IPublicAggreDepthV3ApiItem=} [properties] Properties to set
     * @returns {PublicAggreDepthV3ApiItem} PublicAggreDepthV3ApiItem instance
     */
    PublicAggreDepthV3ApiItem.create = function create(properties) {
        return new PublicAggreDepthV3ApiItem(properties);
    };
    /**
     * Encodes the specified PublicAggreDepthV3ApiItem message. Does not implicitly {@link PublicAggreDepthV3ApiItem.verify|verify} messages.
     * @function encode
     * @memberof PublicAggreDepthV3ApiItem
     * @static
     * @param {IPublicAggreDepthV3ApiItem} message PublicAggreDepthV3ApiItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicAggreDepthV3ApiItem.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.price);
        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.quantity);
        return writer;
    };
    /**
     * Encodes the specified PublicAggreDepthV3ApiItem message, length delimited. Does not implicitly {@link PublicAggreDepthV3ApiItem.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicAggreDepthV3ApiItem
     * @static
     * @param {IPublicAggreDepthV3ApiItem} message PublicAggreDepthV3ApiItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicAggreDepthV3ApiItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicAggreDepthV3ApiItem message from the specified reader or buffer.
     * @function decode
     * @memberof PublicAggreDepthV3ApiItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicAggreDepthV3ApiItem} PublicAggreDepthV3ApiItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicAggreDepthV3ApiItem.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicAggreDepthV3ApiItem();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    message.price = reader.string();
                    break;
                }
                case 2: {
                    message.quantity = reader.string();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicAggreDepthV3ApiItem message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicAggreDepthV3ApiItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicAggreDepthV3ApiItem} PublicAggreDepthV3ApiItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicAggreDepthV3ApiItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicAggreDepthV3ApiItem message.
     * @function verify
     * @memberof PublicAggreDepthV3ApiItem
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicAggreDepthV3ApiItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.price != null && message.hasOwnProperty("price"))
            if (!$util.isString(message.price))
                return "price: string expected";
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (!$util.isString(message.quantity))
                return "quantity: string expected";
        return null;
    };
    /**
     * Creates a PublicAggreDepthV3ApiItem message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicAggreDepthV3ApiItem
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicAggreDepthV3ApiItem} PublicAggreDepthV3ApiItem
     */
    PublicAggreDepthV3ApiItem.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicAggreDepthV3ApiItem)
            return object;
        var message = new $root.PublicAggreDepthV3ApiItem();
        if (object.price != null)
            message.price = String(object.price);
        if (object.quantity != null)
            message.quantity = String(object.quantity);
        return message;
    };
    /**
     * Creates a plain object from a PublicAggreDepthV3ApiItem message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicAggreDepthV3ApiItem
     * @static
     * @param {PublicAggreDepthV3ApiItem} message PublicAggreDepthV3ApiItem
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicAggreDepthV3ApiItem.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.price = "";
            object.quantity = "";
        }
        if (message.price != null && message.hasOwnProperty("price"))
            object.price = message.price;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            object.quantity = message.quantity;
        return object;
    };
    /**
     * Converts this PublicAggreDepthV3ApiItem to JSON.
     * @function toJSON
     * @memberof PublicAggreDepthV3ApiItem
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicAggreDepthV3ApiItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicAggreDepthV3ApiItem
     * @function getTypeUrl
     * @memberof PublicAggreDepthV3ApiItem
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicAggreDepthV3ApiItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicAggreDepthV3ApiItem";
    };
    return PublicAggreDepthV3ApiItem;
})();
$root.PublicBookTickerBatchV3Api = (function () {
    /**
     * Properties of a PublicBookTickerBatchV3Api.
     * @exports IPublicBookTickerBatchV3Api
     * @interface IPublicBookTickerBatchV3Api
     * @property {Array.<IPublicBookTickerV3Api>|null} [items] PublicBookTickerBatchV3Api items
     */
    /**
     * Constructs a new PublicBookTickerBatchV3Api.
     * @exports PublicBookTickerBatchV3Api
     * @classdesc Represents a PublicBookTickerBatchV3Api.
     * @implements IPublicBookTickerBatchV3Api
     * @constructor
     * @param {IPublicBookTickerBatchV3Api=} [properties] Properties to set
     */
    function PublicBookTickerBatchV3Api(properties) {
        this.items = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicBookTickerBatchV3Api items.
     * @member {Array.<IPublicBookTickerV3Api>} items
     * @memberof PublicBookTickerBatchV3Api
     * @instance
     */
    PublicBookTickerBatchV3Api.prototype.items = $util.emptyArray;
    /**
     * Creates a new PublicBookTickerBatchV3Api instance using the specified properties.
     * @function create
     * @memberof PublicBookTickerBatchV3Api
     * @static
     * @param {IPublicBookTickerBatchV3Api=} [properties] Properties to set
     * @returns {PublicBookTickerBatchV3Api} PublicBookTickerBatchV3Api instance
     */
    PublicBookTickerBatchV3Api.create = function create(properties) {
        return new PublicBookTickerBatchV3Api(properties);
    };
    /**
     * Encodes the specified PublicBookTickerBatchV3Api message. Does not implicitly {@link PublicBookTickerBatchV3Api.verify|verify} messages.
     * @function encode
     * @memberof PublicBookTickerBatchV3Api
     * @static
     * @param {IPublicBookTickerBatchV3Api} message PublicBookTickerBatchV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicBookTickerBatchV3Api.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.items != null && message.items.length)
            for (var i = 0; i < message.items.length; ++i)
                $root.PublicBookTickerV3Api.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified PublicBookTickerBatchV3Api message, length delimited. Does not implicitly {@link PublicBookTickerBatchV3Api.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicBookTickerBatchV3Api
     * @static
     * @param {IPublicBookTickerBatchV3Api} message PublicBookTickerBatchV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicBookTickerBatchV3Api.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicBookTickerBatchV3Api message from the specified reader or buffer.
     * @function decode
     * @memberof PublicBookTickerBatchV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicBookTickerBatchV3Api} PublicBookTickerBatchV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicBookTickerBatchV3Api.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicBookTickerBatchV3Api();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.PublicBookTickerV3Api.decode(reader, reader.uint32()));
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicBookTickerBatchV3Api message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicBookTickerBatchV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicBookTickerBatchV3Api} PublicBookTickerBatchV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicBookTickerBatchV3Api.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicBookTickerBatchV3Api message.
     * @function verify
     * @memberof PublicBookTickerBatchV3Api
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicBookTickerBatchV3Api.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.items != null && message.hasOwnProperty("items")) {
            if (!Array.isArray(message.items))
                return "items: array expected";
            for (var i = 0; i < message.items.length; ++i) {
                var error = $root.PublicBookTickerV3Api.verify(message.items[i]);
                if (error)
                    return "items." + error;
            }
        }
        return null;
    };
    /**
     * Creates a PublicBookTickerBatchV3Api message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicBookTickerBatchV3Api
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicBookTickerBatchV3Api} PublicBookTickerBatchV3Api
     */
    PublicBookTickerBatchV3Api.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicBookTickerBatchV3Api)
            return object;
        var message = new $root.PublicBookTickerBatchV3Api();
        if (object.items) {
            if (!Array.isArray(object.items))
                throw TypeError(".PublicBookTickerBatchV3Api.items: array expected");
            message.items = [];
            for (var i = 0; i < object.items.length; ++i) {
                if (typeof object.items[i] !== "object")
                    throw TypeError(".PublicBookTickerBatchV3Api.items: object expected");
                message.items[i] = $root.PublicBookTickerV3Api.fromObject(object.items[i]);
            }
        }
        return message;
    };
    /**
     * Creates a plain object from a PublicBookTickerBatchV3Api message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicBookTickerBatchV3Api
     * @static
     * @param {PublicBookTickerBatchV3Api} message PublicBookTickerBatchV3Api
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicBookTickerBatchV3Api.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.items = [];
        if (message.items && message.items.length) {
            object.items = [];
            for (var j = 0; j < message.items.length; ++j)
                object.items[j] = $root.PublicBookTickerV3Api.toObject(message.items[j], options);
        }
        return object;
    };
    /**
     * Converts this PublicBookTickerBatchV3Api to JSON.
     * @function toJSON
     * @memberof PublicBookTickerBatchV3Api
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicBookTickerBatchV3Api.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicBookTickerBatchV3Api
     * @function getTypeUrl
     * @memberof PublicBookTickerBatchV3Api
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicBookTickerBatchV3Api.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicBookTickerBatchV3Api";
    };
    return PublicBookTickerBatchV3Api;
})();
$root.PublicBookTickerV3Api = (function () {
    /**
     * Properties of a PublicBookTickerV3Api.
     * @exports IPublicBookTickerV3Api
     * @interface IPublicBookTickerV3Api
     * @property {string|null} [bidPrice] PublicBookTickerV3Api bidPrice
     * @property {string|null} [bidQuantity] PublicBookTickerV3Api bidQuantity
     * @property {string|null} [askPrice] PublicBookTickerV3Api askPrice
     * @property {string|null} [askQuantity] PublicBookTickerV3Api askQuantity
     */
    /**
     * Constructs a new PublicBookTickerV3Api.
     * @exports PublicBookTickerV3Api
     * @classdesc Represents a PublicBookTickerV3Api.
     * @implements IPublicBookTickerV3Api
     * @constructor
     * @param {IPublicBookTickerV3Api=} [properties] Properties to set
     */
    function PublicBookTickerV3Api(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicBookTickerV3Api bidPrice.
     * @member {string} bidPrice
     * @memberof PublicBookTickerV3Api
     * @instance
     */
    PublicBookTickerV3Api.prototype.bidPrice = "";
    /**
     * PublicBookTickerV3Api bidQuantity.
     * @member {string} bidQuantity
     * @memberof PublicBookTickerV3Api
     * @instance
     */
    PublicBookTickerV3Api.prototype.bidQuantity = "";
    /**
     * PublicBookTickerV3Api askPrice.
     * @member {string} askPrice
     * @memberof PublicBookTickerV3Api
     * @instance
     */
    PublicBookTickerV3Api.prototype.askPrice = "";
    /**
     * PublicBookTickerV3Api askQuantity.
     * @member {string} askQuantity
     * @memberof PublicBookTickerV3Api
     * @instance
     */
    PublicBookTickerV3Api.prototype.askQuantity = "";
    /**
     * Creates a new PublicBookTickerV3Api instance using the specified properties.
     * @function create
     * @memberof PublicBookTickerV3Api
     * @static
     * @param {IPublicBookTickerV3Api=} [properties] Properties to set
     * @returns {PublicBookTickerV3Api} PublicBookTickerV3Api instance
     */
    PublicBookTickerV3Api.create = function create(properties) {
        return new PublicBookTickerV3Api(properties);
    };
    /**
     * Encodes the specified PublicBookTickerV3Api message. Does not implicitly {@link PublicBookTickerV3Api.verify|verify} messages.
     * @function encode
     * @memberof PublicBookTickerV3Api
     * @static
     * @param {IPublicBookTickerV3Api} message PublicBookTickerV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicBookTickerV3Api.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.bidPrice != null && Object.hasOwnProperty.call(message, "bidPrice"))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.bidPrice);
        if (message.bidQuantity != null && Object.hasOwnProperty.call(message, "bidQuantity"))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.bidQuantity);
        if (message.askPrice != null && Object.hasOwnProperty.call(message, "askPrice"))
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.askPrice);
        if (message.askQuantity != null && Object.hasOwnProperty.call(message, "askQuantity"))
            writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.askQuantity);
        return writer;
    };
    /**
     * Encodes the specified PublicBookTickerV3Api message, length delimited. Does not implicitly {@link PublicBookTickerV3Api.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicBookTickerV3Api
     * @static
     * @param {IPublicBookTickerV3Api} message PublicBookTickerV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicBookTickerV3Api.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicBookTickerV3Api message from the specified reader or buffer.
     * @function decode
     * @memberof PublicBookTickerV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicBookTickerV3Api} PublicBookTickerV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicBookTickerV3Api.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicBookTickerV3Api();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    message.bidPrice = reader.string();
                    break;
                }
                case 2: {
                    message.bidQuantity = reader.string();
                    break;
                }
                case 3: {
                    message.askPrice = reader.string();
                    break;
                }
                case 4: {
                    message.askQuantity = reader.string();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicBookTickerV3Api message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicBookTickerV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicBookTickerV3Api} PublicBookTickerV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicBookTickerV3Api.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicBookTickerV3Api message.
     * @function verify
     * @memberof PublicBookTickerV3Api
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicBookTickerV3Api.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.bidPrice != null && message.hasOwnProperty("bidPrice"))
            if (!$util.isString(message.bidPrice))
                return "bidPrice: string expected";
        if (message.bidQuantity != null && message.hasOwnProperty("bidQuantity"))
            if (!$util.isString(message.bidQuantity))
                return "bidQuantity: string expected";
        if (message.askPrice != null && message.hasOwnProperty("askPrice"))
            if (!$util.isString(message.askPrice))
                return "askPrice: string expected";
        if (message.askQuantity != null && message.hasOwnProperty("askQuantity"))
            if (!$util.isString(message.askQuantity))
                return "askQuantity: string expected";
        return null;
    };
    /**
     * Creates a PublicBookTickerV3Api message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicBookTickerV3Api
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicBookTickerV3Api} PublicBookTickerV3Api
     */
    PublicBookTickerV3Api.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicBookTickerV3Api)
            return object;
        var message = new $root.PublicBookTickerV3Api();
        if (object.bidPrice != null)
            message.bidPrice = String(object.bidPrice);
        if (object.bidQuantity != null)
            message.bidQuantity = String(object.bidQuantity);
        if (object.askPrice != null)
            message.askPrice = String(object.askPrice);
        if (object.askQuantity != null)
            message.askQuantity = String(object.askQuantity);
        return message;
    };
    /**
     * Creates a plain object from a PublicBookTickerV3Api message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicBookTickerV3Api
     * @static
     * @param {PublicBookTickerV3Api} message PublicBookTickerV3Api
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicBookTickerV3Api.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.bidPrice = "";
            object.bidQuantity = "";
            object.askPrice = "";
            object.askQuantity = "";
        }
        if (message.bidPrice != null && message.hasOwnProperty("bidPrice"))
            object.bidPrice = message.bidPrice;
        if (message.bidQuantity != null && message.hasOwnProperty("bidQuantity"))
            object.bidQuantity = message.bidQuantity;
        if (message.askPrice != null && message.hasOwnProperty("askPrice"))
            object.askPrice = message.askPrice;
        if (message.askQuantity != null && message.hasOwnProperty("askQuantity"))
            object.askQuantity = message.askQuantity;
        return object;
    };
    /**
     * Converts this PublicBookTickerV3Api to JSON.
     * @function toJSON
     * @memberof PublicBookTickerV3Api
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicBookTickerV3Api.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicBookTickerV3Api
     * @function getTypeUrl
     * @memberof PublicBookTickerV3Api
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicBookTickerV3Api.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicBookTickerV3Api";
    };
    return PublicBookTickerV3Api;
})();
$root.PublicDealsV3Api = (function () {
    /**
     * Properties of a PublicDealsV3Api.
     * @exports IPublicDealsV3Api
     * @interface IPublicDealsV3Api
     * @property {Array.<IPublicDealsV3ApiItem>|null} [deals] PublicDealsV3Api deals
     * @property {string|null} [eventType] PublicDealsV3Api eventType
     */
    /**
     * Constructs a new PublicDealsV3Api.
     * @exports PublicDealsV3Api
     * @classdesc Represents a PublicDealsV3Api.
     * @implements IPublicDealsV3Api
     * @constructor
     * @param {IPublicDealsV3Api=} [properties] Properties to set
     */
    function PublicDealsV3Api(properties) {
        this.deals = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicDealsV3Api deals.
     * @member {Array.<IPublicDealsV3ApiItem>} deals
     * @memberof PublicDealsV3Api
     * @instance
     */
    PublicDealsV3Api.prototype.deals = $util.emptyArray;
    /**
     * PublicDealsV3Api eventType.
     * @member {string} eventType
     * @memberof PublicDealsV3Api
     * @instance
     */
    PublicDealsV3Api.prototype.eventType = "";
    /**
     * Creates a new PublicDealsV3Api instance using the specified properties.
     * @function create
     * @memberof PublicDealsV3Api
     * @static
     * @param {IPublicDealsV3Api=} [properties] Properties to set
     * @returns {PublicDealsV3Api} PublicDealsV3Api instance
     */
    PublicDealsV3Api.create = function create(properties) {
        return new PublicDealsV3Api(properties);
    };
    /**
     * Encodes the specified PublicDealsV3Api message. Does not implicitly {@link PublicDealsV3Api.verify|verify} messages.
     * @function encode
     * @memberof PublicDealsV3Api
     * @static
     * @param {IPublicDealsV3Api} message PublicDealsV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicDealsV3Api.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.deals != null && message.deals.length)
            for (var i = 0; i < message.deals.length; ++i)
                $root.PublicDealsV3ApiItem.encode(message.deals[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        if (message.eventType != null && Object.hasOwnProperty.call(message, "eventType"))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.eventType);
        return writer;
    };
    /**
     * Encodes the specified PublicDealsV3Api message, length delimited. Does not implicitly {@link PublicDealsV3Api.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicDealsV3Api
     * @static
     * @param {IPublicDealsV3Api} message PublicDealsV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicDealsV3Api.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicDealsV3Api message from the specified reader or buffer.
     * @function decode
     * @memberof PublicDealsV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicDealsV3Api} PublicDealsV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicDealsV3Api.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicDealsV3Api();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    if (!(message.deals && message.deals.length))
                        message.deals = [];
                    message.deals.push($root.PublicDealsV3ApiItem.decode(reader, reader.uint32()));
                    break;
                }
                case 2: {
                    message.eventType = reader.string();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicDealsV3Api message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicDealsV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicDealsV3Api} PublicDealsV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicDealsV3Api.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicDealsV3Api message.
     * @function verify
     * @memberof PublicDealsV3Api
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicDealsV3Api.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.deals != null && message.hasOwnProperty("deals")) {
            if (!Array.isArray(message.deals))
                return "deals: array expected";
            for (var i = 0; i < message.deals.length; ++i) {
                var error = $root.PublicDealsV3ApiItem.verify(message.deals[i]);
                if (error)
                    return "deals." + error;
            }
        }
        if (message.eventType != null && message.hasOwnProperty("eventType"))
            if (!$util.isString(message.eventType))
                return "eventType: string expected";
        return null;
    };
    /**
     * Creates a PublicDealsV3Api message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicDealsV3Api
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicDealsV3Api} PublicDealsV3Api
     */
    PublicDealsV3Api.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicDealsV3Api)
            return object;
        var message = new $root.PublicDealsV3Api();
        if (object.deals) {
            if (!Array.isArray(object.deals))
                throw TypeError(".PublicDealsV3Api.deals: array expected");
            message.deals = [];
            for (var i = 0; i < object.deals.length; ++i) {
                if (typeof object.deals[i] !== "object")
                    throw TypeError(".PublicDealsV3Api.deals: object expected");
                message.deals[i] = $root.PublicDealsV3ApiItem.fromObject(object.deals[i]);
            }
        }
        if (object.eventType != null)
            message.eventType = String(object.eventType);
        return message;
    };
    /**
     * Creates a plain object from a PublicDealsV3Api message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicDealsV3Api
     * @static
     * @param {PublicDealsV3Api} message PublicDealsV3Api
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicDealsV3Api.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.deals = [];
        if (options.defaults)
            object.eventType = "";
        if (message.deals && message.deals.length) {
            object.deals = [];
            for (var j = 0; j < message.deals.length; ++j)
                object.deals[j] = $root.PublicDealsV3ApiItem.toObject(message.deals[j], options);
        }
        if (message.eventType != null && message.hasOwnProperty("eventType"))
            object.eventType = message.eventType;
        return object;
    };
    /**
     * Converts this PublicDealsV3Api to JSON.
     * @function toJSON
     * @memberof PublicDealsV3Api
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicDealsV3Api.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicDealsV3Api
     * @function getTypeUrl
     * @memberof PublicDealsV3Api
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicDealsV3Api.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicDealsV3Api";
    };
    return PublicDealsV3Api;
})();
$root.PublicDealsV3ApiItem = (function () {
    /**
     * Properties of a PublicDealsV3ApiItem.
     * @exports IPublicDealsV3ApiItem
     * @interface IPublicDealsV3ApiItem
     * @property {string|null} [price] PublicDealsV3ApiItem price
     * @property {string|null} [quantity] PublicDealsV3ApiItem quantity
     * @property {number|null} [tradeType] PublicDealsV3ApiItem tradeType
     * @property {number|Long|null} [time] PublicDealsV3ApiItem time
     */
    /**
     * Constructs a new PublicDealsV3ApiItem.
     * @exports PublicDealsV3ApiItem
     * @classdesc Represents a PublicDealsV3ApiItem.
     * @implements IPublicDealsV3ApiItem
     * @constructor
     * @param {IPublicDealsV3ApiItem=} [properties] Properties to set
     */
    function PublicDealsV3ApiItem(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicDealsV3ApiItem price.
     * @member {string} price
     * @memberof PublicDealsV3ApiItem
     * @instance
     */
    PublicDealsV3ApiItem.prototype.price = "";
    /**
     * PublicDealsV3ApiItem quantity.
     * @member {string} quantity
     * @memberof PublicDealsV3ApiItem
     * @instance
     */
    PublicDealsV3ApiItem.prototype.quantity = "";
    /**
     * PublicDealsV3ApiItem tradeType.
     * @member {number} tradeType
     * @memberof PublicDealsV3ApiItem
     * @instance
     */
    PublicDealsV3ApiItem.prototype.tradeType = 0;
    /**
     * PublicDealsV3ApiItem time.
     * @member {number|Long} time
     * @memberof PublicDealsV3ApiItem
     * @instance
     */
    PublicDealsV3ApiItem.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    /**
     * Creates a new PublicDealsV3ApiItem instance using the specified properties.
     * @function create
     * @memberof PublicDealsV3ApiItem
     * @static
     * @param {IPublicDealsV3ApiItem=} [properties] Properties to set
     * @returns {PublicDealsV3ApiItem} PublicDealsV3ApiItem instance
     */
    PublicDealsV3ApiItem.create = function create(properties) {
        return new PublicDealsV3ApiItem(properties);
    };
    /**
     * Encodes the specified PublicDealsV3ApiItem message. Does not implicitly {@link PublicDealsV3ApiItem.verify|verify} messages.
     * @function encode
     * @memberof PublicDealsV3ApiItem
     * @static
     * @param {IPublicDealsV3ApiItem} message PublicDealsV3ApiItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicDealsV3ApiItem.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.price);
        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.quantity);
        if (message.tradeType != null && Object.hasOwnProperty.call(message, "tradeType"))
            writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.tradeType);
        if (message.time != null && Object.hasOwnProperty.call(message, "time"))
            writer.uint32(/* id 4, wireType 0 =*/ 32).int64(message.time);
        return writer;
    };
    /**
     * Encodes the specified PublicDealsV3ApiItem message, length delimited. Does not implicitly {@link PublicDealsV3ApiItem.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicDealsV3ApiItem
     * @static
     * @param {IPublicDealsV3ApiItem} message PublicDealsV3ApiItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicDealsV3ApiItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicDealsV3ApiItem message from the specified reader or buffer.
     * @function decode
     * @memberof PublicDealsV3ApiItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicDealsV3ApiItem} PublicDealsV3ApiItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicDealsV3ApiItem.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicDealsV3ApiItem();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    message.price = reader.string();
                    break;
                }
                case 2: {
                    message.quantity = reader.string();
                    break;
                }
                case 3: {
                    message.tradeType = reader.int32();
                    break;
                }
                case 4: {
                    message.time = reader.int64();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicDealsV3ApiItem message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicDealsV3ApiItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicDealsV3ApiItem} PublicDealsV3ApiItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicDealsV3ApiItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicDealsV3ApiItem message.
     * @function verify
     * @memberof PublicDealsV3ApiItem
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicDealsV3ApiItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.price != null && message.hasOwnProperty("price"))
            if (!$util.isString(message.price))
                return "price: string expected";
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (!$util.isString(message.quantity))
                return "quantity: string expected";
        if (message.tradeType != null && message.hasOwnProperty("tradeType"))
            if (!$util.isInteger(message.tradeType))
                return "tradeType: integer expected";
        if (message.time != null && message.hasOwnProperty("time"))
            if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
                return "time: integer|Long expected";
        return null;
    };
    /**
     * Creates a PublicDealsV3ApiItem message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicDealsV3ApiItem
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicDealsV3ApiItem} PublicDealsV3ApiItem
     */
    PublicDealsV3ApiItem.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicDealsV3ApiItem)
            return object;
        var message = new $root.PublicDealsV3ApiItem();
        if (object.price != null)
            message.price = String(object.price);
        if (object.quantity != null)
            message.quantity = String(object.quantity);
        if (object.tradeType != null)
            message.tradeType = object.tradeType | 0;
        if (object.time != null)
            if ($util.Long)
                (message.time = $util.Long.fromValue(object.time)).unsigned = false;
            else if (typeof object.time === "string")
                message.time = parseInt(object.time, 10);
            else if (typeof object.time === "number")
                message.time = object.time;
            else if (typeof object.time === "object")
                message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
        return message;
    };
    /**
     * Creates a plain object from a PublicDealsV3ApiItem message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicDealsV3ApiItem
     * @static
     * @param {PublicDealsV3ApiItem} message PublicDealsV3ApiItem
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicDealsV3ApiItem.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.price = "";
            object.quantity = "";
            object.tradeType = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            }
            else
                object.time = options.longs === String ? "0" : 0;
        }
        if (message.price != null && message.hasOwnProperty("price"))
            object.price = message.price;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            object.quantity = message.quantity;
        if (message.tradeType != null && message.hasOwnProperty("tradeType"))
            object.tradeType = message.tradeType;
        if (message.time != null && message.hasOwnProperty("time"))
            if (typeof message.time === "number")
                object.time = options.longs === String ? String(message.time) : message.time;
            else
                object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
        return object;
    };
    /**
     * Converts this PublicDealsV3ApiItem to JSON.
     * @function toJSON
     * @memberof PublicDealsV3ApiItem
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicDealsV3ApiItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicDealsV3ApiItem
     * @function getTypeUrl
     * @memberof PublicDealsV3ApiItem
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicDealsV3ApiItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicDealsV3ApiItem";
    };
    return PublicDealsV3ApiItem;
})();
$root.PublicIncreaseDepthsBatchV3Api = (function () {
    /**
     * Properties of a PublicIncreaseDepthsBatchV3Api.
     * @exports IPublicIncreaseDepthsBatchV3Api
     * @interface IPublicIncreaseDepthsBatchV3Api
     * @property {Array.<IPublicIncreaseDepthsV3Api>|null} [items] PublicIncreaseDepthsBatchV3Api items
     * @property {string|null} [eventType] PublicIncreaseDepthsBatchV3Api eventType
     */
    /**
     * Constructs a new PublicIncreaseDepthsBatchV3Api.
     * @exports PublicIncreaseDepthsBatchV3Api
     * @classdesc Represents a PublicIncreaseDepthsBatchV3Api.
     * @implements IPublicIncreaseDepthsBatchV3Api
     * @constructor
     * @param {IPublicIncreaseDepthsBatchV3Api=} [properties] Properties to set
     */
    function PublicIncreaseDepthsBatchV3Api(properties) {
        this.items = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicIncreaseDepthsBatchV3Api items.
     * @member {Array.<IPublicIncreaseDepthsV3Api>} items
     * @memberof PublicIncreaseDepthsBatchV3Api
     * @instance
     */
    PublicIncreaseDepthsBatchV3Api.prototype.items = $util.emptyArray;
    /**
     * PublicIncreaseDepthsBatchV3Api eventType.
     * @member {string} eventType
     * @memberof PublicIncreaseDepthsBatchV3Api
     * @instance
     */
    PublicIncreaseDepthsBatchV3Api.prototype.eventType = "";
    /**
     * Creates a new PublicIncreaseDepthsBatchV3Api instance using the specified properties.
     * @function create
     * @memberof PublicIncreaseDepthsBatchV3Api
     * @static
     * @param {IPublicIncreaseDepthsBatchV3Api=} [properties] Properties to set
     * @returns {PublicIncreaseDepthsBatchV3Api} PublicIncreaseDepthsBatchV3Api instance
     */
    PublicIncreaseDepthsBatchV3Api.create = function create(properties) {
        return new PublicIncreaseDepthsBatchV3Api(properties);
    };
    /**
     * Encodes the specified PublicIncreaseDepthsBatchV3Api message. Does not implicitly {@link PublicIncreaseDepthsBatchV3Api.verify|verify} messages.
     * @function encode
     * @memberof PublicIncreaseDepthsBatchV3Api
     * @static
     * @param {IPublicIncreaseDepthsBatchV3Api} message PublicIncreaseDepthsBatchV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicIncreaseDepthsBatchV3Api.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.items != null && message.items.length)
            for (var i = 0; i < message.items.length; ++i)
                $root.PublicIncreaseDepthsV3Api.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        if (message.eventType != null && Object.hasOwnProperty.call(message, "eventType"))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.eventType);
        return writer;
    };
    /**
     * Encodes the specified PublicIncreaseDepthsBatchV3Api message, length delimited. Does not implicitly {@link PublicIncreaseDepthsBatchV3Api.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicIncreaseDepthsBatchV3Api
     * @static
     * @param {IPublicIncreaseDepthsBatchV3Api} message PublicIncreaseDepthsBatchV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicIncreaseDepthsBatchV3Api.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicIncreaseDepthsBatchV3Api message from the specified reader or buffer.
     * @function decode
     * @memberof PublicIncreaseDepthsBatchV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicIncreaseDepthsBatchV3Api} PublicIncreaseDepthsBatchV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicIncreaseDepthsBatchV3Api.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicIncreaseDepthsBatchV3Api();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.PublicIncreaseDepthsV3Api.decode(reader, reader.uint32()));
                    break;
                }
                case 2: {
                    message.eventType = reader.string();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicIncreaseDepthsBatchV3Api message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicIncreaseDepthsBatchV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicIncreaseDepthsBatchV3Api} PublicIncreaseDepthsBatchV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicIncreaseDepthsBatchV3Api.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicIncreaseDepthsBatchV3Api message.
     * @function verify
     * @memberof PublicIncreaseDepthsBatchV3Api
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicIncreaseDepthsBatchV3Api.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.items != null && message.hasOwnProperty("items")) {
            if (!Array.isArray(message.items))
                return "items: array expected";
            for (var i = 0; i < message.items.length; ++i) {
                var error = $root.PublicIncreaseDepthsV3Api.verify(message.items[i]);
                if (error)
                    return "items." + error;
            }
        }
        if (message.eventType != null && message.hasOwnProperty("eventType"))
            if (!$util.isString(message.eventType))
                return "eventType: string expected";
        return null;
    };
    /**
     * Creates a PublicIncreaseDepthsBatchV3Api message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicIncreaseDepthsBatchV3Api
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicIncreaseDepthsBatchV3Api} PublicIncreaseDepthsBatchV3Api
     */
    PublicIncreaseDepthsBatchV3Api.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicIncreaseDepthsBatchV3Api)
            return object;
        var message = new $root.PublicIncreaseDepthsBatchV3Api();
        if (object.items) {
            if (!Array.isArray(object.items))
                throw TypeError(".PublicIncreaseDepthsBatchV3Api.items: array expected");
            message.items = [];
            for (var i = 0; i < object.items.length; ++i) {
                if (typeof object.items[i] !== "object")
                    throw TypeError(".PublicIncreaseDepthsBatchV3Api.items: object expected");
                message.items[i] = $root.PublicIncreaseDepthsV3Api.fromObject(object.items[i]);
            }
        }
        if (object.eventType != null)
            message.eventType = String(object.eventType);
        return message;
    };
    /**
     * Creates a plain object from a PublicIncreaseDepthsBatchV3Api message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicIncreaseDepthsBatchV3Api
     * @static
     * @param {PublicIncreaseDepthsBatchV3Api} message PublicIncreaseDepthsBatchV3Api
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicIncreaseDepthsBatchV3Api.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.items = [];
        if (options.defaults)
            object.eventType = "";
        if (message.items && message.items.length) {
            object.items = [];
            for (var j = 0; j < message.items.length; ++j)
                object.items[j] = $root.PublicIncreaseDepthsV3Api.toObject(message.items[j], options);
        }
        if (message.eventType != null && message.hasOwnProperty("eventType"))
            object.eventType = message.eventType;
        return object;
    };
    /**
     * Converts this PublicIncreaseDepthsBatchV3Api to JSON.
     * @function toJSON
     * @memberof PublicIncreaseDepthsBatchV3Api
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicIncreaseDepthsBatchV3Api.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicIncreaseDepthsBatchV3Api
     * @function getTypeUrl
     * @memberof PublicIncreaseDepthsBatchV3Api
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicIncreaseDepthsBatchV3Api.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicIncreaseDepthsBatchV3Api";
    };
    return PublicIncreaseDepthsBatchV3Api;
})();
$root.PublicIncreaseDepthsV3Api = (function () {
    /**
     * Properties of a PublicIncreaseDepthsV3Api.
     * @exports IPublicIncreaseDepthsV3Api
     * @interface IPublicIncreaseDepthsV3Api
     * @property {Array.<IPublicIncreaseDepthV3ApiItem>|null} [asks] PublicIncreaseDepthsV3Api asks
     * @property {Array.<IPublicIncreaseDepthV3ApiItem>|null} [bids] PublicIncreaseDepthsV3Api bids
     * @property {string|null} [eventType] PublicIncreaseDepthsV3Api eventType
     * @property {string|null} [version] PublicIncreaseDepthsV3Api version
     */
    /**
     * Constructs a new PublicIncreaseDepthsV3Api.
     * @exports PublicIncreaseDepthsV3Api
     * @classdesc Represents a PublicIncreaseDepthsV3Api.
     * @implements IPublicIncreaseDepthsV3Api
     * @constructor
     * @param {IPublicIncreaseDepthsV3Api=} [properties] Properties to set
     */
    function PublicIncreaseDepthsV3Api(properties) {
        this.asks = [];
        this.bids = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicIncreaseDepthsV3Api asks.
     * @member {Array.<IPublicIncreaseDepthV3ApiItem>} asks
     * @memberof PublicIncreaseDepthsV3Api
     * @instance
     */
    PublicIncreaseDepthsV3Api.prototype.asks = $util.emptyArray;
    /**
     * PublicIncreaseDepthsV3Api bids.
     * @member {Array.<IPublicIncreaseDepthV3ApiItem>} bids
     * @memberof PublicIncreaseDepthsV3Api
     * @instance
     */
    PublicIncreaseDepthsV3Api.prototype.bids = $util.emptyArray;
    /**
     * PublicIncreaseDepthsV3Api eventType.
     * @member {string} eventType
     * @memberof PublicIncreaseDepthsV3Api
     * @instance
     */
    PublicIncreaseDepthsV3Api.prototype.eventType = "";
    /**
     * PublicIncreaseDepthsV3Api version.
     * @member {string} version
     * @memberof PublicIncreaseDepthsV3Api
     * @instance
     */
    PublicIncreaseDepthsV3Api.prototype.version = "";
    /**
     * Creates a new PublicIncreaseDepthsV3Api instance using the specified properties.
     * @function create
     * @memberof PublicIncreaseDepthsV3Api
     * @static
     * @param {IPublicIncreaseDepthsV3Api=} [properties] Properties to set
     * @returns {PublicIncreaseDepthsV3Api} PublicIncreaseDepthsV3Api instance
     */
    PublicIncreaseDepthsV3Api.create = function create(properties) {
        return new PublicIncreaseDepthsV3Api(properties);
    };
    /**
     * Encodes the specified PublicIncreaseDepthsV3Api message. Does not implicitly {@link PublicIncreaseDepthsV3Api.verify|verify} messages.
     * @function encode
     * @memberof PublicIncreaseDepthsV3Api
     * @static
     * @param {IPublicIncreaseDepthsV3Api} message PublicIncreaseDepthsV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicIncreaseDepthsV3Api.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.asks != null && message.asks.length)
            for (var i = 0; i < message.asks.length; ++i)
                $root.PublicIncreaseDepthV3ApiItem.encode(message.asks[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        if (message.bids != null && message.bids.length)
            for (var i = 0; i < message.bids.length; ++i)
                $root.PublicIncreaseDepthV3ApiItem.encode(message.bids[i], writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
        if (message.eventType != null && Object.hasOwnProperty.call(message, "eventType"))
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.eventType);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.version);
        return writer;
    };
    /**
     * Encodes the specified PublicIncreaseDepthsV3Api message, length delimited. Does not implicitly {@link PublicIncreaseDepthsV3Api.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicIncreaseDepthsV3Api
     * @static
     * @param {IPublicIncreaseDepthsV3Api} message PublicIncreaseDepthsV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicIncreaseDepthsV3Api.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicIncreaseDepthsV3Api message from the specified reader or buffer.
     * @function decode
     * @memberof PublicIncreaseDepthsV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicIncreaseDepthsV3Api} PublicIncreaseDepthsV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicIncreaseDepthsV3Api.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicIncreaseDepthsV3Api();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    if (!(message.asks && message.asks.length))
                        message.asks = [];
                    message.asks.push($root.PublicIncreaseDepthV3ApiItem.decode(reader, reader.uint32()));
                    break;
                }
                case 2: {
                    if (!(message.bids && message.bids.length))
                        message.bids = [];
                    message.bids.push($root.PublicIncreaseDepthV3ApiItem.decode(reader, reader.uint32()));
                    break;
                }
                case 3: {
                    message.eventType = reader.string();
                    break;
                }
                case 4: {
                    message.version = reader.string();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicIncreaseDepthsV3Api message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicIncreaseDepthsV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicIncreaseDepthsV3Api} PublicIncreaseDepthsV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicIncreaseDepthsV3Api.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicIncreaseDepthsV3Api message.
     * @function verify
     * @memberof PublicIncreaseDepthsV3Api
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicIncreaseDepthsV3Api.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.asks != null && message.hasOwnProperty("asks")) {
            if (!Array.isArray(message.asks))
                return "asks: array expected";
            for (var i = 0; i < message.asks.length; ++i) {
                var error = $root.PublicIncreaseDepthV3ApiItem.verify(message.asks[i]);
                if (error)
                    return "asks." + error;
            }
        }
        if (message.bids != null && message.hasOwnProperty("bids")) {
            if (!Array.isArray(message.bids))
                return "bids: array expected";
            for (var i = 0; i < message.bids.length; ++i) {
                var error = $root.PublicIncreaseDepthV3ApiItem.verify(message.bids[i]);
                if (error)
                    return "bids." + error;
            }
        }
        if (message.eventType != null && message.hasOwnProperty("eventType"))
            if (!$util.isString(message.eventType))
                return "eventType: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isString(message.version))
                return "version: string expected";
        return null;
    };
    /**
     * Creates a PublicIncreaseDepthsV3Api message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicIncreaseDepthsV3Api
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicIncreaseDepthsV3Api} PublicIncreaseDepthsV3Api
     */
    PublicIncreaseDepthsV3Api.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicIncreaseDepthsV3Api)
            return object;
        var message = new $root.PublicIncreaseDepthsV3Api();
        if (object.asks) {
            if (!Array.isArray(object.asks))
                throw TypeError(".PublicIncreaseDepthsV3Api.asks: array expected");
            message.asks = [];
            for (var i = 0; i < object.asks.length; ++i) {
                if (typeof object.asks[i] !== "object")
                    throw TypeError(".PublicIncreaseDepthsV3Api.asks: object expected");
                message.asks[i] = $root.PublicIncreaseDepthV3ApiItem.fromObject(object.asks[i]);
            }
        }
        if (object.bids) {
            if (!Array.isArray(object.bids))
                throw TypeError(".PublicIncreaseDepthsV3Api.bids: array expected");
            message.bids = [];
            for (var i = 0; i < object.bids.length; ++i) {
                if (typeof object.bids[i] !== "object")
                    throw TypeError(".PublicIncreaseDepthsV3Api.bids: object expected");
                message.bids[i] = $root.PublicIncreaseDepthV3ApiItem.fromObject(object.bids[i]);
            }
        }
        if (object.eventType != null)
            message.eventType = String(object.eventType);
        if (object.version != null)
            message.version = String(object.version);
        return message;
    };
    /**
     * Creates a plain object from a PublicIncreaseDepthsV3Api message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicIncreaseDepthsV3Api
     * @static
     * @param {PublicIncreaseDepthsV3Api} message PublicIncreaseDepthsV3Api
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicIncreaseDepthsV3Api.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.asks = [];
            object.bids = [];
        }
        if (options.defaults) {
            object.eventType = "";
            object.version = "";
        }
        if (message.asks && message.asks.length) {
            object.asks = [];
            for (var j = 0; j < message.asks.length; ++j)
                object.asks[j] = $root.PublicIncreaseDepthV3ApiItem.toObject(message.asks[j], options);
        }
        if (message.bids && message.bids.length) {
            object.bids = [];
            for (var j = 0; j < message.bids.length; ++j)
                object.bids[j] = $root.PublicIncreaseDepthV3ApiItem.toObject(message.bids[j], options);
        }
        if (message.eventType != null && message.hasOwnProperty("eventType"))
            object.eventType = message.eventType;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        return object;
    };
    /**
     * Converts this PublicIncreaseDepthsV3Api to JSON.
     * @function toJSON
     * @memberof PublicIncreaseDepthsV3Api
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicIncreaseDepthsV3Api.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicIncreaseDepthsV3Api
     * @function getTypeUrl
     * @memberof PublicIncreaseDepthsV3Api
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicIncreaseDepthsV3Api.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicIncreaseDepthsV3Api";
    };
    return PublicIncreaseDepthsV3Api;
})();
$root.PublicIncreaseDepthV3ApiItem = (function () {
    /**
     * Properties of a PublicIncreaseDepthV3ApiItem.
     * @exports IPublicIncreaseDepthV3ApiItem
     * @interface IPublicIncreaseDepthV3ApiItem
     * @property {string|null} [price] PublicIncreaseDepthV3ApiItem price
     * @property {string|null} [quantity] PublicIncreaseDepthV3ApiItem quantity
     */
    /**
     * Constructs a new PublicIncreaseDepthV3ApiItem.
     * @exports PublicIncreaseDepthV3ApiItem
     * @classdesc Represents a PublicIncreaseDepthV3ApiItem.
     * @implements IPublicIncreaseDepthV3ApiItem
     * @constructor
     * @param {IPublicIncreaseDepthV3ApiItem=} [properties] Properties to set
     */
    function PublicIncreaseDepthV3ApiItem(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicIncreaseDepthV3ApiItem price.
     * @member {string} price
     * @memberof PublicIncreaseDepthV3ApiItem
     * @instance
     */
    PublicIncreaseDepthV3ApiItem.prototype.price = "";
    /**
     * PublicIncreaseDepthV3ApiItem quantity.
     * @member {string} quantity
     * @memberof PublicIncreaseDepthV3ApiItem
     * @instance
     */
    PublicIncreaseDepthV3ApiItem.prototype.quantity = "";
    /**
     * Creates a new PublicIncreaseDepthV3ApiItem instance using the specified properties.
     * @function create
     * @memberof PublicIncreaseDepthV3ApiItem
     * @static
     * @param {IPublicIncreaseDepthV3ApiItem=} [properties] Properties to set
     * @returns {PublicIncreaseDepthV3ApiItem} PublicIncreaseDepthV3ApiItem instance
     */
    PublicIncreaseDepthV3ApiItem.create = function create(properties) {
        return new PublicIncreaseDepthV3ApiItem(properties);
    };
    /**
     * Encodes the specified PublicIncreaseDepthV3ApiItem message. Does not implicitly {@link PublicIncreaseDepthV3ApiItem.verify|verify} messages.
     * @function encode
     * @memberof PublicIncreaseDepthV3ApiItem
     * @static
     * @param {IPublicIncreaseDepthV3ApiItem} message PublicIncreaseDepthV3ApiItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicIncreaseDepthV3ApiItem.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.price);
        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.quantity);
        return writer;
    };
    /**
     * Encodes the specified PublicIncreaseDepthV3ApiItem message, length delimited. Does not implicitly {@link PublicIncreaseDepthV3ApiItem.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicIncreaseDepthV3ApiItem
     * @static
     * @param {IPublicIncreaseDepthV3ApiItem} message PublicIncreaseDepthV3ApiItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicIncreaseDepthV3ApiItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicIncreaseDepthV3ApiItem message from the specified reader or buffer.
     * @function decode
     * @memberof PublicIncreaseDepthV3ApiItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicIncreaseDepthV3ApiItem} PublicIncreaseDepthV3ApiItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicIncreaseDepthV3ApiItem.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicIncreaseDepthV3ApiItem();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    message.price = reader.string();
                    break;
                }
                case 2: {
                    message.quantity = reader.string();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicIncreaseDepthV3ApiItem message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicIncreaseDepthV3ApiItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicIncreaseDepthV3ApiItem} PublicIncreaseDepthV3ApiItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicIncreaseDepthV3ApiItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicIncreaseDepthV3ApiItem message.
     * @function verify
     * @memberof PublicIncreaseDepthV3ApiItem
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicIncreaseDepthV3ApiItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.price != null && message.hasOwnProperty("price"))
            if (!$util.isString(message.price))
                return "price: string expected";
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (!$util.isString(message.quantity))
                return "quantity: string expected";
        return null;
    };
    /**
     * Creates a PublicIncreaseDepthV3ApiItem message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicIncreaseDepthV3ApiItem
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicIncreaseDepthV3ApiItem} PublicIncreaseDepthV3ApiItem
     */
    PublicIncreaseDepthV3ApiItem.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicIncreaseDepthV3ApiItem)
            return object;
        var message = new $root.PublicIncreaseDepthV3ApiItem();
        if (object.price != null)
            message.price = String(object.price);
        if (object.quantity != null)
            message.quantity = String(object.quantity);
        return message;
    };
    /**
     * Creates a plain object from a PublicIncreaseDepthV3ApiItem message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicIncreaseDepthV3ApiItem
     * @static
     * @param {PublicIncreaseDepthV3ApiItem} message PublicIncreaseDepthV3ApiItem
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicIncreaseDepthV3ApiItem.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.price = "";
            object.quantity = "";
        }
        if (message.price != null && message.hasOwnProperty("price"))
            object.price = message.price;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            object.quantity = message.quantity;
        return object;
    };
    /**
     * Converts this PublicIncreaseDepthV3ApiItem to JSON.
     * @function toJSON
     * @memberof PublicIncreaseDepthV3ApiItem
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicIncreaseDepthV3ApiItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicIncreaseDepthV3ApiItem
     * @function getTypeUrl
     * @memberof PublicIncreaseDepthV3ApiItem
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicIncreaseDepthV3ApiItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicIncreaseDepthV3ApiItem";
    };
    return PublicIncreaseDepthV3ApiItem;
})();
$root.PublicLimitDepthsV3Api = (function () {
    /**
     * Properties of a PublicLimitDepthsV3Api.
     * @exports IPublicLimitDepthsV3Api
     * @interface IPublicLimitDepthsV3Api
     * @property {Array.<IPublicLimitDepthV3ApiItem>|null} [asks] PublicLimitDepthsV3Api asks
     * @property {Array.<IPublicLimitDepthV3ApiItem>|null} [bids] PublicLimitDepthsV3Api bids
     * @property {string|null} [eventType] PublicLimitDepthsV3Api eventType
     * @property {string|null} [version] PublicLimitDepthsV3Api version
     */
    /**
     * Constructs a new PublicLimitDepthsV3Api.
     * @exports PublicLimitDepthsV3Api
     * @classdesc Represents a PublicLimitDepthsV3Api.
     * @implements IPublicLimitDepthsV3Api
     * @constructor
     * @param {IPublicLimitDepthsV3Api=} [properties] Properties to set
     */
    function PublicLimitDepthsV3Api(properties) {
        this.asks = [];
        this.bids = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicLimitDepthsV3Api asks.
     * @member {Array.<IPublicLimitDepthV3ApiItem>} asks
     * @memberof PublicLimitDepthsV3Api
     * @instance
     */
    PublicLimitDepthsV3Api.prototype.asks = $util.emptyArray;
    /**
     * PublicLimitDepthsV3Api bids.
     * @member {Array.<IPublicLimitDepthV3ApiItem>} bids
     * @memberof PublicLimitDepthsV3Api
     * @instance
     */
    PublicLimitDepthsV3Api.prototype.bids = $util.emptyArray;
    /**
     * PublicLimitDepthsV3Api eventType.
     * @member {string} eventType
     * @memberof PublicLimitDepthsV3Api
     * @instance
     */
    PublicLimitDepthsV3Api.prototype.eventType = "";
    /**
     * PublicLimitDepthsV3Api version.
     * @member {string} version
     * @memberof PublicLimitDepthsV3Api
     * @instance
     */
    PublicLimitDepthsV3Api.prototype.version = "";
    /**
     * Creates a new PublicLimitDepthsV3Api instance using the specified properties.
     * @function create
     * @memberof PublicLimitDepthsV3Api
     * @static
     * @param {IPublicLimitDepthsV3Api=} [properties] Properties to set
     * @returns {PublicLimitDepthsV3Api} PublicLimitDepthsV3Api instance
     */
    PublicLimitDepthsV3Api.create = function create(properties) {
        return new PublicLimitDepthsV3Api(properties);
    };
    /**
     * Encodes the specified PublicLimitDepthsV3Api message. Does not implicitly {@link PublicLimitDepthsV3Api.verify|verify} messages.
     * @function encode
     * @memberof PublicLimitDepthsV3Api
     * @static
     * @param {IPublicLimitDepthsV3Api} message PublicLimitDepthsV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicLimitDepthsV3Api.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.asks != null && message.asks.length)
            for (var i = 0; i < message.asks.length; ++i)
                $root.PublicLimitDepthV3ApiItem.encode(message.asks[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        if (message.bids != null && message.bids.length)
            for (var i = 0; i < message.bids.length; ++i)
                $root.PublicLimitDepthV3ApiItem.encode(message.bids[i], writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
        if (message.eventType != null && Object.hasOwnProperty.call(message, "eventType"))
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.eventType);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.version);
        return writer;
    };
    /**
     * Encodes the specified PublicLimitDepthsV3Api message, length delimited. Does not implicitly {@link PublicLimitDepthsV3Api.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicLimitDepthsV3Api
     * @static
     * @param {IPublicLimitDepthsV3Api} message PublicLimitDepthsV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicLimitDepthsV3Api.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicLimitDepthsV3Api message from the specified reader or buffer.
     * @function decode
     * @memberof PublicLimitDepthsV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicLimitDepthsV3Api} PublicLimitDepthsV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicLimitDepthsV3Api.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicLimitDepthsV3Api();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    if (!(message.asks && message.asks.length))
                        message.asks = [];
                    message.asks.push($root.PublicLimitDepthV3ApiItem.decode(reader, reader.uint32()));
                    break;
                }
                case 2: {
                    if (!(message.bids && message.bids.length))
                        message.bids = [];
                    message.bids.push($root.PublicLimitDepthV3ApiItem.decode(reader, reader.uint32()));
                    break;
                }
                case 3: {
                    message.eventType = reader.string();
                    break;
                }
                case 4: {
                    message.version = reader.string();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicLimitDepthsV3Api message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicLimitDepthsV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicLimitDepthsV3Api} PublicLimitDepthsV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicLimitDepthsV3Api.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicLimitDepthsV3Api message.
     * @function verify
     * @memberof PublicLimitDepthsV3Api
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicLimitDepthsV3Api.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.asks != null && message.hasOwnProperty("asks")) {
            if (!Array.isArray(message.asks))
                return "asks: array expected";
            for (var i = 0; i < message.asks.length; ++i) {
                var error = $root.PublicLimitDepthV3ApiItem.verify(message.asks[i]);
                if (error)
                    return "asks." + error;
            }
        }
        if (message.bids != null && message.hasOwnProperty("bids")) {
            if (!Array.isArray(message.bids))
                return "bids: array expected";
            for (var i = 0; i < message.bids.length; ++i) {
                var error = $root.PublicLimitDepthV3ApiItem.verify(message.bids[i]);
                if (error)
                    return "bids." + error;
            }
        }
        if (message.eventType != null && message.hasOwnProperty("eventType"))
            if (!$util.isString(message.eventType))
                return "eventType: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isString(message.version))
                return "version: string expected";
        return null;
    };
    /**
     * Creates a PublicLimitDepthsV3Api message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicLimitDepthsV3Api
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicLimitDepthsV3Api} PublicLimitDepthsV3Api
     */
    PublicLimitDepthsV3Api.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicLimitDepthsV3Api)
            return object;
        var message = new $root.PublicLimitDepthsV3Api();
        if (object.asks) {
            if (!Array.isArray(object.asks))
                throw TypeError(".PublicLimitDepthsV3Api.asks: array expected");
            message.asks = [];
            for (var i = 0; i < object.asks.length; ++i) {
                if (typeof object.asks[i] !== "object")
                    throw TypeError(".PublicLimitDepthsV3Api.asks: object expected");
                message.asks[i] = $root.PublicLimitDepthV3ApiItem.fromObject(object.asks[i]);
            }
        }
        if (object.bids) {
            if (!Array.isArray(object.bids))
                throw TypeError(".PublicLimitDepthsV3Api.bids: array expected");
            message.bids = [];
            for (var i = 0; i < object.bids.length; ++i) {
                if (typeof object.bids[i] !== "object")
                    throw TypeError(".PublicLimitDepthsV3Api.bids: object expected");
                message.bids[i] = $root.PublicLimitDepthV3ApiItem.fromObject(object.bids[i]);
            }
        }
        if (object.eventType != null)
            message.eventType = String(object.eventType);
        if (object.version != null)
            message.version = String(object.version);
        return message;
    };
    /**
     * Creates a plain object from a PublicLimitDepthsV3Api message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicLimitDepthsV3Api
     * @static
     * @param {PublicLimitDepthsV3Api} message PublicLimitDepthsV3Api
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicLimitDepthsV3Api.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.asks = [];
            object.bids = [];
        }
        if (options.defaults) {
            object.eventType = "";
            object.version = "";
        }
        if (message.asks && message.asks.length) {
            object.asks = [];
            for (var j = 0; j < message.asks.length; ++j)
                object.asks[j] = $root.PublicLimitDepthV3ApiItem.toObject(message.asks[j], options);
        }
        if (message.bids && message.bids.length) {
            object.bids = [];
            for (var j = 0; j < message.bids.length; ++j)
                object.bids[j] = $root.PublicLimitDepthV3ApiItem.toObject(message.bids[j], options);
        }
        if (message.eventType != null && message.hasOwnProperty("eventType"))
            object.eventType = message.eventType;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        return object;
    };
    /**
     * Converts this PublicLimitDepthsV3Api to JSON.
     * @function toJSON
     * @memberof PublicLimitDepthsV3Api
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicLimitDepthsV3Api.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicLimitDepthsV3Api
     * @function getTypeUrl
     * @memberof PublicLimitDepthsV3Api
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicLimitDepthsV3Api.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicLimitDepthsV3Api";
    };
    return PublicLimitDepthsV3Api;
})();
$root.PublicLimitDepthV3ApiItem = (function () {
    /**
     * Properties of a PublicLimitDepthV3ApiItem.
     * @exports IPublicLimitDepthV3ApiItem
     * @interface IPublicLimitDepthV3ApiItem
     * @property {string|null} [price] PublicLimitDepthV3ApiItem price
     * @property {string|null} [quantity] PublicLimitDepthV3ApiItem quantity
     */
    /**
     * Constructs a new PublicLimitDepthV3ApiItem.
     * @exports PublicLimitDepthV3ApiItem
     * @classdesc Represents a PublicLimitDepthV3ApiItem.
     * @implements IPublicLimitDepthV3ApiItem
     * @constructor
     * @param {IPublicLimitDepthV3ApiItem=} [properties] Properties to set
     */
    function PublicLimitDepthV3ApiItem(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicLimitDepthV3ApiItem price.
     * @member {string} price
     * @memberof PublicLimitDepthV3ApiItem
     * @instance
     */
    PublicLimitDepthV3ApiItem.prototype.price = "";
    /**
     * PublicLimitDepthV3ApiItem quantity.
     * @member {string} quantity
     * @memberof PublicLimitDepthV3ApiItem
     * @instance
     */
    PublicLimitDepthV3ApiItem.prototype.quantity = "";
    /**
     * Creates a new PublicLimitDepthV3ApiItem instance using the specified properties.
     * @function create
     * @memberof PublicLimitDepthV3ApiItem
     * @static
     * @param {IPublicLimitDepthV3ApiItem=} [properties] Properties to set
     * @returns {PublicLimitDepthV3ApiItem} PublicLimitDepthV3ApiItem instance
     */
    PublicLimitDepthV3ApiItem.create = function create(properties) {
        return new PublicLimitDepthV3ApiItem(properties);
    };
    /**
     * Encodes the specified PublicLimitDepthV3ApiItem message. Does not implicitly {@link PublicLimitDepthV3ApiItem.verify|verify} messages.
     * @function encode
     * @memberof PublicLimitDepthV3ApiItem
     * @static
     * @param {IPublicLimitDepthV3ApiItem} message PublicLimitDepthV3ApiItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicLimitDepthV3ApiItem.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.price);
        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.quantity);
        return writer;
    };
    /**
     * Encodes the specified PublicLimitDepthV3ApiItem message, length delimited. Does not implicitly {@link PublicLimitDepthV3ApiItem.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicLimitDepthV3ApiItem
     * @static
     * @param {IPublicLimitDepthV3ApiItem} message PublicLimitDepthV3ApiItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicLimitDepthV3ApiItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicLimitDepthV3ApiItem message from the specified reader or buffer.
     * @function decode
     * @memberof PublicLimitDepthV3ApiItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicLimitDepthV3ApiItem} PublicLimitDepthV3ApiItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicLimitDepthV3ApiItem.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicLimitDepthV3ApiItem();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    message.price = reader.string();
                    break;
                }
                case 2: {
                    message.quantity = reader.string();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicLimitDepthV3ApiItem message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicLimitDepthV3ApiItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicLimitDepthV3ApiItem} PublicLimitDepthV3ApiItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicLimitDepthV3ApiItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicLimitDepthV3ApiItem message.
     * @function verify
     * @memberof PublicLimitDepthV3ApiItem
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicLimitDepthV3ApiItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.price != null && message.hasOwnProperty("price"))
            if (!$util.isString(message.price))
                return "price: string expected";
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (!$util.isString(message.quantity))
                return "quantity: string expected";
        return null;
    };
    /**
     * Creates a PublicLimitDepthV3ApiItem message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicLimitDepthV3ApiItem
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicLimitDepthV3ApiItem} PublicLimitDepthV3ApiItem
     */
    PublicLimitDepthV3ApiItem.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicLimitDepthV3ApiItem)
            return object;
        var message = new $root.PublicLimitDepthV3ApiItem();
        if (object.price != null)
            message.price = String(object.price);
        if (object.quantity != null)
            message.quantity = String(object.quantity);
        return message;
    };
    /**
     * Creates a plain object from a PublicLimitDepthV3ApiItem message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicLimitDepthV3ApiItem
     * @static
     * @param {PublicLimitDepthV3ApiItem} message PublicLimitDepthV3ApiItem
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicLimitDepthV3ApiItem.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.price = "";
            object.quantity = "";
        }
        if (message.price != null && message.hasOwnProperty("price"))
            object.price = message.price;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            object.quantity = message.quantity;
        return object;
    };
    /**
     * Converts this PublicLimitDepthV3ApiItem to JSON.
     * @function toJSON
     * @memberof PublicLimitDepthV3ApiItem
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicLimitDepthV3ApiItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicLimitDepthV3ApiItem
     * @function getTypeUrl
     * @memberof PublicLimitDepthV3ApiItem
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicLimitDepthV3ApiItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicLimitDepthV3ApiItem";
    };
    return PublicLimitDepthV3ApiItem;
})();
$root.PublicMiniTickerV3Api = (function () {
    /**
     * Properties of a PublicMiniTickerV3Api.
     * @exports IPublicMiniTickerV3Api
     * @interface IPublicMiniTickerV3Api
     * @property {string|null} [symbol] PublicMiniTickerV3Api symbol
     * @property {string|null} [price] PublicMiniTickerV3Api price
     * @property {string|null} [rate] PublicMiniTickerV3Api rate
     * @property {string|null} [zonedRate] PublicMiniTickerV3Api zonedRate
     * @property {string|null} [high] PublicMiniTickerV3Api high
     * @property {string|null} [low] PublicMiniTickerV3Api low
     * @property {string|null} [volume] PublicMiniTickerV3Api volume
     * @property {string|null} [quantity] PublicMiniTickerV3Api quantity
     * @property {string|null} [lastCloseRate] PublicMiniTickerV3Api lastCloseRate
     * @property {string|null} [lastCloseZonedRate] PublicMiniTickerV3Api lastCloseZonedRate
     * @property {string|null} [lastCloseHigh] PublicMiniTickerV3Api lastCloseHigh
     * @property {string|null} [lastCloseLow] PublicMiniTickerV3Api lastCloseLow
     */
    /**
     * Constructs a new PublicMiniTickerV3Api.
     * @exports PublicMiniTickerV3Api
     * @classdesc Represents a PublicMiniTickerV3Api.
     * @implements IPublicMiniTickerV3Api
     * @constructor
     * @param {IPublicMiniTickerV3Api=} [properties] Properties to set
     */
    function PublicMiniTickerV3Api(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicMiniTickerV3Api symbol.
     * @member {string} symbol
     * @memberof PublicMiniTickerV3Api
     * @instance
     */
    PublicMiniTickerV3Api.prototype.symbol = "";
    /**
     * PublicMiniTickerV3Api price.
     * @member {string} price
     * @memberof PublicMiniTickerV3Api
     * @instance
     */
    PublicMiniTickerV3Api.prototype.price = "";
    /**
     * PublicMiniTickerV3Api rate.
     * @member {string} rate
     * @memberof PublicMiniTickerV3Api
     * @instance
     */
    PublicMiniTickerV3Api.prototype.rate = "";
    /**
     * PublicMiniTickerV3Api zonedRate.
     * @member {string} zonedRate
     * @memberof PublicMiniTickerV3Api
     * @instance
     */
    PublicMiniTickerV3Api.prototype.zonedRate = "";
    /**
     * PublicMiniTickerV3Api high.
     * @member {string} high
     * @memberof PublicMiniTickerV3Api
     * @instance
     */
    PublicMiniTickerV3Api.prototype.high = "";
    /**
     * PublicMiniTickerV3Api low.
     * @member {string} low
     * @memberof PublicMiniTickerV3Api
     * @instance
     */
    PublicMiniTickerV3Api.prototype.low = "";
    /**
     * PublicMiniTickerV3Api volume.
     * @member {string} volume
     * @memberof PublicMiniTickerV3Api
     * @instance
     */
    PublicMiniTickerV3Api.prototype.volume = "";
    /**
     * PublicMiniTickerV3Api quantity.
     * @member {string} quantity
     * @memberof PublicMiniTickerV3Api
     * @instance
     */
    PublicMiniTickerV3Api.prototype.quantity = "";
    /**
     * PublicMiniTickerV3Api lastCloseRate.
     * @member {string} lastCloseRate
     * @memberof PublicMiniTickerV3Api
     * @instance
     */
    PublicMiniTickerV3Api.prototype.lastCloseRate = "";
    /**
     * PublicMiniTickerV3Api lastCloseZonedRate.
     * @member {string} lastCloseZonedRate
     * @memberof PublicMiniTickerV3Api
     * @instance
     */
    PublicMiniTickerV3Api.prototype.lastCloseZonedRate = "";
    /**
     * PublicMiniTickerV3Api lastCloseHigh.
     * @member {string} lastCloseHigh
     * @memberof PublicMiniTickerV3Api
     * @instance
     */
    PublicMiniTickerV3Api.prototype.lastCloseHigh = "";
    /**
     * PublicMiniTickerV3Api lastCloseLow.
     * @member {string} lastCloseLow
     * @memberof PublicMiniTickerV3Api
     * @instance
     */
    PublicMiniTickerV3Api.prototype.lastCloseLow = "";
    /**
     * Creates a new PublicMiniTickerV3Api instance using the specified properties.
     * @function create
     * @memberof PublicMiniTickerV3Api
     * @static
     * @param {IPublicMiniTickerV3Api=} [properties] Properties to set
     * @returns {PublicMiniTickerV3Api} PublicMiniTickerV3Api instance
     */
    PublicMiniTickerV3Api.create = function create(properties) {
        return new PublicMiniTickerV3Api(properties);
    };
    /**
     * Encodes the specified PublicMiniTickerV3Api message. Does not implicitly {@link PublicMiniTickerV3Api.verify|verify} messages.
     * @function encode
     * @memberof PublicMiniTickerV3Api
     * @static
     * @param {IPublicMiniTickerV3Api} message PublicMiniTickerV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicMiniTickerV3Api.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.symbol);
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.price);
        if (message.rate != null && Object.hasOwnProperty.call(message, "rate"))
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.rate);
        if (message.zonedRate != null && Object.hasOwnProperty.call(message, "zonedRate"))
            writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.zonedRate);
        if (message.high != null && Object.hasOwnProperty.call(message, "high"))
            writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.high);
        if (message.low != null && Object.hasOwnProperty.call(message, "low"))
            writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.low);
        if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
            writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.volume);
        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.quantity);
        if (message.lastCloseRate != null && Object.hasOwnProperty.call(message, "lastCloseRate"))
            writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.lastCloseRate);
        if (message.lastCloseZonedRate != null && Object.hasOwnProperty.call(message, "lastCloseZonedRate"))
            writer.uint32(/* id 10, wireType 2 =*/ 82).string(message.lastCloseZonedRate);
        if (message.lastCloseHigh != null && Object.hasOwnProperty.call(message, "lastCloseHigh"))
            writer.uint32(/* id 11, wireType 2 =*/ 90).string(message.lastCloseHigh);
        if (message.lastCloseLow != null && Object.hasOwnProperty.call(message, "lastCloseLow"))
            writer.uint32(/* id 12, wireType 2 =*/ 98).string(message.lastCloseLow);
        return writer;
    };
    /**
     * Encodes the specified PublicMiniTickerV3Api message, length delimited. Does not implicitly {@link PublicMiniTickerV3Api.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicMiniTickerV3Api
     * @static
     * @param {IPublicMiniTickerV3Api} message PublicMiniTickerV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicMiniTickerV3Api.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicMiniTickerV3Api message from the specified reader or buffer.
     * @function decode
     * @memberof PublicMiniTickerV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicMiniTickerV3Api} PublicMiniTickerV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicMiniTickerV3Api.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicMiniTickerV3Api();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    message.symbol = reader.string();
                    break;
                }
                case 2: {
                    message.price = reader.string();
                    break;
                }
                case 3: {
                    message.rate = reader.string();
                    break;
                }
                case 4: {
                    message.zonedRate = reader.string();
                    break;
                }
                case 5: {
                    message.high = reader.string();
                    break;
                }
                case 6: {
                    message.low = reader.string();
                    break;
                }
                case 7: {
                    message.volume = reader.string();
                    break;
                }
                case 8: {
                    message.quantity = reader.string();
                    break;
                }
                case 9: {
                    message.lastCloseRate = reader.string();
                    break;
                }
                case 10: {
                    message.lastCloseZonedRate = reader.string();
                    break;
                }
                case 11: {
                    message.lastCloseHigh = reader.string();
                    break;
                }
                case 12: {
                    message.lastCloseLow = reader.string();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicMiniTickerV3Api message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicMiniTickerV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicMiniTickerV3Api} PublicMiniTickerV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicMiniTickerV3Api.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicMiniTickerV3Api message.
     * @function verify
     * @memberof PublicMiniTickerV3Api
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicMiniTickerV3Api.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            if (!$util.isString(message.symbol))
                return "symbol: string expected";
        if (message.price != null && message.hasOwnProperty("price"))
            if (!$util.isString(message.price))
                return "price: string expected";
        if (message.rate != null && message.hasOwnProperty("rate"))
            if (!$util.isString(message.rate))
                return "rate: string expected";
        if (message.zonedRate != null && message.hasOwnProperty("zonedRate"))
            if (!$util.isString(message.zonedRate))
                return "zonedRate: string expected";
        if (message.high != null && message.hasOwnProperty("high"))
            if (!$util.isString(message.high))
                return "high: string expected";
        if (message.low != null && message.hasOwnProperty("low"))
            if (!$util.isString(message.low))
                return "low: string expected";
        if (message.volume != null && message.hasOwnProperty("volume"))
            if (!$util.isString(message.volume))
                return "volume: string expected";
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (!$util.isString(message.quantity))
                return "quantity: string expected";
        if (message.lastCloseRate != null && message.hasOwnProperty("lastCloseRate"))
            if (!$util.isString(message.lastCloseRate))
                return "lastCloseRate: string expected";
        if (message.lastCloseZonedRate != null && message.hasOwnProperty("lastCloseZonedRate"))
            if (!$util.isString(message.lastCloseZonedRate))
                return "lastCloseZonedRate: string expected";
        if (message.lastCloseHigh != null && message.hasOwnProperty("lastCloseHigh"))
            if (!$util.isString(message.lastCloseHigh))
                return "lastCloseHigh: string expected";
        if (message.lastCloseLow != null && message.hasOwnProperty("lastCloseLow"))
            if (!$util.isString(message.lastCloseLow))
                return "lastCloseLow: string expected";
        return null;
    };
    /**
     * Creates a PublicMiniTickerV3Api message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicMiniTickerV3Api
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicMiniTickerV3Api} PublicMiniTickerV3Api
     */
    PublicMiniTickerV3Api.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicMiniTickerV3Api)
            return object;
        var message = new $root.PublicMiniTickerV3Api();
        if (object.symbol != null)
            message.symbol = String(object.symbol);
        if (object.price != null)
            message.price = String(object.price);
        if (object.rate != null)
            message.rate = String(object.rate);
        if (object.zonedRate != null)
            message.zonedRate = String(object.zonedRate);
        if (object.high != null)
            message.high = String(object.high);
        if (object.low != null)
            message.low = String(object.low);
        if (object.volume != null)
            message.volume = String(object.volume);
        if (object.quantity != null)
            message.quantity = String(object.quantity);
        if (object.lastCloseRate != null)
            message.lastCloseRate = String(object.lastCloseRate);
        if (object.lastCloseZonedRate != null)
            message.lastCloseZonedRate = String(object.lastCloseZonedRate);
        if (object.lastCloseHigh != null)
            message.lastCloseHigh = String(object.lastCloseHigh);
        if (object.lastCloseLow != null)
            message.lastCloseLow = String(object.lastCloseLow);
        return message;
    };
    /**
     * Creates a plain object from a PublicMiniTickerV3Api message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicMiniTickerV3Api
     * @static
     * @param {PublicMiniTickerV3Api} message PublicMiniTickerV3Api
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicMiniTickerV3Api.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.symbol = "";
            object.price = "";
            object.rate = "";
            object.zonedRate = "";
            object.high = "";
            object.low = "";
            object.volume = "";
            object.quantity = "";
            object.lastCloseRate = "";
            object.lastCloseZonedRate = "";
            object.lastCloseHigh = "";
            object.lastCloseLow = "";
        }
        if (message.symbol != null && message.hasOwnProperty("symbol"))
            object.symbol = message.symbol;
        if (message.price != null && message.hasOwnProperty("price"))
            object.price = message.price;
        if (message.rate != null && message.hasOwnProperty("rate"))
            object.rate = message.rate;
        if (message.zonedRate != null && message.hasOwnProperty("zonedRate"))
            object.zonedRate = message.zonedRate;
        if (message.high != null && message.hasOwnProperty("high"))
            object.high = message.high;
        if (message.low != null && message.hasOwnProperty("low"))
            object.low = message.low;
        if (message.volume != null && message.hasOwnProperty("volume"))
            object.volume = message.volume;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            object.quantity = message.quantity;
        if (message.lastCloseRate != null && message.hasOwnProperty("lastCloseRate"))
            object.lastCloseRate = message.lastCloseRate;
        if (message.lastCloseZonedRate != null && message.hasOwnProperty("lastCloseZonedRate"))
            object.lastCloseZonedRate = message.lastCloseZonedRate;
        if (message.lastCloseHigh != null && message.hasOwnProperty("lastCloseHigh"))
            object.lastCloseHigh = message.lastCloseHigh;
        if (message.lastCloseLow != null && message.hasOwnProperty("lastCloseLow"))
            object.lastCloseLow = message.lastCloseLow;
        return object;
    };
    /**
     * Converts this PublicMiniTickerV3Api to JSON.
     * @function toJSON
     * @memberof PublicMiniTickerV3Api
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicMiniTickerV3Api.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicMiniTickerV3Api
     * @function getTypeUrl
     * @memberof PublicMiniTickerV3Api
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicMiniTickerV3Api.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicMiniTickerV3Api";
    };
    return PublicMiniTickerV3Api;
})();
$root.PublicMiniTickersV3Api = (function () {
    /**
     * Properties of a PublicMiniTickersV3Api.
     * @exports IPublicMiniTickersV3Api
     * @interface IPublicMiniTickersV3Api
     * @property {Array.<IPublicMiniTickerV3Api>|null} [items] PublicMiniTickersV3Api items
     */
    /**
     * Constructs a new PublicMiniTickersV3Api.
     * @exports PublicMiniTickersV3Api
     * @classdesc Represents a PublicMiniTickersV3Api.
     * @implements IPublicMiniTickersV3Api
     * @constructor
     * @param {IPublicMiniTickersV3Api=} [properties] Properties to set
     */
    function PublicMiniTickersV3Api(properties) {
        this.items = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicMiniTickersV3Api items.
     * @member {Array.<IPublicMiniTickerV3Api>} items
     * @memberof PublicMiniTickersV3Api
     * @instance
     */
    PublicMiniTickersV3Api.prototype.items = $util.emptyArray;
    /**
     * Creates a new PublicMiniTickersV3Api instance using the specified properties.
     * @function create
     * @memberof PublicMiniTickersV3Api
     * @static
     * @param {IPublicMiniTickersV3Api=} [properties] Properties to set
     * @returns {PublicMiniTickersV3Api} PublicMiniTickersV3Api instance
     */
    PublicMiniTickersV3Api.create = function create(properties) {
        return new PublicMiniTickersV3Api(properties);
    };
    /**
     * Encodes the specified PublicMiniTickersV3Api message. Does not implicitly {@link PublicMiniTickersV3Api.verify|verify} messages.
     * @function encode
     * @memberof PublicMiniTickersV3Api
     * @static
     * @param {IPublicMiniTickersV3Api} message PublicMiniTickersV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicMiniTickersV3Api.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.items != null && message.items.length)
            for (var i = 0; i < message.items.length; ++i)
                $root.PublicMiniTickerV3Api.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified PublicMiniTickersV3Api message, length delimited. Does not implicitly {@link PublicMiniTickersV3Api.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicMiniTickersV3Api
     * @static
     * @param {IPublicMiniTickersV3Api} message PublicMiniTickersV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicMiniTickersV3Api.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicMiniTickersV3Api message from the specified reader or buffer.
     * @function decode
     * @memberof PublicMiniTickersV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicMiniTickersV3Api} PublicMiniTickersV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicMiniTickersV3Api.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicMiniTickersV3Api();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    if (!(message.items && message.items.length))
                        message.items = [];
                    message.items.push($root.PublicMiniTickerV3Api.decode(reader, reader.uint32()));
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicMiniTickersV3Api message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicMiniTickersV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicMiniTickersV3Api} PublicMiniTickersV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicMiniTickersV3Api.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicMiniTickersV3Api message.
     * @function verify
     * @memberof PublicMiniTickersV3Api
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicMiniTickersV3Api.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.items != null && message.hasOwnProperty("items")) {
            if (!Array.isArray(message.items))
                return "items: array expected";
            for (var i = 0; i < message.items.length; ++i) {
                var error = $root.PublicMiniTickerV3Api.verify(message.items[i]);
                if (error)
                    return "items." + error;
            }
        }
        return null;
    };
    /**
     * Creates a PublicMiniTickersV3Api message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicMiniTickersV3Api
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicMiniTickersV3Api} PublicMiniTickersV3Api
     */
    PublicMiniTickersV3Api.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicMiniTickersV3Api)
            return object;
        var message = new $root.PublicMiniTickersV3Api();
        if (object.items) {
            if (!Array.isArray(object.items))
                throw TypeError(".PublicMiniTickersV3Api.items: array expected");
            message.items = [];
            for (var i = 0; i < object.items.length; ++i) {
                if (typeof object.items[i] !== "object")
                    throw TypeError(".PublicMiniTickersV3Api.items: object expected");
                message.items[i] = $root.PublicMiniTickerV3Api.fromObject(object.items[i]);
            }
        }
        return message;
    };
    /**
     * Creates a plain object from a PublicMiniTickersV3Api message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicMiniTickersV3Api
     * @static
     * @param {PublicMiniTickersV3Api} message PublicMiniTickersV3Api
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicMiniTickersV3Api.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.items = [];
        if (message.items && message.items.length) {
            object.items = [];
            for (var j = 0; j < message.items.length; ++j)
                object.items[j] = $root.PublicMiniTickerV3Api.toObject(message.items[j], options);
        }
        return object;
    };
    /**
     * Converts this PublicMiniTickersV3Api to JSON.
     * @function toJSON
     * @memberof PublicMiniTickersV3Api
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicMiniTickersV3Api.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicMiniTickersV3Api
     * @function getTypeUrl
     * @memberof PublicMiniTickersV3Api
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicMiniTickersV3Api.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicMiniTickersV3Api";
    };
    return PublicMiniTickersV3Api;
})();
$root.PublicSpotKlineV3Api = (function () {
    /**
     * Properties of a PublicSpotKlineV3Api.
     * @exports IPublicSpotKlineV3Api
     * @interface IPublicSpotKlineV3Api
     * @property {string|null} [interval] PublicSpotKlineV3Api interval
     * @property {number|Long|null} [windowStart] PublicSpotKlineV3Api windowStart
     * @property {string|null} [openingPrice] PublicSpotKlineV3Api openingPrice
     * @property {string|null} [closingPrice] PublicSpotKlineV3Api closingPrice
     * @property {string|null} [highestPrice] PublicSpotKlineV3Api highestPrice
     * @property {string|null} [lowestPrice] PublicSpotKlineV3Api lowestPrice
     * @property {string|null} [volume] PublicSpotKlineV3Api volume
     * @property {string|null} [amount] PublicSpotKlineV3Api amount
     * @property {number|Long|null} [windowEnd] PublicSpotKlineV3Api windowEnd
     */
    /**
     * Constructs a new PublicSpotKlineV3Api.
     * @exports PublicSpotKlineV3Api
     * @classdesc Represents a PublicSpotKlineV3Api.
     * @implements IPublicSpotKlineV3Api
     * @constructor
     * @param {IPublicSpotKlineV3Api=} [properties] Properties to set
     */
    function PublicSpotKlineV3Api(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * PublicSpotKlineV3Api interval.
     * @member {string} interval
     * @memberof PublicSpotKlineV3Api
     * @instance
     */
    PublicSpotKlineV3Api.prototype.interval = "";
    /**
     * PublicSpotKlineV3Api windowStart.
     * @member {number|Long} windowStart
     * @memberof PublicSpotKlineV3Api
     * @instance
     */
    PublicSpotKlineV3Api.prototype.windowStart = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    /**
     * PublicSpotKlineV3Api openingPrice.
     * @member {string} openingPrice
     * @memberof PublicSpotKlineV3Api
     * @instance
     */
    PublicSpotKlineV3Api.prototype.openingPrice = "";
    /**
     * PublicSpotKlineV3Api closingPrice.
     * @member {string} closingPrice
     * @memberof PublicSpotKlineV3Api
     * @instance
     */
    PublicSpotKlineV3Api.prototype.closingPrice = "";
    /**
     * PublicSpotKlineV3Api highestPrice.
     * @member {string} highestPrice
     * @memberof PublicSpotKlineV3Api
     * @instance
     */
    PublicSpotKlineV3Api.prototype.highestPrice = "";
    /**
     * PublicSpotKlineV3Api lowestPrice.
     * @member {string} lowestPrice
     * @memberof PublicSpotKlineV3Api
     * @instance
     */
    PublicSpotKlineV3Api.prototype.lowestPrice = "";
    /**
     * PublicSpotKlineV3Api volume.
     * @member {string} volume
     * @memberof PublicSpotKlineV3Api
     * @instance
     */
    PublicSpotKlineV3Api.prototype.volume = "";
    /**
     * PublicSpotKlineV3Api amount.
     * @member {string} amount
     * @memberof PublicSpotKlineV3Api
     * @instance
     */
    PublicSpotKlineV3Api.prototype.amount = "";
    /**
     * PublicSpotKlineV3Api windowEnd.
     * @member {number|Long} windowEnd
     * @memberof PublicSpotKlineV3Api
     * @instance
     */
    PublicSpotKlineV3Api.prototype.windowEnd = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
    /**
     * Creates a new PublicSpotKlineV3Api instance using the specified properties.
     * @function create
     * @memberof PublicSpotKlineV3Api
     * @static
     * @param {IPublicSpotKlineV3Api=} [properties] Properties to set
     * @returns {PublicSpotKlineV3Api} PublicSpotKlineV3Api instance
     */
    PublicSpotKlineV3Api.create = function create(properties) {
        return new PublicSpotKlineV3Api(properties);
    };
    /**
     * Encodes the specified PublicSpotKlineV3Api message. Does not implicitly {@link PublicSpotKlineV3Api.verify|verify} messages.
     * @function encode
     * @memberof PublicSpotKlineV3Api
     * @static
     * @param {IPublicSpotKlineV3Api} message PublicSpotKlineV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicSpotKlineV3Api.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.interval != null && Object.hasOwnProperty.call(message, "interval"))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.interval);
        if (message.windowStart != null && Object.hasOwnProperty.call(message, "windowStart"))
            writer.uint32(/* id 2, wireType 0 =*/ 16).int64(message.windowStart);
        if (message.openingPrice != null && Object.hasOwnProperty.call(message, "openingPrice"))
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.openingPrice);
        if (message.closingPrice != null && Object.hasOwnProperty.call(message, "closingPrice"))
            writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.closingPrice);
        if (message.highestPrice != null && Object.hasOwnProperty.call(message, "highestPrice"))
            writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.highestPrice);
        if (message.lowestPrice != null && Object.hasOwnProperty.call(message, "lowestPrice"))
            writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.lowestPrice);
        if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
            writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.volume);
        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
            writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.amount);
        if (message.windowEnd != null && Object.hasOwnProperty.call(message, "windowEnd"))
            writer.uint32(/* id 9, wireType 0 =*/ 72).int64(message.windowEnd);
        return writer;
    };
    /**
     * Encodes the specified PublicSpotKlineV3Api message, length delimited. Does not implicitly {@link PublicSpotKlineV3Api.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicSpotKlineV3Api
     * @static
     * @param {IPublicSpotKlineV3Api} message PublicSpotKlineV3Api message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicSpotKlineV3Api.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PublicSpotKlineV3Api message from the specified reader or buffer.
     * @function decode
     * @memberof PublicSpotKlineV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicSpotKlineV3Api} PublicSpotKlineV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicSpotKlineV3Api.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicSpotKlineV3Api();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    message.interval = reader.string();
                    break;
                }
                case 2: {
                    message.windowStart = reader.int64();
                    break;
                }
                case 3: {
                    message.openingPrice = reader.string();
                    break;
                }
                case 4: {
                    message.closingPrice = reader.string();
                    break;
                }
                case 5: {
                    message.highestPrice = reader.string();
                    break;
                }
                case 6: {
                    message.lowestPrice = reader.string();
                    break;
                }
                case 7: {
                    message.volume = reader.string();
                    break;
                }
                case 8: {
                    message.amount = reader.string();
                    break;
                }
                case 9: {
                    message.windowEnd = reader.int64();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PublicSpotKlineV3Api message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicSpotKlineV3Api
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicSpotKlineV3Api} PublicSpotKlineV3Api
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicSpotKlineV3Api.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PublicSpotKlineV3Api message.
     * @function verify
     * @memberof PublicSpotKlineV3Api
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicSpotKlineV3Api.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.interval != null && message.hasOwnProperty("interval"))
            if (!$util.isString(message.interval))
                return "interval: string expected";
        if (message.windowStart != null && message.hasOwnProperty("windowStart"))
            if (!$util.isInteger(message.windowStart) && !(message.windowStart && $util.isInteger(message.windowStart.low) && $util.isInteger(message.windowStart.high)))
                return "windowStart: integer|Long expected";
        if (message.openingPrice != null && message.hasOwnProperty("openingPrice"))
            if (!$util.isString(message.openingPrice))
                return "openingPrice: string expected";
        if (message.closingPrice != null && message.hasOwnProperty("closingPrice"))
            if (!$util.isString(message.closingPrice))
                return "closingPrice: string expected";
        if (message.highestPrice != null && message.hasOwnProperty("highestPrice"))
            if (!$util.isString(message.highestPrice))
                return "highestPrice: string expected";
        if (message.lowestPrice != null && message.hasOwnProperty("lowestPrice"))
            if (!$util.isString(message.lowestPrice))
                return "lowestPrice: string expected";
        if (message.volume != null && message.hasOwnProperty("volume"))
            if (!$util.isString(message.volume))
                return "volume: string expected";
        if (message.amount != null && message.hasOwnProperty("amount"))
            if (!$util.isString(message.amount))
                return "amount: string expected";
        if (message.windowEnd != null && message.hasOwnProperty("windowEnd"))
            if (!$util.isInteger(message.windowEnd) && !(message.windowEnd && $util.isInteger(message.windowEnd.low) && $util.isInteger(message.windowEnd.high)))
                return "windowEnd: integer|Long expected";
        return null;
    };
    /**
     * Creates a PublicSpotKlineV3Api message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicSpotKlineV3Api
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicSpotKlineV3Api} PublicSpotKlineV3Api
     */
    PublicSpotKlineV3Api.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicSpotKlineV3Api)
            return object;
        var message = new $root.PublicSpotKlineV3Api();
        if (object.interval != null)
            message.interval = String(object.interval);
        if (object.windowStart != null)
            if ($util.Long)
                (message.windowStart = $util.Long.fromValue(object.windowStart)).unsigned = false;
            else if (typeof object.windowStart === "string")
                message.windowStart = parseInt(object.windowStart, 10);
            else if (typeof object.windowStart === "number")
                message.windowStart = object.windowStart;
            else if (typeof object.windowStart === "object")
                message.windowStart = new $util.LongBits(object.windowStart.low >>> 0, object.windowStart.high >>> 0).toNumber();
        if (object.openingPrice != null)
            message.openingPrice = String(object.openingPrice);
        if (object.closingPrice != null)
            message.closingPrice = String(object.closingPrice);
        if (object.highestPrice != null)
            message.highestPrice = String(object.highestPrice);
        if (object.lowestPrice != null)
            message.lowestPrice = String(object.lowestPrice);
        if (object.volume != null)
            message.volume = String(object.volume);
        if (object.amount != null)
            message.amount = String(object.amount);
        if (object.windowEnd != null)
            if ($util.Long)
                (message.windowEnd = $util.Long.fromValue(object.windowEnd)).unsigned = false;
            else if (typeof object.windowEnd === "string")
                message.windowEnd = parseInt(object.windowEnd, 10);
            else if (typeof object.windowEnd === "number")
                message.windowEnd = object.windowEnd;
            else if (typeof object.windowEnd === "object")
                message.windowEnd = new $util.LongBits(object.windowEnd.low >>> 0, object.windowEnd.high >>> 0).toNumber();
        return message;
    };
    /**
     * Creates a plain object from a PublicSpotKlineV3Api message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicSpotKlineV3Api
     * @static
     * @param {PublicSpotKlineV3Api} message PublicSpotKlineV3Api
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicSpotKlineV3Api.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.interval = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.windowStart = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            }
            else
                object.windowStart = options.longs === String ? "0" : 0;
            object.openingPrice = "";
            object.closingPrice = "";
            object.highestPrice = "";
            object.lowestPrice = "";
            object.volume = "";
            object.amount = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.windowEnd = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            }
            else
                object.windowEnd = options.longs === String ? "0" : 0;
        }
        if (message.interval != null && message.hasOwnProperty("interval"))
            object.interval = message.interval;
        if (message.windowStart != null && message.hasOwnProperty("windowStart"))
            if (typeof message.windowStart === "number")
                object.windowStart = options.longs === String ? String(message.windowStart) : message.windowStart;
            else
                object.windowStart = options.longs === String ? $util.Long.prototype.toString.call(message.windowStart) : options.longs === Number ? new $util.LongBits(message.windowStart.low >>> 0, message.windowStart.high >>> 0).toNumber() : message.windowStart;
        if (message.openingPrice != null && message.hasOwnProperty("openingPrice"))
            object.openingPrice = message.openingPrice;
        if (message.closingPrice != null && message.hasOwnProperty("closingPrice"))
            object.closingPrice = message.closingPrice;
        if (message.highestPrice != null && message.hasOwnProperty("highestPrice"))
            object.highestPrice = message.highestPrice;
        if (message.lowestPrice != null && message.hasOwnProperty("lowestPrice"))
            object.lowestPrice = message.lowestPrice;
        if (message.volume != null && message.hasOwnProperty("volume"))
            object.volume = message.volume;
        if (message.amount != null && message.hasOwnProperty("amount"))
            object.amount = message.amount;
        if (message.windowEnd != null && message.hasOwnProperty("windowEnd"))
            if (typeof message.windowEnd === "number")
                object.windowEnd = options.longs === String ? String(message.windowEnd) : message.windowEnd;
            else
                object.windowEnd = options.longs === String ? $util.Long.prototype.toString.call(message.windowEnd) : options.longs === Number ? new $util.LongBits(message.windowEnd.low >>> 0, message.windowEnd.high >>> 0).toNumber() : message.windowEnd;
        return object;
    };
    /**
     * Converts this PublicSpotKlineV3Api to JSON.
     * @function toJSON
     * @memberof PublicSpotKlineV3Api
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicSpotKlineV3Api.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PublicSpotKlineV3Api
     * @function getTypeUrl
     * @memberof PublicSpotKlineV3Api
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicSpotKlineV3Api.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicSpotKlineV3Api";
    };
    return PublicSpotKlineV3Api;
})();
var PushDataV3ApiWrapper = $root.PushDataV3ApiWrapper = (function () {
    /**
     * Properties of a PushDataV3ApiWrapper.
     * @exports IPushDataV3ApiWrapper
     * @interface IPushDataV3ApiWrapper
     * @property {string|null} [channel] 频道
     * @property {IPublicDealsV3Api|null} [publicDeals] PushDataV3ApiWrapper publicDeals
     * @property {IPublicIncreaseDepthsV3Api|null} [publicIncreaseDepths] PushDataV3ApiWrapper publicIncreaseDepths
     * @property {IPublicLimitDepthsV3Api|null} [publicLimitDepths] PushDataV3ApiWrapper publicLimitDepths
     * @property {IPrivateOrdersV3Api|null} [privateOrders] PushDataV3ApiWrapper privateOrders
     * @property {IPublicBookTickerV3Api|null} [publicBookTicker] PushDataV3ApiWrapper publicBookTicker
     * @property {IPrivateDealsV3Api|null} [privateDeals] PushDataV3ApiWrapper privateDeals
     * @property {IPrivateAccountV3Api|null} [privateAccount] PushDataV3ApiWrapper privateAccount
     * @property {IPublicSpotKlineV3Api|null} [publicSpotKline] PushDataV3ApiWrapper publicSpotKline
     * @property {IPublicMiniTickerV3Api|null} [publicMiniTicker] PushDataV3ApiWrapper publicMiniTicker
     * @property {IPublicMiniTickersV3Api|null} [publicMiniTickers] PushDataV3ApiWrapper publicMiniTickers
     * @property {IPublicBookTickerBatchV3Api|null} [publicBookTickerBatch] PushDataV3ApiWrapper publicBookTickerBatch
     * @property {IPublicIncreaseDepthsBatchV3Api|null} [publicIncreaseDepthsBatch] PushDataV3ApiWrapper publicIncreaseDepthsBatch
     * @property {IPublicAggreDepthsV3Api|null} [publicAggreDepths] PushDataV3ApiWrapper publicAggreDepths
     * @property {IPublicAggreDealsV3Api|null} [publicAggreDeals] PushDataV3ApiWrapper publicAggreDeals
     * @property {IPublicAggreBookTickerV3Api|null} [publicAggreBookTicker] PushDataV3ApiWrapper publicAggreBookTicker
     * @property {string|null} [symbol] 交易对
     * @property {string|null} [symbolId] 交易对ID
     * @property {number|Long|null} [createTime] 消息生成时间
     * @property {number|Long|null} [sendTime] 消息推送时间
     */
    /**
     * Constructs a new PushDataV3ApiWrapper.
     * @exports PushDataV3ApiWrapper
     * @classdesc Represents a PushDataV3ApiWrapper.
     * @implements IPushDataV3ApiWrapper
     * @constructor
     * @param {IPushDataV3ApiWrapper=} [properties] Properties to set
     */
    function PushDataV3ApiWrapper(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }
    /**
     * 频道
     * @member {string} channel
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.channel = "";
    /**
     * PushDataV3ApiWrapper publicDeals.
     * @member {IPublicDealsV3Api|null|undefined} publicDeals
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.publicDeals = null;
    /**
     * PushDataV3ApiWrapper publicIncreaseDepths.
     * @member {IPublicIncreaseDepthsV3Api|null|undefined} publicIncreaseDepths
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.publicIncreaseDepths = null;
    /**
     * PushDataV3ApiWrapper publicLimitDepths.
     * @member {IPublicLimitDepthsV3Api|null|undefined} publicLimitDepths
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.publicLimitDepths = null;
    /**
     * PushDataV3ApiWrapper privateOrders.
     * @member {IPrivateOrdersV3Api|null|undefined} privateOrders
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.privateOrders = null;
    /**
     * PushDataV3ApiWrapper publicBookTicker.
     * @member {IPublicBookTickerV3Api|null|undefined} publicBookTicker
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.publicBookTicker = null;
    /**
     * PushDataV3ApiWrapper privateDeals.
     * @member {IPrivateDealsV3Api|null|undefined} privateDeals
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.privateDeals = null;
    /**
     * PushDataV3ApiWrapper privateAccount.
     * @member {IPrivateAccountV3Api|null|undefined} privateAccount
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.privateAccount = null;
    /**
     * PushDataV3ApiWrapper publicSpotKline.
     * @member {IPublicSpotKlineV3Api|null|undefined} publicSpotKline
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.publicSpotKline = null;
    /**
     * PushDataV3ApiWrapper publicMiniTicker.
     * @member {IPublicMiniTickerV3Api|null|undefined} publicMiniTicker
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.publicMiniTicker = null;
    /**
     * PushDataV3ApiWrapper publicMiniTickers.
     * @member {IPublicMiniTickersV3Api|null|undefined} publicMiniTickers
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.publicMiniTickers = null;
    /**
     * PushDataV3ApiWrapper publicBookTickerBatch.
     * @member {IPublicBookTickerBatchV3Api|null|undefined} publicBookTickerBatch
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.publicBookTickerBatch = null;
    /**
     * PushDataV3ApiWrapper publicIncreaseDepthsBatch.
     * @member {IPublicIncreaseDepthsBatchV3Api|null|undefined} publicIncreaseDepthsBatch
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.publicIncreaseDepthsBatch = null;
    /**
     * PushDataV3ApiWrapper publicAggreDepths.
     * @member {IPublicAggreDepthsV3Api|null|undefined} publicAggreDepths
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.publicAggreDepths = null;
    /**
     * PushDataV3ApiWrapper publicAggreDeals.
     * @member {IPublicAggreDealsV3Api|null|undefined} publicAggreDeals
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.publicAggreDeals = null;
    /**
     * PushDataV3ApiWrapper publicAggreBookTicker.
     * @member {IPublicAggreBookTickerV3Api|null|undefined} publicAggreBookTicker
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.publicAggreBookTicker = null;
    /**
     * 交易对
     * @member {string|null|undefined} symbol
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.symbol = null;
    /**
     * 交易对ID
     * @member {string|null|undefined} symbolId
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.symbolId = null;
    /**
     * 消息生成时间
     * @member {number|Long|null|undefined} createTime
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.createTime = null;
    /**
     * 消息推送时间
     * @member {number|Long|null|undefined} sendTime
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    PushDataV3ApiWrapper.prototype.sendTime = null;
    // OneOf field names bound to virtual getters and setters
    var $oneOfFields;
    /**
     * 数据，NOTE：因为不能重复，所以类型和变量名尽量使用全名
     * @member {"publicDeals"|"publicIncreaseDepths"|"publicLimitDepths"|"privateOrders"|"publicBookTicker"|"privateDeals"|"privateAccount"|"publicSpotKline"|"publicMiniTicker"|"publicMiniTickers"|"publicBookTickerBatch"|"publicIncreaseDepthsBatch"|"publicAggreDepths"|"publicAggreDeals"|"publicAggreBookTicker"|undefined} body
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    Object.defineProperty(PushDataV3ApiWrapper.prototype, "body", {
        get: $util.oneOfGetter($oneOfFields = ["publicDeals", "publicIncreaseDepths", "publicLimitDepths", "privateOrders", "publicBookTicker", "privateDeals", "privateAccount", "publicSpotKline", "publicMiniTicker", "publicMiniTickers", "publicBookTickerBatch", "publicIncreaseDepthsBatch", "publicAggreDepths", "publicAggreDeals", "publicAggreBookTicker"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * PushDataV3ApiWrapper _symbol.
     * @member {"symbol"|undefined} _symbol
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    Object.defineProperty(PushDataV3ApiWrapper.prototype, "_symbol", {
        get: $util.oneOfGetter($oneOfFields = ["symbol"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * PushDataV3ApiWrapper _symbolId.
     * @member {"symbolId"|undefined} _symbolId
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    Object.defineProperty(PushDataV3ApiWrapper.prototype, "_symbolId", {
        get: $util.oneOfGetter($oneOfFields = ["symbolId"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * PushDataV3ApiWrapper _createTime.
     * @member {"createTime"|undefined} _createTime
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    Object.defineProperty(PushDataV3ApiWrapper.prototype, "_createTime", {
        get: $util.oneOfGetter($oneOfFields = ["createTime"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * PushDataV3ApiWrapper _sendTime.
     * @member {"sendTime"|undefined} _sendTime
     * @memberof PushDataV3ApiWrapper
     * @instance
     */
    Object.defineProperty(PushDataV3ApiWrapper.prototype, "_sendTime", {
        get: $util.oneOfGetter($oneOfFields = ["sendTime"]),
        set: $util.oneOfSetter($oneOfFields)
    });
    /**
     * Creates a new PushDataV3ApiWrapper instance using the specified properties.
     * @function create
     * @memberof PushDataV3ApiWrapper
     * @static
     * @param {IPushDataV3ApiWrapper=} [properties] Properties to set
     * @returns {PushDataV3ApiWrapper} PushDataV3ApiWrapper instance
     */
    PushDataV3ApiWrapper.create = function create(properties) {
        return new PushDataV3ApiWrapper(properties);
    };
    /**
     * Encodes the specified PushDataV3ApiWrapper message. Does not implicitly {@link PushDataV3ApiWrapper.verify|verify} messages.
     * @function encode
     * @memberof PushDataV3ApiWrapper
     * @static
     * @param {IPushDataV3ApiWrapper} message PushDataV3ApiWrapper message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PushDataV3ApiWrapper.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.channel);
        if (message.symbol != null && Object.hasOwnProperty.call(message, "symbol"))
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.symbol);
        if (message.symbolId != null && Object.hasOwnProperty.call(message, "symbolId"))
            writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.symbolId);
        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
            writer.uint32(/* id 5, wireType 0 =*/ 40).int64(message.createTime);
        if (message.sendTime != null && Object.hasOwnProperty.call(message, "sendTime"))
            writer.uint32(/* id 6, wireType 0 =*/ 48).int64(message.sendTime);
        if (message.publicDeals != null && Object.hasOwnProperty.call(message, "publicDeals"))
            $root.PublicDealsV3Api.encode(message.publicDeals, writer.uint32(/* id 301, wireType 2 =*/ 2410).fork()).ldelim();
        if (message.publicIncreaseDepths != null && Object.hasOwnProperty.call(message, "publicIncreaseDepths"))
            $root.PublicIncreaseDepthsV3Api.encode(message.publicIncreaseDepths, writer.uint32(/* id 302, wireType 2 =*/ 2418).fork()).ldelim();
        if (message.publicLimitDepths != null && Object.hasOwnProperty.call(message, "publicLimitDepths"))
            $root.PublicLimitDepthsV3Api.encode(message.publicLimitDepths, writer.uint32(/* id 303, wireType 2 =*/ 2426).fork()).ldelim();
        if (message.privateOrders != null && Object.hasOwnProperty.call(message, "privateOrders"))
            $root.PrivateOrdersV3Api.encode(message.privateOrders, writer.uint32(/* id 304, wireType 2 =*/ 2434).fork()).ldelim();
        if (message.publicBookTicker != null && Object.hasOwnProperty.call(message, "publicBookTicker"))
            $root.PublicBookTickerV3Api.encode(message.publicBookTicker, writer.uint32(/* id 305, wireType 2 =*/ 2442).fork()).ldelim();
        if (message.privateDeals != null && Object.hasOwnProperty.call(message, "privateDeals"))
            $root.PrivateDealsV3Api.encode(message.privateDeals, writer.uint32(/* id 306, wireType 2 =*/ 2450).fork()).ldelim();
        if (message.privateAccount != null && Object.hasOwnProperty.call(message, "privateAccount"))
            $root.PrivateAccountV3Api.encode(message.privateAccount, writer.uint32(/* id 307, wireType 2 =*/ 2458).fork()).ldelim();
        if (message.publicSpotKline != null && Object.hasOwnProperty.call(message, "publicSpotKline"))
            $root.PublicSpotKlineV3Api.encode(message.publicSpotKline, writer.uint32(/* id 308, wireType 2 =*/ 2466).fork()).ldelim();
        if (message.publicMiniTicker != null && Object.hasOwnProperty.call(message, "publicMiniTicker"))
            $root.PublicMiniTickerV3Api.encode(message.publicMiniTicker, writer.uint32(/* id 309, wireType 2 =*/ 2474).fork()).ldelim();
        if (message.publicMiniTickers != null && Object.hasOwnProperty.call(message, "publicMiniTickers"))
            $root.PublicMiniTickersV3Api.encode(message.publicMiniTickers, writer.uint32(/* id 310, wireType 2 =*/ 2482).fork()).ldelim();
        if (message.publicBookTickerBatch != null && Object.hasOwnProperty.call(message, "publicBookTickerBatch"))
            $root.PublicBookTickerBatchV3Api.encode(message.publicBookTickerBatch, writer.uint32(/* id 311, wireType 2 =*/ 2490).fork()).ldelim();
        if (message.publicIncreaseDepthsBatch != null && Object.hasOwnProperty.call(message, "publicIncreaseDepthsBatch"))
            $root.PublicIncreaseDepthsBatchV3Api.encode(message.publicIncreaseDepthsBatch, writer.uint32(/* id 312, wireType 2 =*/ 2498).fork()).ldelim();
        if (message.publicAggreDepths != null && Object.hasOwnProperty.call(message, "publicAggreDepths"))
            $root.PublicAggreDepthsV3Api.encode(message.publicAggreDepths, writer.uint32(/* id 313, wireType 2 =*/ 2506).fork()).ldelim();
        if (message.publicAggreDeals != null && Object.hasOwnProperty.call(message, "publicAggreDeals"))
            $root.PublicAggreDealsV3Api.encode(message.publicAggreDeals, writer.uint32(/* id 314, wireType 2 =*/ 2514).fork()).ldelim();
        if (message.publicAggreBookTicker != null && Object.hasOwnProperty.call(message, "publicAggreBookTicker"))
            $root.PublicAggreBookTickerV3Api.encode(message.publicAggreBookTicker, writer.uint32(/* id 315, wireType 2 =*/ 2522).fork()).ldelim();
        return writer;
    };
    /**
     * Encodes the specified PushDataV3ApiWrapper message, length delimited. Does not implicitly {@link PushDataV3ApiWrapper.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PushDataV3ApiWrapper
     * @static
     * @param {IPushDataV3ApiWrapper} message PushDataV3ApiWrapper message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PushDataV3ApiWrapper.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };
    /**
     * Decodes a PushDataV3ApiWrapper message from the specified reader or buffer.
     * @function decode
     * @memberof PushDataV3ApiWrapper
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PushDataV3ApiWrapper} PushDataV3ApiWrapper
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PushDataV3ApiWrapper.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PushDataV3ApiWrapper();
        while (reader.pos < end) {
            var tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
                case 1: {
                    message.channel = reader.string();
                    break;
                }
                case 301: {
                    message.publicDeals = $root.PublicDealsV3Api.decode(reader, reader.uint32());
                    break;
                }
                case 302: {
                    message.publicIncreaseDepths = $root.PublicIncreaseDepthsV3Api.decode(reader, reader.uint32());
                    break;
                }
                case 303: {
                    message.publicLimitDepths = $root.PublicLimitDepthsV3Api.decode(reader, reader.uint32());
                    break;
                }
                case 304: {
                    message.privateOrders = $root.PrivateOrdersV3Api.decode(reader, reader.uint32());
                    break;
                }
                case 305: {
                    message.publicBookTicker = $root.PublicBookTickerV3Api.decode(reader, reader.uint32());
                    break;
                }
                case 306: {
                    message.privateDeals = $root.PrivateDealsV3Api.decode(reader, reader.uint32());
                    break;
                }
                case 307: {
                    message.privateAccount = $root.PrivateAccountV3Api.decode(reader, reader.uint32());
                    break;
                }
                case 308: {
                    message.publicSpotKline = $root.PublicSpotKlineV3Api.decode(reader, reader.uint32());
                    break;
                }
                case 309: {
                    message.publicMiniTicker = $root.PublicMiniTickerV3Api.decode(reader, reader.uint32());
                    break;
                }
                case 310: {
                    message.publicMiniTickers = $root.PublicMiniTickersV3Api.decode(reader, reader.uint32());
                    break;
                }
                case 311: {
                    message.publicBookTickerBatch = $root.PublicBookTickerBatchV3Api.decode(reader, reader.uint32());
                    break;
                }
                case 312: {
                    message.publicIncreaseDepthsBatch = $root.PublicIncreaseDepthsBatchV3Api.decode(reader, reader.uint32());
                    break;
                }
                case 313: {
                    message.publicAggreDepths = $root.PublicAggreDepthsV3Api.decode(reader, reader.uint32());
                    break;
                }
                case 314: {
                    message.publicAggreDeals = $root.PublicAggreDealsV3Api.decode(reader, reader.uint32());
                    break;
                }
                case 315: {
                    message.publicAggreBookTicker = $root.PublicAggreBookTickerV3Api.decode(reader, reader.uint32());
                    break;
                }
                case 3: {
                    message.symbol = reader.string();
                    break;
                }
                case 4: {
                    message.symbolId = reader.string();
                    break;
                }
                case 5: {
                    message.createTime = reader.int64();
                    break;
                }
                case 6: {
                    message.sendTime = reader.int64();
                    break;
                }
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    };
    /**
     * Decodes a PushDataV3ApiWrapper message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PushDataV3ApiWrapper
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PushDataV3ApiWrapper} PushDataV3ApiWrapper
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PushDataV3ApiWrapper.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };
    /**
     * Verifies a PushDataV3ApiWrapper message.
     * @function verify
     * @memberof PushDataV3ApiWrapper
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PushDataV3ApiWrapper.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        var properties = {};
        if (message.channel != null && message.hasOwnProperty("channel"))
            if (!$util.isString(message.channel))
                return "channel: string expected";
        if (message.publicDeals != null && message.hasOwnProperty("publicDeals")) {
            properties.body = 1;
            {
                var error = $root.PublicDealsV3Api.verify(message.publicDeals);
                if (error)
                    return "publicDeals." + error;
            }
        }
        if (message.publicIncreaseDepths != null && message.hasOwnProperty("publicIncreaseDepths")) {
            if (properties.body === 1)
                return "body: multiple values";
            properties.body = 1;
            {
                var error = $root.PublicIncreaseDepthsV3Api.verify(message.publicIncreaseDepths);
                if (error)
                    return "publicIncreaseDepths." + error;
            }
        }
        if (message.publicLimitDepths != null && message.hasOwnProperty("publicLimitDepths")) {
            if (properties.body === 1)
                return "body: multiple values";
            properties.body = 1;
            {
                var error = $root.PublicLimitDepthsV3Api.verify(message.publicLimitDepths);
                if (error)
                    return "publicLimitDepths." + error;
            }
        }
        if (message.privateOrders != null && message.hasOwnProperty("privateOrders")) {
            if (properties.body === 1)
                return "body: multiple values";
            properties.body = 1;
            {
                var error = $root.PrivateOrdersV3Api.verify(message.privateOrders);
                if (error)
                    return "privateOrders." + error;
            }
        }
        if (message.publicBookTicker != null && message.hasOwnProperty("publicBookTicker")) {
            if (properties.body === 1)
                return "body: multiple values";
            properties.body = 1;
            {
                var error = $root.PublicBookTickerV3Api.verify(message.publicBookTicker);
                if (error)
                    return "publicBookTicker." + error;
            }
        }
        if (message.privateDeals != null && message.hasOwnProperty("privateDeals")) {
            if (properties.body === 1)
                return "body: multiple values";
            properties.body = 1;
            {
                var error = $root.PrivateDealsV3Api.verify(message.privateDeals);
                if (error)
                    return "privateDeals." + error;
            }
        }
        if (message.privateAccount != null && message.hasOwnProperty("privateAccount")) {
            if (properties.body === 1)
                return "body: multiple values";
            properties.body = 1;
            {
                var error = $root.PrivateAccountV3Api.verify(message.privateAccount);
                if (error)
                    return "privateAccount." + error;
            }
        }
        if (message.publicSpotKline != null && message.hasOwnProperty("publicSpotKline")) {
            if (properties.body === 1)
                return "body: multiple values";
            properties.body = 1;
            {
                var error = $root.PublicSpotKlineV3Api.verify(message.publicSpotKline);
                if (error)
                    return "publicSpotKline." + error;
            }
        }
        if (message.publicMiniTicker != null && message.hasOwnProperty("publicMiniTicker")) {
            if (properties.body === 1)
                return "body: multiple values";
            properties.body = 1;
            {
                var error = $root.PublicMiniTickerV3Api.verify(message.publicMiniTicker);
                if (error)
                    return "publicMiniTicker." + error;
            }
        }
        if (message.publicMiniTickers != null && message.hasOwnProperty("publicMiniTickers")) {
            if (properties.body === 1)
                return "body: multiple values";
            properties.body = 1;
            {
                var error = $root.PublicMiniTickersV3Api.verify(message.publicMiniTickers);
                if (error)
                    return "publicMiniTickers." + error;
            }
        }
        if (message.publicBookTickerBatch != null && message.hasOwnProperty("publicBookTickerBatch")) {
            if (properties.body === 1)
                return "body: multiple values";
            properties.body = 1;
            {
                var error = $root.PublicBookTickerBatchV3Api.verify(message.publicBookTickerBatch);
                if (error)
                    return "publicBookTickerBatch." + error;
            }
        }
        if (message.publicIncreaseDepthsBatch != null && message.hasOwnProperty("publicIncreaseDepthsBatch")) {
            if (properties.body === 1)
                return "body: multiple values";
            properties.body = 1;
            {
                var error = $root.PublicIncreaseDepthsBatchV3Api.verify(message.publicIncreaseDepthsBatch);
                if (error)
                    return "publicIncreaseDepthsBatch." + error;
            }
        }
        if (message.publicAggreDepths != null && message.hasOwnProperty("publicAggreDepths")) {
            if (properties.body === 1)
                return "body: multiple values";
            properties.body = 1;
            {
                var error = $root.PublicAggreDepthsV3Api.verify(message.publicAggreDepths);
                if (error)
                    return "publicAggreDepths." + error;
            }
        }
        if (message.publicAggreDeals != null && message.hasOwnProperty("publicAggreDeals")) {
            if (properties.body === 1)
                return "body: multiple values";
            properties.body = 1;
            {
                var error = $root.PublicAggreDealsV3Api.verify(message.publicAggreDeals);
                if (error)
                    return "publicAggreDeals." + error;
            }
        }
        if (message.publicAggreBookTicker != null && message.hasOwnProperty("publicAggreBookTicker")) {
            if (properties.body === 1)
                return "body: multiple values";
            properties.body = 1;
            {
                var error = $root.PublicAggreBookTickerV3Api.verify(message.publicAggreBookTicker);
                if (error)
                    return "publicAggreBookTicker." + error;
            }
        }
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
            properties._symbol = 1;
            if (!$util.isString(message.symbol))
                return "symbol: string expected";
        }
        if (message.symbolId != null && message.hasOwnProperty("symbolId")) {
            properties._symbolId = 1;
            if (!$util.isString(message.symbolId))
                return "symbolId: string expected";
        }
        if (message.createTime != null && message.hasOwnProperty("createTime")) {
            properties._createTime = 1;
            if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                return "createTime: integer|Long expected";
        }
        if (message.sendTime != null && message.hasOwnProperty("sendTime")) {
            properties._sendTime = 1;
            if (!$util.isInteger(message.sendTime) && !(message.sendTime && $util.isInteger(message.sendTime.low) && $util.isInteger(message.sendTime.high)))
                return "sendTime: integer|Long expected";
        }
        return null;
    };
    /**
     * Creates a PushDataV3ApiWrapper message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PushDataV3ApiWrapper
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PushDataV3ApiWrapper} PushDataV3ApiWrapper
     */
    PushDataV3ApiWrapper.fromObject = function fromObject(object) {
        if (object instanceof $root.PushDataV3ApiWrapper)
            return object;
        var message = new $root.PushDataV3ApiWrapper();
        if (object.channel != null)
            message.channel = String(object.channel);
        if (object.publicDeals != null) {
            if (typeof object.publicDeals !== "object")
                throw TypeError(".PushDataV3ApiWrapper.publicDeals: object expected");
            message.publicDeals = $root.PublicDealsV3Api.fromObject(object.publicDeals);
        }
        if (object.publicIncreaseDepths != null) {
            if (typeof object.publicIncreaseDepths !== "object")
                throw TypeError(".PushDataV3ApiWrapper.publicIncreaseDepths: object expected");
            message.publicIncreaseDepths = $root.PublicIncreaseDepthsV3Api.fromObject(object.publicIncreaseDepths);
        }
        if (object.publicLimitDepths != null) {
            if (typeof object.publicLimitDepths !== "object")
                throw TypeError(".PushDataV3ApiWrapper.publicLimitDepths: object expected");
            message.publicLimitDepths = $root.PublicLimitDepthsV3Api.fromObject(object.publicLimitDepths);
        }
        if (object.privateOrders != null) {
            if (typeof object.privateOrders !== "object")
                throw TypeError(".PushDataV3ApiWrapper.privateOrders: object expected");
            message.privateOrders = $root.PrivateOrdersV3Api.fromObject(object.privateOrders);
        }
        if (object.publicBookTicker != null) {
            if (typeof object.publicBookTicker !== "object")
                throw TypeError(".PushDataV3ApiWrapper.publicBookTicker: object expected");
            message.publicBookTicker = $root.PublicBookTickerV3Api.fromObject(object.publicBookTicker);
        }
        if (object.privateDeals != null) {
            if (typeof object.privateDeals !== "object")
                throw TypeError(".PushDataV3ApiWrapper.privateDeals: object expected");
            message.privateDeals = $root.PrivateDealsV3Api.fromObject(object.privateDeals);
        }
        if (object.privateAccount != null) {
            if (typeof object.privateAccount !== "object")
                throw TypeError(".PushDataV3ApiWrapper.privateAccount: object expected");
            message.privateAccount = $root.PrivateAccountV3Api.fromObject(object.privateAccount);
        }
        if (object.publicSpotKline != null) {
            if (typeof object.publicSpotKline !== "object")
                throw TypeError(".PushDataV3ApiWrapper.publicSpotKline: object expected");
            message.publicSpotKline = $root.PublicSpotKlineV3Api.fromObject(object.publicSpotKline);
        }
        if (object.publicMiniTicker != null) {
            if (typeof object.publicMiniTicker !== "object")
                throw TypeError(".PushDataV3ApiWrapper.publicMiniTicker: object expected");
            message.publicMiniTicker = $root.PublicMiniTickerV3Api.fromObject(object.publicMiniTicker);
        }
        if (object.publicMiniTickers != null) {
            if (typeof object.publicMiniTickers !== "object")
                throw TypeError(".PushDataV3ApiWrapper.publicMiniTickers: object expected");
            message.publicMiniTickers = $root.PublicMiniTickersV3Api.fromObject(object.publicMiniTickers);
        }
        if (object.publicBookTickerBatch != null) {
            if (typeof object.publicBookTickerBatch !== "object")
                throw TypeError(".PushDataV3ApiWrapper.publicBookTickerBatch: object expected");
            message.publicBookTickerBatch = $root.PublicBookTickerBatchV3Api.fromObject(object.publicBookTickerBatch);
        }
        if (object.publicIncreaseDepthsBatch != null) {
            if (typeof object.publicIncreaseDepthsBatch !== "object")
                throw TypeError(".PushDataV3ApiWrapper.publicIncreaseDepthsBatch: object expected");
            message.publicIncreaseDepthsBatch = $root.PublicIncreaseDepthsBatchV3Api.fromObject(object.publicIncreaseDepthsBatch);
        }
        if (object.publicAggreDepths != null) {
            if (typeof object.publicAggreDepths !== "object")
                throw TypeError(".PushDataV3ApiWrapper.publicAggreDepths: object expected");
            message.publicAggreDepths = $root.PublicAggreDepthsV3Api.fromObject(object.publicAggreDepths);
        }
        if (object.publicAggreDeals != null) {
            if (typeof object.publicAggreDeals !== "object")
                throw TypeError(".PushDataV3ApiWrapper.publicAggreDeals: object expected");
            message.publicAggreDeals = $root.PublicAggreDealsV3Api.fromObject(object.publicAggreDeals);
        }
        if (object.publicAggreBookTicker != null) {
            if (typeof object.publicAggreBookTicker !== "object")
                throw TypeError(".PushDataV3ApiWrapper.publicAggreBookTicker: object expected");
            message.publicAggreBookTicker = $root.PublicAggreBookTickerV3Api.fromObject(object.publicAggreBookTicker);
        }
        if (object.symbol != null)
            message.symbol = String(object.symbol);
        if (object.symbolId != null)
            message.symbolId = String(object.symbolId);
        if (object.createTime != null)
            if ($util.Long)
                (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
            else if (typeof object.createTime === "string")
                message.createTime = parseInt(object.createTime, 10);
            else if (typeof object.createTime === "number")
                message.createTime = object.createTime;
            else if (typeof object.createTime === "object")
                message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
        if (object.sendTime != null)
            if ($util.Long)
                (message.sendTime = $util.Long.fromValue(object.sendTime)).unsigned = false;
            else if (typeof object.sendTime === "string")
                message.sendTime = parseInt(object.sendTime, 10);
            else if (typeof object.sendTime === "number")
                message.sendTime = object.sendTime;
            else if (typeof object.sendTime === "object")
                message.sendTime = new $util.LongBits(object.sendTime.low >>> 0, object.sendTime.high >>> 0).toNumber();
        return message;
    };
    /**
     * Creates a plain object from a PushDataV3ApiWrapper message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PushDataV3ApiWrapper
     * @static
     * @param {PushDataV3ApiWrapper} message PushDataV3ApiWrapper
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PushDataV3ApiWrapper.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.channel = "";
        if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
        if (message.symbol != null && message.hasOwnProperty("symbol")) {
            object.symbol = message.symbol;
            if (options.oneofs)
                object._symbol = "symbol";
        }
        if (message.symbolId != null && message.hasOwnProperty("symbolId")) {
            object.symbolId = message.symbolId;
            if (options.oneofs)
                object._symbolId = "symbolId";
        }
        if (message.createTime != null && message.hasOwnProperty("createTime")) {
            if (typeof message.createTime === "number")
                object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
            else
                object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
            if (options.oneofs)
                object._createTime = "createTime";
        }
        if (message.sendTime != null && message.hasOwnProperty("sendTime")) {
            if (typeof message.sendTime === "number")
                object.sendTime = options.longs === String ? String(message.sendTime) : message.sendTime;
            else
                object.sendTime = options.longs === String ? $util.Long.prototype.toString.call(message.sendTime) : options.longs === Number ? new $util.LongBits(message.sendTime.low >>> 0, message.sendTime.high >>> 0).toNumber() : message.sendTime;
            if (options.oneofs)
                object._sendTime = "sendTime";
        }
        if (message.publicDeals != null && message.hasOwnProperty("publicDeals")) {
            object.publicDeals = $root.PublicDealsV3Api.toObject(message.publicDeals, options);
            if (options.oneofs)
                object.body = "publicDeals";
        }
        if (message.publicIncreaseDepths != null && message.hasOwnProperty("publicIncreaseDepths")) {
            object.publicIncreaseDepths = $root.PublicIncreaseDepthsV3Api.toObject(message.publicIncreaseDepths, options);
            if (options.oneofs)
                object.body = "publicIncreaseDepths";
        }
        if (message.publicLimitDepths != null && message.hasOwnProperty("publicLimitDepths")) {
            object.publicLimitDepths = $root.PublicLimitDepthsV3Api.toObject(message.publicLimitDepths, options);
            if (options.oneofs)
                object.body = "publicLimitDepths";
        }
        if (message.privateOrders != null && message.hasOwnProperty("privateOrders")) {
            object.privateOrders = $root.PrivateOrdersV3Api.toObject(message.privateOrders, options);
            if (options.oneofs)
                object.body = "privateOrders";
        }
        if (message.publicBookTicker != null && message.hasOwnProperty("publicBookTicker")) {
            object.publicBookTicker = $root.PublicBookTickerV3Api.toObject(message.publicBookTicker, options);
            if (options.oneofs)
                object.body = "publicBookTicker";
        }
        if (message.privateDeals != null && message.hasOwnProperty("privateDeals")) {
            object.privateDeals = $root.PrivateDealsV3Api.toObject(message.privateDeals, options);
            if (options.oneofs)
                object.body = "privateDeals";
        }
        if (message.privateAccount != null && message.hasOwnProperty("privateAccount")) {
            object.privateAccount = $root.PrivateAccountV3Api.toObject(message.privateAccount, options);
            if (options.oneofs)
                object.body = "privateAccount";
        }
        if (message.publicSpotKline != null && message.hasOwnProperty("publicSpotKline")) {
            object.publicSpotKline = $root.PublicSpotKlineV3Api.toObject(message.publicSpotKline, options);
            if (options.oneofs)
                object.body = "publicSpotKline";
        }
        if (message.publicMiniTicker != null && message.hasOwnProperty("publicMiniTicker")) {
            object.publicMiniTicker = $root.PublicMiniTickerV3Api.toObject(message.publicMiniTicker, options);
            if (options.oneofs)
                object.body = "publicMiniTicker";
        }
        if (message.publicMiniTickers != null && message.hasOwnProperty("publicMiniTickers")) {
            object.publicMiniTickers = $root.PublicMiniTickersV3Api.toObject(message.publicMiniTickers, options);
            if (options.oneofs)
                object.body = "publicMiniTickers";
        }
        if (message.publicBookTickerBatch != null && message.hasOwnProperty("publicBookTickerBatch")) {
            object.publicBookTickerBatch = $root.PublicBookTickerBatchV3Api.toObject(message.publicBookTickerBatch, options);
            if (options.oneofs)
                object.body = "publicBookTickerBatch";
        }
        if (message.publicIncreaseDepthsBatch != null && message.hasOwnProperty("publicIncreaseDepthsBatch")) {
            object.publicIncreaseDepthsBatch = $root.PublicIncreaseDepthsBatchV3Api.toObject(message.publicIncreaseDepthsBatch, options);
            if (options.oneofs)
                object.body = "publicIncreaseDepthsBatch";
        }
        if (message.publicAggreDepths != null && message.hasOwnProperty("publicAggreDepths")) {
            object.publicAggreDepths = $root.PublicAggreDepthsV3Api.toObject(message.publicAggreDepths, options);
            if (options.oneofs)
                object.body = "publicAggreDepths";
        }
        if (message.publicAggreDeals != null && message.hasOwnProperty("publicAggreDeals")) {
            object.publicAggreDeals = $root.PublicAggreDealsV3Api.toObject(message.publicAggreDeals, options);
            if (options.oneofs)
                object.body = "publicAggreDeals";
        }
        if (message.publicAggreBookTicker != null && message.hasOwnProperty("publicAggreBookTicker")) {
            object.publicAggreBookTicker = $root.PublicAggreBookTickerV3Api.toObject(message.publicAggreBookTicker, options);
            if (options.oneofs)
                object.body = "publicAggreBookTicker";
        }
        return object;
    };
    /**
     * Converts this PushDataV3ApiWrapper to JSON.
     * @function toJSON
     * @memberof PushDataV3ApiWrapper
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PushDataV3ApiWrapper.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    /**
     * Gets the default type url for PushDataV3ApiWrapper
     * @function getTypeUrl
     * @memberof PushDataV3ApiWrapper
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PushDataV3ApiWrapper.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PushDataV3ApiWrapper";
    };
    return PushDataV3ApiWrapper;
})();

// @ts-ignore
var wrapper = PushDataV3ApiWrapper;
var MexcSocket = /** @class */ (function (_super) {
    __extends(MexcSocket, _super);
    function MexcSocket(options) {
        var futuresUrl = "wss://contract.mexc.com/edge";
        var spotUrl = "wss://wbs-api.mexc.com/ws";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(MexcSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new MexcSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(MexcSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "sub.depth.full",
                "param": {
                    "symbol": this.coin,
                    "limit": 5
                }
            }));
            if ((_b = this.coin) === null || _b === void 0 ? void 0 : _b.startsWith('NFLX'))
                this.divide = 10;
            this.futuresInterval = setInterval(function () { var _a, _b; return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({ "method": "ping" }))); }, 10000);
        }
    });
    Object.defineProperty(MexcSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "SUBSCRIPTION",
                "params": ["spot@public.limit.depth.v3.api.pb@".concat(this.coin, "@").concat(5)]
            }));
            if (!this.spotInterval)
                this.spotInterval = setInterval(function () { var _a, _b; ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({ "method": "PING" }))); }, 5000);
        }
    });
    Object.defineProperty(MexcSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b;
            var _c = JSON.parse(event.data), channel = _c.channel, data = _c.data;
            if (channel === "push.depth.full") {
                var asks = (_a = data === null || data === void 0 ? void 0 : data.asks) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                var bids = (_b = data === null || data === void 0 ? void 0 : data.bids) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(MexcSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b, _c, _d;
            return __awaiter(this, void 0, void 0, function () {
                var arrayBuffer, uint8Array, pushMsg, asks, bids;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (!event.data)
                                return [2 /*return*/];
                            _e.label = 1;
                        case 1:
                            _e.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, event.data.arrayBuffer()];
                        case 2:
                            arrayBuffer = _e.sent();
                            uint8Array = new Uint8Array(arrayBuffer);
                            //@ts-ignore
                            pushMsg = wrapper.decode(uint8Array);
                            return [3 /*break*/, 4];
                        case 3:
                            _e.sent();
                            return [2 /*return*/];
                        case 4:
                            //@ts-ignore
                            if (pushMsg === null || pushMsg === void 0 ? void 0 : pushMsg.symbol) {
                                asks = (_b = (_a = pushMsg.publicLimitDepths) === null || _a === void 0 ? void 0 : _a.asks) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item.price, volume: (item.price * item.quantity).toFixed(2) }); });
                                bids = (_d = (_c = pushMsg.publicLimitDepths) === null || _c === void 0 ? void 0 : _c.bids) === null || _d === void 0 ? void 0 : _d.map(function (item) { return ({ price: item.price, volume: (item.price * item.quantity).toFixed(2) }); });
                                this.onOrderbook({ asks: asks, bids: bids });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(MexcSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(MexcSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return MexcSocket;
}(DefaultSocket));

var OkxSocket = /** @class */ (function (_super) {
    __extends(OkxSocket, _super);
    function OkxSocket(options) {
        var futuresUrl = "wss://ws.okx.com:8443/ws/v5/public";
        var spotUrl = "wss://ws.okx.com:8443/ws/v5/public";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(OkxSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new OkxSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(OkxSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "op": "subscribe",
                "args": [
                    {
                        "channel": "books5",
                        "instId": this.coin
                    }
                ]
            }));
            this.futuresInterval = setInterval(function () { var _a, _b; return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send('ping')); }, 1000);
        }
    });
    Object.defineProperty(OkxSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "op": "subscribe",
                "args": [
                    {
                        "channel": "books5",
                        "instId": this.coin
                    }
                ]
            }));
            if (!this.spotInterval)
                this.spotInterval = setInterval(function () { var _a, _b; return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send('ping')); }, 1000);
        }
    });
    Object.defineProperty(OkxSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b, _c, _d, _e;
            if (event.data === 'pong') {
                return;
            }
            var data = JSON.parse(event.data).data;
            if ((_a = data === null || data === void 0 ? void 0 : data.at(0)) === null || _a === void 0 ? void 0 : _a.asks) {
                var asks = (_c = (_b = data === null || data === void 0 ? void 0 : data.at(0)) === null || _b === void 0 ? void 0 : _b.asks) === null || _c === void 0 ? void 0 : _c.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                var bids = (_e = (_d = data === null || data === void 0 ? void 0 : data.at(0)) === null || _d === void 0 ? void 0 : _d.bids) === null || _e === void 0 ? void 0 : _e.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0]).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(OkxSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b, _c, _d, _e;
            if (event.data === 'pong') {
                return;
            }
            var data = JSON.parse(event.data).data;
            if ((_a = data === null || data === void 0 ? void 0 : data.at(0)) === null || _a === void 0 ? void 0 : _a.asks) {
                var asks = (_c = (_b = data === null || data === void 0 ? void 0 : data.at(0)) === null || _b === void 0 ? void 0 : _b.asks) === null || _c === void 0 ? void 0 : _c.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                var bids = (_e = (_d = data === null || data === void 0 ? void 0 : data.at(0)) === null || _d === void 0 ? void 0 : _d.bids) === null || _e === void 0 ? void 0 : _e.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(OkxSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(OkxSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return OkxSocket;
}(DefaultSocket));

var OurbitSocket = /** @class */ (function (_super) {
    __extends(OurbitSocket, _super);
    function OurbitSocket(options) {
        var futuresUrl = "wss://futures.ourbit.com/edge";
        var spotUrl = "wss://wbs.ourbit.com/ws";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(OurbitSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new OurbitSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(OurbitSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "sub.depth.step",
                "param": {
                    "symbol": this.coin,
                    "limit": 5
                }
            }));
            this.futuresInterval = setInterval(function () { var _a, _b; return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({ "method": "ping" }))); }, 5000);
        }
    });
    Object.defineProperty(OurbitSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "SUBSCRIPTION",
                "params": ["spot@public.limit.depth.v3.api@".concat(this.coin, "@5")]
            }));
            if (!this.spotInterval)
                this.spotInterval = setInterval(function () { var _a, _b; ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({ "method": "PING" }))); }, 5000);
        }
    });
    Object.defineProperty(OurbitSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b, _c, _d;
            var _e = JSON.parse(event.data), channel = _e.channel, data = _e.data;
            if (channel === "push.depth.step") {
                var asks = (_b = (_a = data === null || data === void 0 ? void 0 : data.asks) === null || _a === void 0 ? void 0 : _a.slice(0, 5)) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                var bids = (_d = (_c = data === null || data === void 0 ? void 0 : data.bids) === null || _c === void 0 ? void 0 : _c.slice(0, 5)) === null || _d === void 0 ? void 0 : _d.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(OurbitSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b;
            var _c = JSON.parse(event.data), s = _c.s, d = _c.d;
            if (s) {
                var asks = (_a = d === null || d === void 0 ? void 0 : d.asks) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({ price: item.p, volume: (item.p * item.v).toFixed(2) }); });
                var bids = (_b = d === null || d === void 0 ? void 0 : d.bids) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item.p, volume: (item.p * item.v).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(OurbitSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(OurbitSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return OurbitSocket;
}(DefaultSocket));

var ParadexSocket = /** @class */ (function (_super) {
    __extends(ParadexSocket, _super);
    function ParadexSocket(options) {
        var coin = options.coin;
        var futuresUrl = "https://api.prod.paradex.trade/v1/orderbook/".concat(coin, "?depth=5");
        var spotUrl = "";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl, noFuturesSocket: true, noSpotSocket: true })) || this;
    }
    Object.defineProperty(ParadexSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new ParadexSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(ParadexSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            var _a, _b;
            var mainData = message;
            // @ts-ignore
            var divide = +((_b = (_a = mainData === null || mainData === void 0 ? void 0 : mainData.symbol) === null || _a === void 0 ? void 0 : _a.match(/^\d*/g)) === null || _b === void 0 ? void 0 : _b.at(0)) || 1;
            var asks = mainData.asks.slice(0, 5).map(function (item) { return ({ price: item[0] / divide, volume: (item[1] * item[0]).toFixed(2) }); });
            var bids = mainData.bids.slice(0, 5).map(function (item) { return ({ price: item[0] / divide, volume: (item[1] * item[0]).toFixed(2) }); });
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    return ParadexSocket;
}(DefaultSocket));

var PhemexSocket = /** @class */ (function (_super) {
    __extends(PhemexSocket, _super);
    function PhemexSocket(options) {
        var _this = this;
        var futuresUrl = "wss://ws.phemex.com";
        var spotUrl = "wss://ws.phemex.com";
        _this = _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
        Object.defineProperty(_this, "bigNumber", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: Math.pow(10, 8)
        });
        Object.defineProperty(_this, "orderbook", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { asks: [], bids: [] }
        });
        Object.defineProperty(_this, "spotOrderbook", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { asks: [], bids: [] }
        });
        Object.defineProperty(_this, "convertSpotSide", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (sideObj, sortDir) {
                return Object.entries(sideObj)
                    .map(function (_a) {
                    var price = _a[0], volume = _a[1];
                    return ({
                        price: +price / _this.bigNumber,
                        //@ts-ignore
                        volume: (+volume / _this.bigNumber / _this.contractSize).toFixed(2)
                    });
                })
                    .sort(function (a, b) { return sortDir === 'asc'
                    ? a.price - b.price
                    : b.price - a.price; });
            }
        });
        return _this;
    }
    Object.defineProperty(PhemexSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "id": 1,
                "method": "orderbook_p.subscribe",
                "params": [
                    this.coin,
                    false,
                    5
                ]
            }));
            // console.log('phemex opened', this.futuresInterval, this.ws?.readyState, +new Date())
            this.futuresInterval = setInterval(function () {
                var _a, _b;
                ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({
                    "id": 1,
                    "method": "server.ping",
                    "params": []
                })));
            }, 1500);
        }
    });
    Object.defineProperty(PhemexSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "id": 2,
                "method": "orderbook.subscribe",
                "params": [
                    this.coin,
                    false,
                    5
                ]
            }));
            this.spotInterval = setInterval(function () {
                var _a, _b;
                return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify({
                    "id": 2,
                    "method": "server.ping",
                    "params": []
                })));
            }, 1500);
        }
    });
    Object.defineProperty(PhemexSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { clearInterval(this.futuresInterval); }
    });
    Object.defineProperty(PhemexSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { clearInterval(this.spotInterval); }
    });
    Object.defineProperty(PhemexSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new PhemexSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(PhemexSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b, _c, _d;
            var message = JSON.parse(event.data);
            if ((message === null || message === void 0 ? void 0 : message.type) === 'snapshot') {
                this.orderbook.asks = message.orderbook_p.asks.reduce(function (acc, item) {
                    //@ts-ignore
                    acc[item.at(0)] = (item.at(1) * item.at(0)).toFixed(2);
                    return acc;
                }, {});
                this.orderbook.bids = message.orderbook_p.bids.reduce(function (acc, item) {
                    //@ts-ignore
                    acc[item.at(0)] = (item.at(1) * item.at(0)).toFixed(2);
                    return acc;
                }, {});
            }
            else if ((message === null || message === void 0 ? void 0 : message.type) === 'incremental') {
                for (var _i = 0, _e = message.orderbook_p.asks; _i < _e.length; _i++) {
                    var item = _e[_i];
                    //@ts-ignore
                    if (!+(item === null || item === void 0 ? void 0 : item.at(1)))
                        delete this.orderbook.asks[item.at(0)];
                    //@ts-ignore
                    else
                        this.orderbook.asks[item.at(0)] = (item.at(1) * item.at(0)).toFixed(2);
                }
                for (var _f = 0, _g = message.orderbook_p.bids; _f < _g.length; _f++) {
                    var item = _g[_f];
                    //@ts-ignore
                    if (!+(item === null || item === void 0 ? void 0 : item.at(1)))
                        delete this.orderbook.bids[item.at(0)];
                    //@ts-ignore
                    else
                        this.orderbook.bids[item.at(0)] = (item.at(1) * item.at(0)).toFixed(2);
                }
            }
            else {
                return;
            }
            var asks = this.convertSide(this.orderbook.asks, 'asc').slice(0, 5);
            var bids = this.convertSide(this.orderbook.bids, 'desc').slice(0, 5);
            //@ts-ignore
            if (((_a = bids.at(0)) === null || _a === void 0 ? void 0 : _a.price) && ((_b = asks.at(0)) === null || _b === void 0 ? void 0 : _b.price) && ((_c = asks.at(0)) === null || _c === void 0 ? void 0 : _c.price) < ((_d = bids.at(0)) === null || _d === void 0 ? void 0 : _d.price)) {
                return this.close();
            }
            //@ts-ignore
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    Object.defineProperty(PhemexSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b, _c, _d;
            var message = JSON.parse(event.data);
            if ((message === null || message === void 0 ? void 0 : message.type) === 'snapshot') {
                this.spotOrderbook.asks = message.book.asks.reduce(function (acc, item) {
                    //@ts-ignore
                    acc[item.at(0)] = (item.at(1) * item.at(0)).toFixed(2);
                    return acc;
                }, {});
                this.spotOrderbook.bids = message.book.bids.reduce(function (acc, item) {
                    //@ts-ignore
                    acc[item.at(0)] = (item.at(1) * item.at(0)).toFixed(2);
                    return acc;
                }, {});
            }
            else if ((message === null || message === void 0 ? void 0 : message.type) === 'incremental') {
                for (var _i = 0, _e = message.book.asks; _i < _e.length; _i++) {
                    var item = _e[_i];
                    //@ts-ignore
                    if (!+(item === null || item === void 0 ? void 0 : item.at(1)))
                        delete this.spotOrderbook.asks[item.at(0)];
                    //@ts-ignore
                    else
                        this.spotOrderbook.asks[item.at(0)] = (item.at(1) * item.at(0)).toFixed(2);
                }
                for (var _f = 0, _g = message.book.bids; _f < _g.length; _f++) {
                    var item = _g[_f];
                    //@ts-ignore
                    if (!+(item === null || item === void 0 ? void 0 : item.at(1)))
                        delete this.spotOrderbook.bids[item.at(0)];
                    //@ts-ignore
                    else
                        this.spotOrderbook.bids[item.at(0)] = (item.at(1) * item.at(0)).toFixed(2);
                }
            }
            else {
                return;
            }
            var asks = this.convertSpotSide(this.spotOrderbook.asks, 'asc').slice(0, 5);
            var bids = this.convertSpotSide(this.spotOrderbook.bids, 'desc').slice(0, 5);
            //@ts-ignore
            if (((_a = bids.at(0)) === null || _a === void 0 ? void 0 : _a.price) && ((_b = asks.at(0)) === null || _b === void 0 ? void 0 : _b.price) && ((_c = asks.at(0)) === null || _c === void 0 ? void 0 : _c.price) < ((_d = bids.at(0)) === null || _d === void 0 ? void 0 : _d.price)) {
                return this.close();
            }
            //@ts-ignore
            this.onOrderbook({ asks: asks, bids: bids });
        }
    });
    return PhemexSocket;
}(DefaultSocket));

var depth = 5;
var XtSocket = /** @class */ (function (_super) {
    __extends(XtSocket, _super);
    function XtSocket(options) {
        var futuresUrl = "wss://fstream.xt.com/ws/market";
        var spotUrl = "wss://stream.xt.com/public";
        return _super.call(this, __assign(__assign({}, options), { futuresUrl: futuresUrl, spotUrl: spotUrl })) || this;
    }
    Object.defineProperty(XtSocket, "factory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, new XtSocket(options)];
                });
            });
        }
    });
    Object.defineProperty(XtSocket.prototype, "onFuturesOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "subscribe",
                "params": ["depth@".concat(this.coin, ",").concat(depth)],
                "id": v4()
            }));
            this.futuresInterval = setInterval(function () { var _a, _b; return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send('ping')); }, 10000);
        }
    });
    Object.defineProperty(XtSocket.prototype, "onSpotOpen", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            (_a = this.ws) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify({
                "method": "subscribe",
                "params": ["depth@".concat(this.coin, ",").concat(depth)],
                "id": v4()
            }));
            if (!this.spotInterval)
                this.spotInterval = setInterval(function () { var _a, _b; return ((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 && ((_b = _this.ws) === null || _b === void 0 ? void 0 : _b.send('ping')); }, 10000);
        }
    });
    Object.defineProperty(XtSocket.prototype, "onFutures", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _this = this;
            var _a, _b;
            if (event.data === 'pong') {
                return;
            }
            var _c = JSON.parse(event.data), topic = _c.topic, data = _c.data;
            if (topic === "depth") {
                var asks = (_a = data === null || data === void 0 ? void 0 : data.a) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                var bids = (_b = data === null || data === void 0 ? void 0 : data.b) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item[0] / _this.divide, volume: (item[1] * item[0] * _this.contractSize).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(XtSocket.prototype, "onSpot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a, _b;
            if (event.data === 'pong') {
                return;
            }
            var _c = JSON.parse(event.data), topic = _c.topic, data = _c.data;
            if (topic === "depth") {
                var asks = (_a = data === null || data === void 0 ? void 0 : data.a) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                var bids = (_b = data === null || data === void 0 ? void 0 : data.b) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({ price: item[0], volume: (item[1] * item[0]).toFixed(2) }); });
                this.onOrderbook({ asks: asks, bids: bids });
            }
        }
    });
    Object.defineProperty(XtSocket.prototype, "onFuturesClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.futuresInterval);
        }
    });
    Object.defineProperty(XtSocket.prototype, "onSpotClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            clearInterval(this.spotInterval);
        }
    });
    return XtSocket;
}(DefaultSocket));

var socketFactoriesMap = {
    "binance": BinanceSocket.factory,
    "bingx": BingxSocket.factory,
    "bitget": BitgetSocket.factory,
    "bitmart": BitmartSocket.factory,
    "bitmex": BitmexSocket.factory,
    "bybit": BybitSocket.factory,
    "coinex": CoinexSocket.factory,
    "gateio": GateioSocket.factory,
    "huobi": HuobiSocket.factory,
    "hyper": HyperLiquidSocket.factory,
    "kucoin": KucoinSocket.factory,
    // "lbank": LbankSocket.factory, // not work
    "mexc": MexcSocket.factory,
    "okx": OkxSocket.factory,
    'xt': XtSocket.factory,
    'ourbit': OurbitSocket.factory,
    'blofin': BlofinSocket.factory,
    'paradex': ParadexSocket.factory,
    'aster': AsterSocket.factory,
    'lighter': LighterSocket.factory,
    'apex': ApexSocket.factory,
    'phemex': PhemexSocket.factory
};
function createSocketConnection(options) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var long, short, longCoin, shortCoin, type, onLongOrderbook, onShortOrderbook, longContractSize, shortContractSize, coin, createLongSocket, createShortSocket, divideLong, divideShort, _c, longType, shortType, longSocket, shortSocket;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    long = options.long, short = options.short, longCoin = options.longCoin, shortCoin = options.shortCoin, type = options.type, onLongOrderbook = options.onLongOrderbook, onShortOrderbook = options.onShortOrderbook, longContractSize = options.longContractSize, shortContractSize = options.shortContractSize, coin = options.coin;
                    createLongSocket = socketFactoriesMap[long || ''];
                    createShortSocket = socketFactoriesMap[short || ''];
                    divideLong = (long !== 'bitmart') ? (+((_a = longCoin === null || longCoin === void 0 ? void 0 : longCoin.match(/^10+/g)) === null || _a === void 0 ? void 0 : _a.at(0)) || 1) : 1;
                    divideShort = (short !== 'bitmart') ? (+((_b = shortCoin === null || shortCoin === void 0 ? void 0 : shortCoin.match(/^10+/g)) === null || _b === void 0 ? void 0 : _b.at(0)) || 1) : 1;
                    _c = getTypes(type), longType = _c.longType, shortType = _c.shortType;
                    return [4 /*yield*/, (createLongSocket === null || createLongSocket === void 0 ? void 0 : createLongSocket({ type: longType, coin: longCoin, backendCoin: coin, onOrderbook: onLongOrderbook, divide: divideLong, contractSize: longContractSize }))];
                case 1:
                    longSocket = _d.sent();
                    return [4 /*yield*/, (createShortSocket === null || createShortSocket === void 0 ? void 0 : createShortSocket({ type: shortType, coin: shortCoin, backendCoin: coin, onOrderbook: onShortOrderbook, divide: divideShort, contractSize: shortContractSize }))];
                case 2:
                    shortSocket = _d.sent();
                    return [2 /*return*/, {
                            close: function () {
                                longSocket === null || longSocket === void 0 ? void 0 : longSocket.close();
                                shortSocket === null || shortSocket === void 0 ? void 0 : shortSocket.close();
                            },
                            hasBadConnection: {
                                checkLong: longSocket ? (function () { return longSocket.hasBadConnection(); }) : (function () { return false; }),
                                checkShort: shortSocket ? (function () { return shortSocket.hasBadConnection(); }) : (function () { return false; }),
                            },
                            hasTradfi: {
                                checkLong: longSocket ? (function () { return longSocket.tradfi(); }) : (function () { return false; }),
                                checkShort: shortSocket ? (function () { return shortSocket.tradfi(); }) : (function () { return false; }),
                            }
                        }];
            }
        });
    });
}
function getTypes(type) {
    var longType = "futures";
    var shortType = "futures";
    if (type === "spot") {
        longType = "spot";
    }
    if (type === 'margin') {
        shortType = "spot";
    }
    return { longType: longType, shortType: shortType };
}

function getFuturesMarketCoins() {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, response, marketsMap;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/market-coins/futures"))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    marketsMap = _a.sent();
                    return [2 /*return*/, marketsMap];
            }
        });
    });
}
function getSpotMarketCoins() {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, response, markstesMap;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/market-coins/spot"))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    markstesMap = _a.sent();
                    return [2 /*return*/, markstesMap];
            }
        });
    });
}
function getContractSizes() {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, response, contractsMap;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/contract-sizes"))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    contractsMap = _a.sent();
                    return [2 /*return*/, contractsMap];
            }
        });
    });
}
function getBitmexSpotContractSize(coin) {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, response, contractSize;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/bitmex/contract-size/spot/").concat(coin))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    contractSize = _a.sent();
                    return [2 /*return*/, contractSize];
            }
        });
    });
}
function getPhemexSpotContractSize(coin) {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, response, contractSize;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/phemex/contract-size/spot/").concat(coin))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    contractSize = _a.sent();
                    return [2 /*return*/, contractSize];
            }
        });
    });
}
function getLighterDivides(coin) {
    return __awaiter(this, void 0, void 0, function () {
        var baseUrl, response, contractSize;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userStore.getBaseUrl()];
                case 1:
                    baseUrl = _a.sent();
                    return [4 /*yield*/, fetch("".concat(baseUrl, "/lighter/divides/").concat(coin))];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    contractSize = _a.sent();
                    return [2 /*return*/, contractSize];
            }
        });
    });
}

function useGetCoinForMarket(type, market, backendCoin) {
    var _this = this;
    var marketsKoinsMap = useQuery({
        queryKey: ['MarketsCoinsMap', type],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(type === "spot")) return [3 /*break*/, 2];
                        return [4 /*yield*/, getSpotMarketCoins()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, getFuturesMarketCoins()];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        }); }
    }).data;
    var coin = useMemo(function () {
        var _a;
        if (!market) {
            return undefined;
        }
        var coins = marketsKoinsMap === null || marketsKoinsMap === void 0 ? void 0 : marketsKoinsMap[market];
        return (_a = coins === null || coins === void 0 ? void 0 : coins.find(function (_a) {
            var a = _a[0]; _a[1];
            return a === backendCoin;
        })) === null || _a === void 0 ? void 0 : _a[1];
    }, [market, backendCoin, marketsKoinsMap]);
    return coin;
}

function useGetContractSize(type, market, backendCoin) {
    var _this = this;
    var contractsMap = useQuery({
        queryKey: ['ContractSizesMap'],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getContractSizes()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); }
    }).data;
    var contractSize = useMemo(function () {
        if (!market) {
            return 0;
        }
        var contracts = contractsMap === null || contractsMap === void 0 ? void 0 : contractsMap[market];
        return +(contracts === null || contracts === void 0 ? void 0 : contracts[backendCoin]) || 0; //parseInt(contracts?.[backendCoin], 10)
    }, [market, backendCoin, contractsMap]);
    var bitmexSpotContractSize = useQuery({
        queryKey: ['BitmexContractSize', type, backendCoin, market],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var contract_size;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(type === "spot" && market === "bitmex")) return [3 /*break*/, 2];
                        return [4 /*yield*/, getBitmexSpotContractSize(backendCoin)];
                    case 1:
                        contract_size = (_a.sent()).contract_size;
                        return [2 /*return*/, parseInt(contract_size, 10)];
                    case 2: return [2 /*return*/, 1];
                }
            });
        }); }
    }).data;
    var phemexSpotContractSize = useQuery({
        queryKey: ['PhemexContractSize', type, backendCoin, market],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var contract_size;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(type === "spot" && market === "phemex")) return [3 /*break*/, 2];
                        return [4 /*yield*/, getPhemexSpotContractSize(backendCoin)];
                    case 1:
                        contract_size = (_a.sent()).contract_size;
                        return [2 /*return*/, contract_size];
                    case 2: return [2 /*return*/, 1];
                }
            });
        }); }
    }).data;
    var lighterDivides = useQuery({
        queryKey: ['LighterDivides', type, backendCoin, market],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var divide;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(market === "lighter")) return [3 /*break*/, 2];
                        return [4 /*yield*/, getLighterDivides(backendCoin)];
                    case 1:
                        divide = (_a.sent()).divide;
                        return [2 /*return*/, divide];
                    case 2: return [2 /*return*/, 1];
                }
            });
        }); }
    }).data;
    if (type === "spot" && market === "bitmex") {
        return bitmexSpotContractSize || 1;
    }
    if (type === "spot" && market === "phemex") {
        return phemexSpotContractSize || 1;
    }
    if (market === 'lighter') {
        return lighterDivides || 1;
    }
    if (contractsMap && !contractSize) {
        return 1;
    }
    return contractSize;
}

var Graph = observer(function (_a) {
    var _b, _c, _d, _e;
    var type = _a.type, coin = _a.coin, long = _a.long, short = _a.short, chain = _a.chain, isVisible = _a.isVisible, UpperInfo = _a.UpperInfo, LowerInfo = _a.LowerInfo, Orders = _a.Orders;
    var _f = useState(), statistics = _f[0], setStatistics = _f[1];
    var _g = useState(chartStore.timeFrames[0]), timeFrame = _g[0], setTimeFrame = _g[1];
    var _h = useState(false), waitingToReconnect = _h[0], setWaitingToReconnect = _h[1];
    var lastMessage = useRef(+new Date());
    var clientRef = useRef(null);
    var reconnectInterval = useRef(null);
    var _j = getTypes(type), longType = _j.longType, shortType = _j.shortType;
    var longCoin = useGetCoinForMarket(longType, long, coin);
    var shortCoin = useGetCoinForMarket(shortType, short, coin);
    var longContractSize = useGetContractSize(longType, long, coin);
    var shortContractSize = useGetContractSize(shortType, short, coin);
    var closeSockets = useRef();
    var hasConnectionErrors = useRef({
        checkShort: function () { return true; },
        checkLong: function () { return true; },
    });
    var hasTradfiRef = useRef({
        checkLong: function () { return false; },
        checkShort: function () { return false; }
    });
    useEffect(function () {
        var connectionInterval = setInterval(function () {
            var longHasErrors = hasConnectionErrors.current.checkLong();
            var shortHasErrors = hasConnectionErrors.current.checkShort();
            if (long) {
                chartStore.hasConnectionError[long] = longHasErrors;
            }
            if (short) {
                chartStore.hasConnectionError[short] = shortHasErrors;
            }
            if (localStorage.getItem(BAD_CONN_NOTIFICATIONS_KEY) === "true") {
                if (longHasErrors) {
                    toast(function () { return jsxs("p", { children: [jsx("span", __assign({ style: { color: 'red' } }, { children: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438" })), " \u043A \u0431\u0438\u0440\u0436\u0435 ", jsx("b", { children: long }), ". \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0432\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F VPN/proxy \u0438\u043B\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F \u043A \u0434\u0440\u0443\u0433\u043E\u043C\u0443 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0443."] }); });
                }
                if (shortHasErrors) {
                    toast(function () { return jsxs("p", { children: [jsx("span", __assign({ style: { color: 'red' } }, { children: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438" })), " \u043A \u0431\u0438\u0440\u0436\u0435 ", jsx("b", { children: short }), ". \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0432\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F VPN/proxy \u0438\u043B\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F \u043A \u0434\u0440\u0443\u0433\u043E\u043C\u0443 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0443."] }); });
                }
            }
        }, 5e3);
        return function () {
            clearInterval(connectionInterval);
        };
    }, [hasConnectionErrors]);
    var _k = useState(''), socketBaseUrl = _k[0], setSocketBaseUrl = _k[1];
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = setSocketBaseUrl;
                        return [4 /*yield*/, userStore.getSocketBaseUrl()];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    var noSocketExchanges = ['lbank', 'bybitTf', 'gateioTf', 'bitgetTf'];
    useEffect(function () {
        if (waitingToReconnect)
            return;
        if (socketBaseUrl && !clientRef.current && (long ? (longCoin && longContractSize) : true) && (short ? (shortCoin && shortContractSize) : true)) {
            createSocketConnection({
                type: type,
                long: long,
                short: short,
                longCoin: longCoin,
                shortCoin: shortCoin,
                shortContractSize: shortContractSize,
                longContractSize: longContractSize,
                coin: coin,
                onLongOrderbook: function (_a) {
                    var asks = _a.asks, bids = _a.bids;
                    if (!long) {
                        return;
                    }
                    setStatistics(function (prev) {
                        var _a, _b, _c, _d;
                        if (!prev) {
                            return undefined;
                        }
                        if ('long' in prev) {
                            return __assign(__assign({}, prev), { long: __assign(__assign({}, prev.long), { orderbook: { asks: asks || ((_a = prev.long.orderbook) === null || _a === void 0 ? void 0 : _a.asks) || [], bids: bids || ((_b = prev.long.orderbook) === null || _b === void 0 ? void 0 : _b.bids) || [] } }) });
                        }
                        if ('orderbook' in prev) {
                            return __assign(__assign({}, prev), { orderbook: { asks: asks || ((_c = prev.orderbook) === null || _c === void 0 ? void 0 : _c.asks) || [], bids: bids || ((_d = prev.orderbook) === null || _d === void 0 ? void 0 : _d.bids) || [] } });
                        }
                    });
                },
                onShortOrderbook: function (_a) {
                    var asks = _a.asks, bids = _a.bids;
                    if (!short) {
                        return;
                    }
                    setStatistics(function (prev) {
                        var _a, _b, _c, _d;
                        if (!prev) {
                            return undefined;
                        }
                        if ('short' in prev) {
                            return __assign(__assign({}, prev), { short: __assign(__assign({}, prev.short), { orderbook: { asks: asks || ((_a = prev.short.orderbook) === null || _a === void 0 ? void 0 : _a.asks) || [], bids: bids || ((_b = prev.short.orderbook) === null || _b === void 0 ? void 0 : _b.bids) || [] } }) });
                        }
                        if ('orderbook' in prev) {
                            return __assign(__assign({}, prev), { orderbook: { asks: asks || ((_c = prev.orderbook) === null || _c === void 0 ? void 0 : _c.asks) || [], bids: bids || ((_d = prev.orderbook) === null || _d === void 0 ? void 0 : _d.bids) || [] } });
                        }
                    });
                },
            }).then(function (_a) {
                var close = _a.close, hasBadConnection = _a.hasBadConnection, hasTradfi = _a.hasTradfi;
                closeSockets.current = close;
                hasConnectionErrors.current = {
                    checkLong: hasBadConnection.checkLong,
                    checkShort: hasBadConnection.checkShort
                };
                hasTradfiRef.current = hasTradfi;
            });
            var socketType_1 = '';
            if (long && short) {
                socketType_1 = type;
            }
            if (!long) {
                socketType_1 = "short";
            }
            if (!short) {
                socketType_1 = "long";
            }
            var exchange_1 = '';
            if (long && short) {
                exchange_1 = type == 'margin' ? short : long;
            }
            else {
                exchange_1 = long || short || '';
            }
            var exchange2_1 = '';
            if (long && short) {
                exchange2_1 = type == 'margin' ? long : short;
            }
            else {
                exchange2_1 = chain || '';
            }
            var createSocket_1 = function () {
                var socket = new WebSocket("".concat(socketBaseUrl, "/threads/").concat(socketType_1, "@").concat(coin, "@").concat(exchange_1, "@").concat(exchange2_1, "?token=").concat(userStore.authToken));
                clientRef.current = socket;
                socket.onerror = function (e) { return console.error(e); };
                socket.onopen = function () {
                    lastMessage.current = +new Date();
                    socket.send('ping');
                };
                socket.onclose = function () {
                    if (!clientRef.current)
                        return;
                    if (waitingToReconnect)
                        return;
                    setWaitingToReconnect(true);
                    setTimeout(function () { return setWaitingToReconnect(false); }, 10000);
                };
                socket.addEventListener('message', function (msg) {
                    var _a, _b;
                    lastMessage.current = Math.max(lastMessage.current, +new Date());
                    if (msg.data === "ping") {
                        socket.send("ping");
                    }
                    else if (typeof (msg === null || msg === void 0 ? void 0 : msg.data) === "string") {
                        var data_1 = JSON.parse(msg === null || msg === void 0 ? void 0 : msg.data);
                        if ('long' in data_1) {
                            data_1.long.name = exchangesStore.getNameByMarket(long);
                            data_1.short.name = exchangesStore.getNameByMarket(short);
                        }
                        else {
                            data_1.name = long ? exchangesStore.getNameByMarket(long) : exchangesStore.getNameByMarket(short);
                        }
                        if ('orderbook' in data_1) {
                            data_1.orderbook = {
                                //@ts-ignore
                                asks: (_a = data_1.orderbook) === null || _a === void 0 ? void 0 : _a.ask,
                                //@ts-ignore
                                bids: (_b = data_1.orderbook) === null || _b === void 0 ? void 0 : _b.bid
                            };
                            data_1.longShort = long ? "long" : "short";
                        }
                        setStatistics(function (prev) {
                            if (long && !noSocketExchanges.includes(long) && !hasConnectionErrors.current.checkLong()) {
                                if ('long' in data_1 && prev && 'long' in prev) {
                                    data_1.long.orderbook = prev === null || prev === void 0 ? void 0 : prev.long.orderbook;
                                }
                                else if ('orderbook' in data_1 && prev && 'orderbook' in prev) {
                                    data_1.orderbook = prev.orderbook;
                                }
                            }
                            if (short && !noSocketExchanges.includes(short) && !hasConnectionErrors.current.checkShort()) {
                                if ('short' in data_1 && prev && 'short' in prev) {
                                    data_1.short.orderbook = prev === null || prev === void 0 ? void 0 : prev.short.orderbook;
                                }
                                else if ('orderbook' in data_1 && prev && 'orderbook' in prev) {
                                    data_1.orderbook = prev.orderbook;
                                }
                            }
                            return data_1;
                        });
                    }
                });
                return socket;
            };
            var socket_1 = createSocket_1();
            reconnectInterval.current = setInterval(function () {
                if (lastMessage && +new Date() - lastMessage.current > 15e3) {
                    console.log('creating new socket: ', new Date(), +new Date() - lastMessage.current);
                    clientRef.current = null;
                    socket_1 === null || socket_1 === void 0 ? void 0 : socket_1.close();
                    socket_1 = createSocket_1();
                }
            }, 1e3);
            return (function () {
                var _a;
                clientRef.current = null;
                socket_1.close();
                (_a = closeSockets.current) === null || _a === void 0 ? void 0 : _a.call(closeSockets);
                clearInterval(reconnectInterval.current || 0);
            });
        }
    }, [waitingToReconnect, longCoin, shortCoin, shortContractSize, longContractSize, socketBaseUrl]);
    var timeframeRef = useRef(null);
    return (jsxs(GraphStyled, { children: [jsxs(GraphContainer, __assign({ style: { display: mobileStore.isChartVisible() ? "initial" : "none" } }, { children: [jsx("div", __assign({ style: { position: 'absolute', top: 0, left: 0, zIndex: 10 } }, { children: jsxs(TimeFrameStyled, __assign({ style: { backgroundColor: themeStore.bgColor }, ref: timeframeRef }, { children: [jsx("h3", __assign({ className: 'rs', style: { color: themeStore.textColor } }, { children: coin })), jsx(Dropdown$1, { value: timeFrame.title, setValue: function (title) {
                                        setTimeFrame(chartStore.timeFrames.find(function (tf) { return tf.title === title; }) || chartStore.timeFrames[0]);
                                    }, options: chartStore.timeFrames.map(function (tf) { return tf.title; }), className: 'timeframe-dropdown' })] })) })), jsx(Chart, { type: type, coin: coin, long: long, short: short, statistics: statistics, timeFrame: timeFrame.value, chain: chain }), Orders && jsx(Orders, { type: type, long: long, short: short, statistics: statistics, coin: coin, width: ((_c = (_b = timeframeRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth) !== null && _c !== void 0 ? _c : 100) - 100, top: ((_e = (_d = timeframeRef.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect().bottom) !== null && _e !== void 0 ? _e : 0) })] })), jsxs(InfoContainer, __assign({ style: { display: mobileStore.isInfoVisible() ? "flex" : "none" } }, { children: [jsx(UpperInfo, { type: type, statistics: statistics, coin: coin, isVisible: isVisible }), jsx(LowerInfo, { statistics: statistics })] })), createPortal(jsx(ToastContainer, { position: "bottom-left", autoClose: 5e3, hideProgressBar: true, theme: themeStore.theme }), document.getElementById("root"))] }));
});

var WindowWrapStyled = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n    position: relative;\n    height: calc(100vh - ", ");\n    width: 100%;\n    overflow-y: auto;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .close {\n        position: absolute;\n        top: 16px;\n        right: 16px;\n        z-index: 10;\n        height: 32px;\n        width: 32px;\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n\n    .swap-mode-btn {\n        position: absolute;\n        right: 16px;\n        top: 64px;\n        z-index: 10;\n        height: 32px;\n        width: 32px;\n        background-color: ", ";\n        border-radius: 100%;\n        color: white !important;\n\n        display: none\n    }\n\n    @media(max-width: calc(2*", ")) {\n      min-width: auto!important;\n\n      .close {\n        background-color: ", ";\n        border-radius: 100%;\n        color: white !important;\n      }\n\n      .swap-mode-btn {\n        display: initial;\n\n        &:hover {\n          cursor: pointer;\n        }\n      }\n    }\n"], ["\n    position: relative;\n    height: calc(100vh - ", ");\n    width: 100%;\n    overflow-y: auto;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .close {\n        position: absolute;\n        top: 16px;\n        right: 16px;\n        z-index: 10;\n        height: 32px;\n        width: 32px;\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n\n    .swap-mode-btn {\n        position: absolute;\n        right: 16px;\n        top: 64px;\n        z-index: 10;\n        height: 32px;\n        width: 32px;\n        background-color: ", ";\n        border-radius: 100%;\n        color: white !important;\n\n        display: none\n    }\n\n    @media(max-width: calc(2*", ")) {\n      min-width: auto!important;\n\n      .close {\n        background-color: ", ";\n        border-radius: 100%;\n        color: white !important;\n      }\n\n      .swap-mode-btn {\n        display: initial;\n\n        &:hover {\n          cursor: pointer;\n        }\n      }\n    }\n"])), HEADER_HEIGHT, BLUE, MIN_INFO_WIDTH, BLUE);
var templateObject_1$1;

var WindowWrap = observer(function (_a) {
    var children = _a.children, index = _a.index, visibleIndex = _a.visibleIndex, onClose = _a.onClose;
    var wrap = useRef(null);
    useEffect(function () {
        if (index === visibleIndex) {
            //@ts-ignore
            wrap.current.scrollIntoView();
        }
    }, [visibleIndex]);
    useResize(function () {
        if (index === visibleIndex) {
            //@ts-ignore
            wrap.current.scrollIntoView();
        }
    }, [index, visibleIndex]);
    return (jsx(Fragment, { children: jsxs(WindowWrapStyled, __assign({ style: {
                minWidth: onClose ? "calc(2*".concat(MIN_INFO_WIDTH, ")") : 'none',
            }, ref: wrap }, { children: [onClose &&
                    jsx(CloseIcon, { className: "close", style: { color: themeStore.textColor }, onClick: function () { onClose(); } }), onClose &&
                    jsx(SwapHorizIcon, { className: "swap-mode-btn", style: { color: themeStore.textColor }, onClick: function () { return mobileStore.changeChartMode(); } }), children] })) }));
});

var NotFoundPage = observer(function () {
    return (jsx(WindowWrap, { children: jsx("h1", __assign({ style: { color: themeStore.textColor, fontSize: '4em' } }, { children: "Page Not Found" })) }));
});

var ScrollWrapStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-right: ", ";\n"], ["\n    padding-right: ", ";\n"])), SCROLL_WIDTH);
var ScrollStyled = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: fixed;\n    right: 0;\n    top: ", ";\n    width: ", ";\n    height: calc(100vh - ", ");\n    z-index: 10;\n\n    display: flex;\n    flex-direction: column;\n"], ["\n    position: fixed;\n    right: 0;\n    top: ", ";\n    width: ", ";\n    height: calc(100vh - ", ");\n    z-index: 10;\n\n    display: flex;\n    flex-direction: column;\n"])), HEADER_HEIGHT, SCROLL_WIDTH, HEADER_HEIGHT);
var ScrollBar = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    h3 {\n        transform: rotate(-90deg);\n        white-space: nowrap;\n\n        @media(max-height: 750px) {\n            font-size: 0.8em;\n        }\n    }\n\n    &:hover {\n        cursor: pointer;\n    }\n"], ["\n    position: relative;\n    width: 100%;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    h3 {\n        transform: rotate(-90deg);\n        white-space: nowrap;\n\n        @media(max-height: 750px) {\n            font-size: 0.8em;\n        }\n    }\n\n    &:hover {\n        cursor: pointer;\n    }\n"])));
var StatisticsPageStyled = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: relative;\n    margin-top: ", ";\n\n    max-height: calc(100vh - ", ");\n    overflow-y: hidden;\n"], ["\n    position: relative;\n    margin-top: ", ";\n\n    max-height: calc(100vh - ", ");\n    overflow-y: hidden;\n"])), HEADER_HEIGHT, HEADER_HEIGHT);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

var StatisticsPage = observer(function (props) {
    var PlotGraphMenu = props.PlotGraphMenu, UpperInfo = props.UpperInfo, LowerInfo = props.LowerInfo, Orders = props.Orders;
    var _a = useState(0), pagesCount = _a[0], setPagesCount = _a[1];
    var _b = useState(0), visibleIndex = _b[0], setVisibleIndex = _b[1];
    var _c = useState([]), graphs = _c[0], setGraphs = _c[1];
    var onCreate = useCallback(function (_a) {
        var type = _a.type, coin = _a.coin, chain = _a.chain, long = _a.long, short = _a.short;
        if (visibleIndex !== pagesCount) {
            return;
        }
        setPagesCount(pagesCount + 1);
        setGraphs(__spreadArray(__spreadArray([], graphs, true), [{ id: Math.random(), type: type, coin: coin, long: long, chain: chain, short: short, isVisible: true, UpperInfo: UpperInfo, LowerInfo: LowerInfo, Orders: Orders }], false));
    }, [pagesCount, graphs, visibleIndex]);
    return (jsxs(ScrollWrapStyled, { children: [jsx(ScrollStyled, { children: pagesCount > 0 && new Array(Math.min(pagesCount + 1, 5)).fill(0).map(function (val, i) {
                    var _a;
                    return jsx(ScrollBar, __assign({ style: {
                            height: "calc((100vh - ".concat(HEADER_HEIGHT, ")/").concat(Math.min(pagesCount + 1, 5), ")"),
                            backgroundColor: i === visibleIndex ? BLUE : themeStore.bgColor,
                            border: "1px solid ".concat(themeStore.textColor)
                        }, onClick: function () {
                            setVisibleIndex(i);
                        } }, { children: jsx("h3", __assign({ className: "rs", style: { color: i === visibleIndex ? WHITE : themeStore.textColor } }, { children: (((_a = graphs[i]) === null || _a === void 0 ? void 0 : _a.coin.replace("USDT", "")) || '') +
                                (graphs.filter(function (g) { var _a; return g.coin === ((_a = graphs[i]) === null || _a === void 0 ? void 0 : _a.coin); }).length > 1 ? " ".concat(graphs.slice(0, i + 1).filter(function (g) { var _a; return g.coin === ((_a = graphs[i]) === null || _a === void 0 ? void 0 : _a.coin); }).length) : '')
                                || "Добавить" })) }), i);
                }) }), jsxs(StatisticsPageStyled, __assign({ id: "statistics-page" }, { children: [graphs.map(function (graph, i) {
                        return jsx(WindowWrap, __assign({ index: i, visibleIndex: visibleIndex, onClose: function () {
                                setPagesCount(pagesCount - 1);
                                setGraphs(graphs.filter(function (g) { return g.id !== graph.id; }));
                            } }, { children: jsx(Graph, { id: graph.id, isVisible: i === visibleIndex, type: graph.type, coin: graph.coin, long: graph.long, chain: graph.chain, short: graph.short, UpperInfo: UpperInfo, LowerInfo: LowerInfo, Orders: Orders }) }), graph.id);
                    }), jsx(WindowWrap, __assign({ index: pagesCount, visibleIndex: visibleIndex }, { children: jsx(PlotGraphMenu, { onCreate: onCreate, showBtn: (pagesCount < 5) }) }))] })), jsx(AuthForm, { isOpen: !userStore.isAuth })] }));
});

export { AUTH_TOKEN, AuthForm, BAD_CONN_NOTIFICATIONS_KEY, BASE_URL, BLACK, BLUE, Button, Checkbox, DARK_GREY, DARK_GREY2, DARK_RED, Dropdown$1 as Dropdown, GOLD, GREEN, GREY, Graph, HEADER_HEIGHT, Header, LIGHT_BLACK, Loader, Logo, MIN_INFO_WIDTH, Modal, NotFoundPage, RED, REFRESH_TOKEN, SCROLL_WIDTH, SearchSelect, StatisticsPage, StringContainer, TextInput, ThemePicker, Toggle, Tooltip, WHITE, audio, chartStore, exchangesStore, getCloseSpread, getEnterSpread, getFormatedLocalTime, getGeneralTitles, getHeaders, getLongShortTitles, isNewTimeFrame, mobileStore, shortExchanges, showNotification, themeStore, typeOptions, useCheckMobile, useDebounce, useGetCoinForMarket, useGetContractSize, useResize, userStore, wait, wasDisconnected, withRetry };
